/*
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
Table of Contents
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

- Theme View
- Header View
- Currency View
- Navigation View
- Mobile navigation View
- Mega navigation View
- Template View

- Index View
- Slideshow View
- Instagram View
- Collection View
- List Collections View
- Product View
- Image zoom View
- Cart View
- Page View
- The404View
- Blog View
- Password Protect Page View
- GiftCard View

=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
*/

var AccountView, BODY, CartView, CollectionListView, CollectionView, GiftCardView, HeaderView, IndexView, InstagramView, ListCollectionsView, MegaNavigationView, MobileNavigationView, NavigationView, PasswordView, ProductView, QuickShopView, RTEView, SharingWidgetView, SlideshowView, TOUCH, ThemeView, TwitterView, VideoView, WINDOW,
extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
hasProp = {}.hasOwnProperty,
slice = [].slice,
bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

window.ThemeEditor = (function(superClass) {
	extend(ThemeEditor, superClass);

	function ThemeEditor() {
		return ThemeEditor.__super__.constructor.apply(this, arguments);
	}

	ThemeEditor.prototype.initialize = function() {
		this.instanceHandlers = {};
		this.instances = {};
		return $(document).on('shopify:section:load', (function(_this) {
			return function(event) {
				return _this._onSectionLoad(event);
			};
		})(this)).on('shopify:section:unload', (function(_this) {
			return function(event) {
				return _this._onSectionUnload(event);
			};
		})(this)).on('shopify:section:select', (function(_this) {
			return function(event) {
				return _this._onSectionSelect(event);
			};
		})(this)).on('shopify:section:deselect', (function(_this) {
			return function(event) {
				return _this._onSectionDeselect(event);
			};
		})(this)).on('shopify:block:select', (function(_this) {
			return function(event) {
				return _this._onBlockSelect(event);
			};
		})(this)).on('shopify:block:deselect', (function(_this) {
			return function(event) {
				return _this._onBlockDeselect(event);
			};
		})(this));
	};

	ThemeEditor.prototype._findInstance = function(event) {
		var $container, instance;
		instance = this.instances[event.originalEvent.detail.sectionId];
		if (instance != null) {
			return instance;
		} else {
			$container = $('[data-section-id]', event.target);
			return this._createInstance($container);
		}
	};

	ThemeEditor.prototype._createInstance = function($container, instanceHandler) {
		var instance, sectionId, sectionType;
		sectionType = $container.attr('data-section-type');
		sectionId = $container.attr('data-section-id');
		if (sectionType == null) {
			return;
		}
		instanceHandler = instanceHandler || this.instanceHandlers[sectionType];
		instance = {
			instanceHandler: instanceHandler,
			$container: $container,
			sectionId: sectionId
		};
		this.instances[sectionId] = instance;
		return instance;
	};


	/*
	Action: A section has been added or re-rendered.
	Expected: Re-execute any JavaScript needed for the section to work and
	display properly (as if the page had just been loaded).
	*/

	ThemeEditor.prototype._onSectionLoad = function(event) {
		var $container, ref, ref1;
		$container = $('[data-section-id]', event.target);
		if (!$container.length) {
			return;
		}
		return (ref = this._createInstance($container)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionLoad === "function" ? ref1.onSectionLoad(event) : void 0 : void 0 : void 0;
	};


	/*
	Action: A section has been deleted or is being re-rendered.
	Expected: Clean up any event listeners, variables, etc., so that
	nothing breaks when the page is interacted with and no memory leaks occur.
	*/

	ThemeEditor.prototype._onSectionUnload = function(event) {
		var instance, ref;
		instance = this._findInstance(event);
		if (instance != null) {
			if ((ref = instance.instanceHandler) != null) {
				if (typeof ref.onSectionUnload === "function") {
					ref.onSectionUnload(event);
				}
			}
		}
		if (instance) {
			return delete this.instances[instance.sectionId];
		}
	};


	/*
	Action: User has selected the section in the sidebar.
	Expected: Make sure the section is in view and stays
	in view while selected (scrolling happens automatically).
	Example: Could be used to pause a slideshow
	*/

	ThemeEditor.prototype._onSectionSelect = function(event) {
		var ref, ref1;
		return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionSelect === "function" ? ref1.onSectionSelect(event) : void 0 : void 0 : void 0;
	};


	/*
	Action: User has deselected the section in the sidebar.
	Expected: (None)
	Example: Could be used to restart slideshows that are no longer being interacted with.
	*/

	ThemeEditor.prototype._onSectionDeselect = function(event) {
		var ref, ref1;
		return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionDeselect === "function" ? ref1.onSectionDeselect(event) : void 0 : void 0 : void 0;
	};


	/*
	Action: User has selected the block in the sidebar.
	Expected: Make sure the block is in view and stays
	in view while selected (scrolling happens automatically).
	Example: Can be used to to trigger a slideshow to bring a slide/block into view
	*/

	ThemeEditor.prototype._onBlockSelect = function(event) {
		var ref, ref1;
		return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockSelect === "function" ? ref1.onBlockSelect(event) : void 0 : void 0 : void 0;
	};


	/*
	Action: User has deselected the block in the sidebar.
	Expected: (None)
	Example: Resume a slideshow
	*/

	ThemeEditor.prototype._onBlockDeselect = function(event) {
		var ref, ref1;
		return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockDeselect === "function" ? ref1.onBlockDeselect(event) : void 0 : void 0 : void 0;
	};


	/*
	Auto initialisation of a section for the store front
	*/

	ThemeEditor.prototype._sectionInit = function(instance) {
		var ref;
		return instance != null ? (ref = instance.instanceHandler) != null ? typeof ref.init === "function" ? ref.init(instance) : void 0 : void 0 : void 0;
	};


	/*
	Registration of a section
	- Takes a string parameter as the first argument which
	matches to `[data-section-type]`

	* Example
	@sections = new Sections()
	@sections.register('some-section-type', @someSectionClass)
	*/

	ThemeEditor.prototype.register = function(type, instanceHandler) {

		/*
		Storage of a instanceHandler based on the sectionType allows _onSectionLoad
		to connect a new section to it's registered instanceHandler
		*/
		this.instanceHandlers[type] = instanceHandler;
		return $("[data-section-type=" + type + "]").each((function(_this) {
			return function(index, container) {
				var $container;
				$container = $(container);
				return _this._sectionInit(_this._createInstance($container, instanceHandler));
			};
		})(this));
	};


	/*
	Public method to retrieve information on an instance based on the
	bubbled `event`
	*/

	ThemeEditor.prototype.getInstance = function(event) {
		return this._findInstance(event);
	};

	return ThemeEditor;

})(Backbone.View);

window.ThemeUtils = {
	extend: function() {
		var dest, j, k, len, obj, objs, v;
		dest = arguments[0], objs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
		for (j = 0, len = objs.length; j < len; j++) {
			obj = objs[j];
			for (k in obj) {
				v = obj[k];
				dest[k] = v;
			}
		}
		return dest;
	},
	windowWidth: function() {
		return window.innerWidth || this.window.width();
	},
	debounce: function(func, wait, immediate) {
		var timeout;
		timeout = null;
		return function() {
			var args, callNow, context, later;
			context = this;
			args = arguments;
			later = function() {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	},
	inViewport: function(el) {
		var bounds, rect;
		if (typeof jQuery === "function" && el instanceof jQuery) {
			el = el[0];
		}
		rect = el.getBoundingClientRect();
		bounds = {
			top: rect.top >= 0,
			bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
		};
		return bounds.top && bounds.bottom;
	},
	unique: function(array) {
		var j, key, output, ref, results, value;
		output = {};
		for (key = j = 0, ref = array.length; 0 <= ref ? j < ref : j > ref; key = 0 <= ref ? ++j : --j) {
			output[array[key]] = array[key];
		}
		results = [];
		for (key in output) {
			value = output[key];
			results.push(value);
		}
		return results;
	}
};

window.LinkedOptions = (function() {
	function LinkedOptions(options) {
		this.options = options;
		this.optionsMap = [];
		this._init();
	}

	LinkedOptions.prototype._init = function() {
		return this._mapVariants(this.options.productJSON);
	};

	LinkedOptions.prototype._getCurrent = function(optionIndex) {
		var key, option1, option2, selector;
		if (this.options.type === 'select') {
			switch (optionIndex) {
				case 0:
				key = 'root';
				selector = this.options.$selector.eq(0);
				break;
				case 1:
				key = this.options.$selector.eq(0).val();
				selector = this.options.$selector.eq(1);
				break;
				case 2:
				key = (this.options.$selector.eq(0).val()) + " / " + (this.options.$selector.eq(1).val());
				selector = this.options.$selector.eq(2);
			}
		}
		if (this.options.type === 'radio') {
			switch (optionIndex) {
				case 0:
				key = 'root';
				selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
				break;
				case 1:
				key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
				selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
				break;
				case 2:
				option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
				option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
				key = option1 + " / " + option2;
				selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
			}
		}
		return {
			key: key,
			selector: selector
		};
	};

	LinkedOptions.prototype._updateOptions = function(optionIndex, optionsMap, emptyOption, emptyOptionIndex) {

		logger('_updateOptions');

		var $available, $option, $selector, $selectorOptions, availableOptions, initialValue, j, key, l, len, len1, option, ref, selector;
		ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
		availableOptions = optionsMap[key];

		if (availableOptions == null) {
			return;
		}
		if (this.options.type === 'select') {
			// Resetting product options
			// Moving it to prevent Safari and iOS bug
			var $tmpElement;
			// Product dropdown
			var $productDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[0]);
			var $productOptions = $productDropdown.find('option');
			var $productDropdownPlaceholder = $('.product-select-holder');
			// Size dropdown
			var $sizeDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[1]);
			var $sizeDropdownOptions = $sizeDropdown.find('option');
			var $sizeDropdownPlaceholder = $('.size-select-holder');
			var $sizeDropdownPlaceholderOptions = $sizeDropdownPlaceholder.find('option');

			// Color dropdown
			var $colorDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[2]);
			var $colorDropdownOptions = $colorDropdown.find('option');
			var $colorDropdownPlaceholder = $('.color-select-holder');
			var $colorDropdownPlaceholderOptions = $colorDropdownPlaceholder.find('option');

			// Refreshes Size and Color option value
			//       $.each($($sizeDropdownPlaceholderOptions), function(){
			//         $tmpElement = $(this);
			//         $tmpElement.detach();
			//         $sizeDropdown.append($tmpElement);

			//         $.each($($colorDropdownPlaceholderOptions), function(){
			//           $tmpElement = $(this);
			//           $tmpElement.detach();
			//           $colorDropdown.append($tmpElement);
			//         });
			//       });
			// end

			$selector = this.options.$productForm.find(selector);
			initialValue = $selector.val();
			$selectorOptions = $selector.find('option');

			var $productDropdownValue = '';

			for (j = 0, len = $selectorOptions.length; j < len; j++) {
				option = $selectorOptions[j];
				if (availableOptions.indexOf(option.value) === -1) {
					$(option).attr('disabled', true).attr('selected', null);
				} else {
					$(option).attr('disabled', null).attr('selected', true);

					$productDropdownValue = $(option).val();
				}
			}

			if (availableOptions.indexOf(initialValue) !== -1) {
				$selector.val(initialValue);
			}

			// Shinee
			// Hide and move unavailable variants.
			// Moving it to prevent Safari and iOS bug

			// Product dropdown
			for (j = 0, len = $productOptions.length; j < len; j++) {
				option = $productOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available
				}
				else{
					// Variant not available
					//           $tmpElement = $(option);
					//           $tmpElement.detach();
					//           $productDropdownPlaceholder.append($tmpElement);
				}
			}

			// Size dropdown
			$productOptions = $productDropdown.find('option');
			$sizeDropdownOptions = $sizeDropdown.find('option');

			for (j = 0, len = $sizeDropdownOptions.length; j < len; j++) {
				option = $sizeDropdownOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available

				}
				else{
					// Variant not available
					//           $tmpElement = $(option);
					//           $tmpElement.detach();
					//           $sizeDropdownPlaceholder.append($tmpElement);
				}
			}

			// Color dropdown
			$colorDropdownOptions = $colorDropdown.find('option');

			for (j = 0, len = $colorDropdownOptions.length; j < len; j++) {

				option = $colorDropdownOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available
				}
				else{
					// Variant not available
					//           $tmpElement = $(option);
					//           $tmpElement.detach();
					//           $colorDropdownPlaceholder.append($tmpElement);
				}
			}
			// ends

			var dropdown;
			var label;
			var i = 0;
			var firstLabel;
			var please_select = get_please_select();

			$.each($('.select-text span'), function(){

				dropdown = $(this).parent().parent().find('.single-option-selector');
				label = $(this);

				if(typeof(getUrlVars()["variant"]) == 'undefined'){

					if(optionIndex == i){
						//             dropdown.prepend($('<option>', {
						//               value: please_select,
						//               text: please_select,
						//               selected: 'selected',
						//               disabled: 'disabled'
						//             }));

						dropdown.val(please_select);
						label.html(please_select);

					}
					else if(i > optionIndex){
						//             dropdown.prepend($('<option>', {
						//               value: please_select,
						//               text: please_select,
						//               selected: 'selected',
						//               disabled: 'disabled'
						//             }));

						dropdown.val(please_select);
						label.html(please_select);
					}
					else{
						//             dropdown.prepend($('<option>', {
						//               value: please_select,
						//               text: please_select,
						//               disabled: 'disabled'
						//             }));
					}
				}
				else{
					if(i >= optionIndex){
						//             dropdown.prepend($('<option>', {
						//               value: please_select,
						//               text: please_select,
						//               selected: 'selected',
						//               disabled: 'disabled'
						//             }));

						dropdown.val(please_select);
						label.html(please_select);

					}
					else{
						//             dropdown.prepend($('<option>', {
						//               value: please_select,
						//               text: please_select,
						//               disabled: 'disabled'
						//             }));
					}
				}

				if(i == 0){
					firstLabel = $(this).html();
				}

				dropdown.prop('disabled',false);

				i++;
			});

			setSubmitButtons('_updateOptions');

		}
		if (this.options.type === 'radio') {
			$selector = this.options.$selector.filter("[data-option-index=" + optionIndex + "]");
			for (l = 0, len1 = $selector.length; l < len1; l++) {
				option = $selector[l];
				$option = $(option);
				if (availableOptions.indexOf(option.value) === -1) {
					$option.prop('disabled', true);
					if (option.checked) {
						$option.prop('checked', false);
						$available = $option.parents('div').find("[data-option-index=" + optionIndex + "]:not(:disabled)").eq(0);
						$available.trigger('click');
					}
				} else {
					$option.prop('disabled', false);
				}
			}
		}

		return $selector.trigger('change');
	};

	LinkedOptions.prototype._filterOptions = function(variant) {

		logger('_filterOptions');

		var optionIndex = 1;
		var optionsMap = this.optionsMap;
		var emptyOption = true;
		var emptyOptionIndex = 2;

		if(this.options.$selector.length == 3){
			optionIndex = 1;
			emptyOptionIndex = 2;
		}
		else if(this.options.$selector.length == 2){
			optionIndex = 1;
			emptyOptionIndex = 2;
		}
		else if(this.options.$selector.length == 1){
			optionIndex = 0;
			emptyOptionIndex = 1;
		}
		else{
			optionIndex = 0;
			emptyOptionIndex = 0;
		}

		var $available, $option, $selector, $selectorOptions, availableOptions, initialValue, j, key, l, len, len1, option, ref, selector;
		ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
		availableOptions = optionsMap[key];

		if (availableOptions == null) {
			return;
		}
		if (this.options.type === 'select') {
			// Resetting product options
			// Moving it to prevent Safari and iOS bug
			var $tmpElement;
			// Product dropdown
			var $productDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[0]);
			var $productOptions = $productDropdown.find('option');
			var $productDropdownPlaceholder = $('.product-select-holder');
			// Size dropdown
			var $sizeDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[1]);
			var $sizeDropdownOptions = $sizeDropdown.find('option');
			var $sizeDropdownPlaceholder = $('.size-select-holder');
			var $sizeDropdownPlaceholderOptions = $sizeDropdownPlaceholder.find('option');

			// Color dropdown
			var $colorDropdown = $($('.product-options .inline-field-wrapper.js-required select.single-option-selector')[2]);
			var $colorDropdownOptions = $colorDropdown.find('option');
			var $colorDropdownPlaceholder = $('.color-select-holder');
			var $colorDropdownPlaceholderOptions = $colorDropdownPlaceholder.find('option');

			// Refreshes Size and Color option value
			$.each($($sizeDropdownPlaceholderOptions), function(){
				$tmpElement = $(this);
				$tmpElement.detach();
				$sizeDropdown.append($tmpElement);

				$.each($($colorDropdownPlaceholderOptions), function(){
					$tmpElement = $(this);
					$tmpElement.detach();
					$colorDropdown.append($tmpElement);
				});
			});
			// end

			$selector = this.options.$productForm.find(selector);
			initialValue = $selector.val();
			$selectorOptions = $selector.find('option');

			// Product dropdown
			for (j = 0, len = $productOptions.length; j < len; j++) {
				option = $productOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available
				}
				else{
					// Variant not available
					$tmpElement = $(option);
					$tmpElement.detach();
					$productDropdownPlaceholder.append($tmpElement);
				}
			}

			// Size dropdown
			$productOptions = $productDropdown.find('option');
			$sizeDropdownOptions = $sizeDropdown.find('option');

			for (j = 0, len = $sizeDropdownOptions.length; j < len; j++) {
				option = $sizeDropdownOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available
				}
				else{
					// Variant not available
					$tmpElement = $(option);
					$tmpElement.detach();
					$sizeDropdownPlaceholder.append($tmpElement);
				}
			}

			// Color dropdown
			$colorDropdownOptions = $colorDropdown.find('option');

			for (j = 0, len = $colorDropdownOptions.length; j < len; j++) {

				option = $colorDropdownOptions[j];

				if(!$(option).prop('disabled')){
					// Variant is available
				}
				else{
					// Variant not available
					$tmpElement = $(option);
					$tmpElement.detach();
					$colorDropdownPlaceholder.append($tmpElement);
				}
			}
			// ends

			var dropdown;
			var label;
			var i = 0;
			var firstLabel;

			var that = this;

			Weglot.on("switchersReady", function(){

				var please_select = get_please_select();
				var selected = false;

				if(variant == null){
					selected = 'selected';
				}

				$.each($('.select-text span'), function(){

					dropdown = $(this).parent().parent().find('.single-option-selector');
					label = $(this);

					dropdown.prepend($('<option>', {
						value: please_select,
						text: please_select,
						selected: selected,
						disabled: 'disabled',
						class: 'option-default'
					}));

					if(variant == null){
						dropdown.find('option').removeAttr('disabled').removeAttr('selected');
						dropdown.find('option').first().attr('selected','selected').attr('disabled','disabled');

						dropdown.val(please_select);
						$(this).html(please_select);

						if(i > 0){
							dropdown.prop('disabled',true);
						}
					}

					i++;
				});

				var dropdowns = that.options.$selector;
				$.each(dropdowns, function(){

					if($(this).attr('disabled') != 'disabled'){
						$(this).attr('data-value', $(this).val());

						var _this = $(this);
						setTimeout(function(){
							_triggerDropdown(_this);
						}, 200);
					}
				});

				function _triggerDropdown(_select){
					var _val = _select.attr('data-value');
					_select.find('option:selected').attr('selected',false);
					_select.find('option[value="' + _val + '"]').attr('selected','selected');
					_select.val(_val);
					_select.change();
				}
			});
			// switchersReady ends

			Weglot.on('languageChanged', function(newLang, prevLang){

				setTimeout(function(){

					var dropdowns = $('.single-option-selector');
					var options;
					var that;
					//Bitte wählen Sie
					var parentLabel;
					var labelsDE = ['Bitte auswählen','Bitte wählen Sie', 'Bitte wählen'];
					var labelsEN = ['Please Select'];
					var labelsFR = ['Sélectionner'];

					$.each(dropdowns, function(){

						that = $(this);
						options = $(this).find('option:disabled');

						var _option = $(options);
						parentLabel = that.parent().find('.select-text span');

						if(prevLang == 'en'){

							for(var i = 0; i <= labelsEN.length; i++){

								if(parentLabel.html() == labelsEN[i]){

									if(newLang == 'en'){
										parentLabel.html(labelsEN[0]);
										_option.html(labelsEN[0]);
									}
									else if(newLang == 'de'){
										parentLabel.html(labelsDE[0]);
										_option.html(labelsDE[0]);
									}
									else if(newLang == 'fr'){
										parentLabel.html(labelsFR[0]);
										_option.html(labelsFR[0]);
									}
								}

							}

						}
						else if(prevLang == 'de'){

							for(var i = 0; i <= labelsDE.length; i++){

								if(parentLabel.html() == labelsDE[i]){

									if(newLang == 'en'){
										parentLabel.html(labelsEN[0]);
										_option.html(labelsEN[0]);
									}
									else if(newLang == 'de'){
										parentLabel.html(labelsDE[0]);
										_option.html(labelsDE[0]);
									}
									else if(newLang == 'fr'){
										parentLabel.html(labelsFR[0]);
										_option.html(labelsFR[0]);
									}
								}

							}

						}
						else if(prevLang == 'fr'){

							for(var i = 0; i <= labelsFR.length; i++){

								if(parentLabel.html() == labelsFR[i]){

									if(newLang == 'en'){
										parentLabel.html(labelsEN[0]);
										_option.html(labelsEN[0]);
									}
									else if(newLang == 'de'){
										parentLabel.html(labelsDE[0]);
										_option.html(labelsDE[0]);
									}
									else if(newLang == 'fr'){
										parentLabel.html(labelsFR[0]);
										_option.html(labelsFR[0]);
									}
								}

							}

						}

					});

				}, 450);

			});
			// languageChanged ends
		}

		return $selector.trigger('change');
	};

	LinkedOptions.prototype._mapVariants = function(product) {

		logger('_mapVariants');

		var j, key, len, ref, variant;
		ref = product.variants;

		for (j = 0, len = ref.length; j < len; j++) {
			variant = ref[j];
			if (variant.available) {
				this.optionsMap = this.optionsMap || [];
				this.optionsMap['root'] = this.optionsMap['root'] || [];
				this.optionsMap['root'].push(variant.option1);
				this.optionsMap['root'] = window.ThemeUtils.unique(this.optionsMap['root']);
				if (product.options.length > 1) {
					key = variant.option1;
					this.optionsMap[key] = this.optionsMap[key] || [];
					this.optionsMap[key].push(variant.option2);
					this.optionsMap[key] = window.ThemeUtils.unique(this.optionsMap[key]);
				}
				if (product.options.length > 2) {
					key = variant.option1 + " / " + variant.option2;
					this.optionsMap[key] = this.optionsMap[key] || [];
					this.optionsMap[key].push(variant.option3);
					this.optionsMap[key] = window.ThemeUtils.unique(this.optionsMap[key]);
				}
			}
		}

		this._filterOptions(getUrlVars()["variant"]);

		return this.options.$selector.on('change', (function(_this) {
			return function(event) {

				var $nextOption, index, nextSelector;
				index = parseInt($(event.currentTarget).attr('data-option-index'));
				nextSelector = index + 1;

				$nextOption = _this.options.$selector.filter("[data-option-index=" + nextSelector + "]");

				if ($nextOption.length) {
					return _this._updateOptions(nextSelector, _this.optionsMap, true, nextSelector);
				}
			};
		})(this));
	};

	return LinkedOptions;

})();

window.VariantHelper = (function() {
	function VariantHelper(options) {
		var defaultOptions;
		defaultOptions = {
			$addToCartButton: null,
			$priceFields: null,
			$productForm: null,
			$productThumbnails: null,
			$selector: null,
			type: 'select',
			productJSON: null,
			productSettings: null
		};
		this.options = window.ThemeUtils.extend(defaultOptions, options);
		this.$body = $(document.body);
		this.linkedOptions = null;
		this.$masterSelect = this.options.$productForm.find("#product-select-" + this.options.formID);
		if (window.Shopify && window.Shopify.preview_host) {
			this.enableHistory = false;
		} else {
			this.enableHistory = this.options.productSettings.enableHistory;
		}
		this._init();
		this._bindEvents();
	}

	VariantHelper.prototype._init = function() {
		var j, len, ref, select;
		if (this.options.type === 'select') {
			ref = this.options.$selector;

			for (j = 0, len = ref.length; j < len; j++) {
				select = ref[j];
				this._setSelectLabel(null, $(select));
			}
		}
		if (this.options.productSettings.linkedOptions) {
			this.linkedOptions = new LinkedOptions(this.options);
		}

		return this._updateCurrency();
	};

	VariantHelper.prototype._bindEvents = function() {

		logger('_bindEvents');

		return this.options.$selector.on('change', (function(_this) {
			return function(event) {

				return _this._variantChange(event);
			};
		})(this));
	};

	VariantHelper.prototype._setSelectLabel = function(event, $target) {
		var selectedOption;
		if (event == null) {
			event = null;
		}
		if ($target == null) {
			$target = false;
		}
		if (!$target) {
			$target = $(event.currentTarget);
		}
		selectedOption = $target.find('option:selected').val();

		return $target.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
	};

	VariantHelper.prototype._getCurrentOptions = function() {

		logger('_getCurrentOptions');

		var $inputs, productOptions;
		productOptions = [];
		$inputs = this.options.$selector;
		if (this.options.type === 'radio') {
			$inputs = $inputs.filter(':checked');
		}
		$inputs.each(function(index, element) {
			return productOptions.push($(element).val());
		});
		return productOptions;
	};

	VariantHelper.prototype._getVariantFromOptions = function(productOptions) {
		var foundVariant, isMatch, j, len, ref, variant;
		if (this.options.productJSON.variants == null) {
			return;
		}
		foundVariant = null;
		ref = this.options.productJSON.variants;
		for (j = 0, len = ref.length; j < len; j++) {
			variant = ref[j];
			isMatch = productOptions.every(function(value) {
				return variant.options.indexOf(value) !== -1;
			});
			if (isMatch) {
				foundVariant = variant;
			}
		}
		return foundVariant;
	};

	VariantHelper.prototype._updateMasterSelect = function(variant) {
		var ref;
		if (variant == null) {
			return;
		}

		this.$masterSelect.val(variant.id);
		this.$masterSelect.find("[value=" + variant.id + "]").attr('selected','selected').prop('selected',true);

		return this.$masterSelect.trigger('change');
	};

	VariantHelper.prototype._updatePrice = function(variant) {
		var $addToCartButton, $moneyEl, $priceFields, attribute, j, l, len, len1, priceField, productSettings, ref;
		$addToCartButton = this.options.$addToCartButton;
		$priceFields = this.options.$priceFields;

		productSettings = this.options.productSettings;
		if (variant) {
			for (j = 0, len = $priceFields.length; j < len; j++) {
				priceField = $priceFields[j];
				$moneyEl = $(priceField).children('.money');
				ref = $moneyEl[0].attributes;
				for (l = 0, len1 = ref.length; l < len1; l++) {
					attribute = ref[l];
					if (attribute.name.indexOf("data-") > -1) {
						$moneyEl.attr(attribute.name, "");
					}
				}
			}

			if (variant.compare_at_price > variant.price) {
				$priceFields.find('.money:not(.original)').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
				$priceFields.find('.money.original').html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).removeClass('hidden').attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
			} else {

				$priceFields.find('.money:not(.original)').html(Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.price, Theme.moneyFormat)).attr("data-currency", Theme.currency);
				$priceFields.find('.money.original').addClass('hidden').attr("data-currency-" + Theme.currency, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).attr("data-currency", Theme.currency);

				var priceContainers = $('.product-details p.price');

				$.each(priceContainers, function(){

					var container = $(this);
					var priceLength = container.find('span.money').length;

					if(priceLength > 1){

						var firstPrice = 0;

						var i = 1;
						$.each(container.find('span.money'), function(){

							if(firstPrice == $(this).html()){
								$(this).hide();
								$(this).parent().find('.money-minus').hide();

								return;
							}
							else{

								if(i = priceLength){
									$(this).show();
									$(this).parent().find('.money-minus').show();
								}
							}

							firstPrice = $(this).html();

							i++;
						});
					}

				});

			}
		}

		return this._updateCurrency();
	};

	VariantHelper.prototype._updateImages = function(variant) {
		var index, ref;
		index = variant != null ? (ref = variant.featured_image) != null ? ref.position : void 0 : void 0;

		if (index == null) {
			return;
		}

		// Variant to image
		if($('body').hasClass('enk-ready')){

			$('body').addClass('enk-variant-lock');
			$('.slider-for').slick("slickGoTo",index - 1);

			setTimeout(function(){
				$('body').removeClass('enk-variant-lock');
			}, 2000);

		}

		return this.options.$productThumbnails.eq(index - 1).trigger('click');
	};

	VariantHelper.prototype._updateHistory = function(variant) {
		var newUrl, variantUrl;
		if (!(this.enableHistory && window.history && window.history.replaceState)) {
			return;
		}
		if (variant != null) {
			newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
			variantUrl = newUrl.join('');
			return window.history.replaceState({
				path: variantUrl
			}, '', variantUrl);
		}
	};

	//   _variantChange_
	VariantHelper.prototype._variantChange = function(event) {

		logger('_variantChange');

		var productOptions, variant;
		if (this.options.type === 'select') {
			this._setSelectLabel(event);
		}

		productOptions = this._getCurrentOptions();
		variant = this._getVariantFromOptions(productOptions);

		this._updateMasterSelect(variant);
		this._updatePrice(variant);
		this._updateImages(variant);

		setSubmitButtons('_variantChange', variant);

		//     $('.added-product-notice').css('opacity', 0);
		$('.added-product-notice').hide();

		return this._updateHistory(variant);
	};

	VariantHelper.prototype._updateCurrency = function() {
		if (Theme.currencySwitcher) {
			return $(document.body).trigger("switch-currency");
		}
	};

	return VariantHelper;

})();

$(function() {
	return new ThemeView();
});

WINDOW = $(window);

BODY = $('body');

TOUCH = $('html').hasClass('touch');

window.themeUtils = {
	debounce: function(func, wait, immediate) {
		var timeout;
		timeout = void 0;
		return function() {
			var args, callNow, context, later;
			context = this;
			args = arguments;
			later = function() {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	}
};

ThemeView = (function(superClass) {
	extend(ThemeView, superClass);

	function ThemeView() {
		return ThemeView.__super__.constructor.apply(this, arguments);
	}

	ThemeView.prototype.el = document.body;

	ThemeView.prototype.events = {
		'focus .field': 'removeErrors',
		'submit .comment-form': 'spamCheck',
		'submit .contact-form': 'spamCheck'
	};

	ThemeView.prototype.initialize = function() {
		var j, len, ref, rte;
		this.render();
		this.customerPage = this.$el.attr('class').indexOf('customer') > 0;
		if (navigator.userAgent.indexOf('MSIE 10.0') > 0) {
			$('html').addClass('ie10');
		}
		if ($('html').hasClass('lt-ie10')) {
			this.inputPlaceholderFix();
		}
		ref = $('.rte');
		for (j = 0, len = ref.length; j < len; j++) {
			rte = ref[j];
			new RTEView({
				el: $(rte)
			});
		}
		new QuickShopView();
		new HeaderView({
			el: this.$el
		});
		if (BODY.hasClass('template-index')) {
			new IndexView({
				el: this.$el
			});
		}
		if (BODY.hasClass('template-collection')) {
			new CollectionView({
				el: this.$el
			});
		}
		if (BODY.hasClass('template-list-collections')) {
			new ListCollectionsView({
				el: this.$el
			});
		}
		if (BODY.hasClass('gift-card-template')) {
			new GiftCardView({
				el: this.$el
			});
		}
		if ($('.content-area').hasClass('customer')) {
			return new AccountView({
				el: this.$el
			});
		}
	};

	ThemeView.prototype.render = function() {
		this.sections = new ThemeEditor();
		this.sections.register('slider', this.slider(this.sections));
		this.sections.register('collection-list', this.collectionList(this.sections));
		//this.sections.register('instagram-feed', this.instagram(this.sections));
		this.sections.register('twitter-feed', this.twitter(this.sections));
		this.sections.register('featured-video', this.video(this.sections));
		if (BODY.hasClass('template-article')) {
			new SharingWidgetView({
				el: this.$el
			});
		}
		if (BODY.hasClass('template-product')) {
			new ProductView({
				el: this.$el
			});
		}
		if (BODY.hasClass('template-cart')) {
			new CartView({
				el: this.$el
			});
		}
		if (BODY.hasClass('template-password')) {
			return new PasswordView({
				el: this.$el
			});
		}
	};

	ThemeView.prototype.slider = function(sections) {
		return {
			instances: {},
			init: function(instance) {
				return this.instances[instance.sectionId] = new SlideshowView({
					el: instance.$container
				});
			},
			onSectionLoad: function(event) {
				var instance;
				instance = sections.getInstance(event);
				if (this.instances[instance.sectionId] == null) {
					return this.init(instance);
				}
			},
			onSectionSelect: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
			},
			onSectionDeselect: function(event) {
				var instance;
				instance = sections.getInstance(event);
				return this.onSectionSelect(instance);
			},
			onSectionUnload: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				if ((ref = this.instances[instance.sectionId]) != null) {
					ref.remove();
				}
				return delete this.instances[instance.sectionId];
			},
			onBlockSelect: function(event) {
				var instanceHandler;
				instanceHandler = this.instances[sections.getInstance(event).sectionId];
				return instanceHandler.lockSlide(event);
			},
			onBlockDeselect: function(event) {
				var instanceHandler;
				instanceHandler = this.instances[sections.getInstance(event).sectionId];
				return instanceHandler.unlockSlide();
			}
		};
	};

	ThemeView.prototype.collectionList = function(sections) {
		return {
			instances: {},
			init: function(instance) {
				return this.instances[instance.sectionId] = new CollectionListView({
					el: instance.$container
				});
			},
			onSectionLoad: function(event) {
				var instance;
				instance = sections.getInstance(event);
				if (this.instances[instance.sectionId] == null) {
					return this.init(instance);
				}
			},
			onSectionSelect: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
			},
			onSectionDeselect: function(event) {
				var instance;
				instance = sections.getInstance(event);
				return this.onSectionSelect(instance);
			},
			onSectionUnload: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				if ((ref = this.instances[instance.sectionId]) != null) {
					ref.remove();
				}
				return delete this.instances[instance.sectionId];
			}
		};
	};

	ThemeView.prototype.instagram = function(sections) {

		return false;

		return {
			instances: {},
			init: function(instance) {
				return this.instances[instance.sectionId] = new InstagramView({
					el: instance.$container
				});
			},
			onSectionLoad: function(event) {
				var instance;
				instance = sections.getInstance(event);
				if (this.instances[instance.sectionId] == null) {
					return this.init(instance);
				}
			},
			onSectionSelect: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
			},
			onSectionDeselect: function(event) {
				var instance;
				instance = sections.getInstance(event);
				return this.onSectionSelect(instance);
			},
			onSectionUnload: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				if ((ref = this.instances[instance.sectionId]) != null) {
					ref.remove();
				}
				return delete this.instances[instance.sectionId];
			}
		};
	};

	ThemeView.prototype.twitter = function(sections) {
		return {
			instances: {},
			init: function(instance) {
				return this.instances[instance.sectionId] = new TwitterView({
					el: instance.$container
				});
			},
			onSectionLoad: function(event) {
				var instance;
				instance = sections.getInstance(event);
				if (this.instances[instance.sectionId] == null) {
					return this.init(instance);
				}
			},
			onSectionSelect: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
			},
			onSectionDeselect: function(event) {
				var instance;
				instance = sections.getInstance(event);
				return this.onSectionSelect(instance);
			},
			onSectionUnload: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				if ((ref = this.instances[instance.sectionId]) != null) {
					ref.remove();
				}
				return delete this.instances[instance.sectionId];
			}
		};
	};

	ThemeView.prototype.video = function(sections) {
		return {
			instances: {},
			init: function(instance) {
				return this.instances[instance.sectionId] = new VideoView({
					el: instance.$container
				});
			},
			onSectionLoad: function(event) {
				var instance;
				instance = sections.getInstance(event);
				if (this.instances[instance.sectionId] == null) {
					return this.init(instance);
				}
			},
			onSectionSelect: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
			},
			onSectionDeselect: function(event) {
				var instance;
				instance = sections.getInstance(event);
				return this.onSectionSelect(instance);
			},
			onSectionUnload: function(event) {
				var instance, ref;
				instance = sections.getInstance(event);
				if ((ref = this.instances[instance.sectionId]) != null) {
					ref.remove();
				}
				return delete this.instances[instance.sectionId];
			}
		};
	};

	ThemeView.prototype.removeErrors = function(e) {
		var field;
		field = $(e.currentTarget);
		return field.removeClass('error');
	};

	ThemeView.prototype.inputPlaceholderFix = function() {
		var input, j, len, placeholders, text;
		placeholders = $('[placeholder]');
		for (j = 0, len = placeholders.length; j < len; j++) {
			input = placeholders[j];
			input = $(input);
			if (!(input.attr('value').length > 0)) {
				text = input.attr('placeholder');
				input.attr('value', text);
				input.data('original-text', text);
			}
		}
		placeholders.focus(function() {
			input = $(this);
			if (input.val() === input.data('original-text')) {
				return input.val('');
			}
		});
		return placeholders.blur(function() {
			input = $(this);
			if (input.val().length === 0) {
				return input.val(input.data('original-text'));
			}
		});
	};

	ThemeView.prototype.spamCheck = function(e) {
		if (this.$(e.target).find('.comment-check').val().length > 0) {
			return e.preventDefault();
		}
	};

	return ThemeView;

})(Backbone.View);

HeaderView = (function(superClass) {
	extend(HeaderView, superClass);

	function HeaderView() {
		this.toggleStickyMobileNav = bind(this.toggleStickyMobileNav, this);
		return HeaderView.__super__.constructor.apply(this, arguments);
	}

	HeaderView.prototype.el = $('.main-header');

	HeaderView.prototype.events = {
		'click .tools .search': 'toggleSearch',
		'blur .search-wrap.full .search-input': 'toggleSearch',
		'click .compact .search': 'toggleMobileSearch',
		'blur .compact .search-input': 'toggleMobileSearch',
		'click .mini-cart-wrap': 'toggleMiniCart',
		//     'mouseleave .mini-cart.active': 'toggleMiniCart',
		'click .mini-cart.active': 'stopProp',
		//     'change [name=currencies]': 'switchCurrency',
		//     'switch-currency': 'switchCurrency'
	};

	HeaderView.prototype.initialize = function() {
		this.sectionBinding();
		this.initializedClass = 'header-initialized';
		return this._validate();
	};

	HeaderView.prototype._initializeCurrency = function() {
		var newCurrency;
		Currency.format = Theme.currencySwitcherFormat;
		Currency.money_with_currency_format = {};
		Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
		Currency.money_format = {};
		Currency.money_format[Theme.currency] = Theme.moneyFormat;
		newCurrency = Currency.cookie.read();
		if (newCurrency && this.$("[name=currencies] option[value=" + newCurrency + "]")) {
			Currency.currentCurrency = newCurrency;
		} else if (Theme.defaultCurrency) {
			Currency.currentCurrency = Theme.defaultCurrency;
			Currency.cookie.write(Theme.defaultCurrency);
		} else {
			Currency.currentCurrency = Theme.currency;
			Currency.cookie.write(Theme.currency);
		}
		$("[name=currencies]").val(Currency.currentCurrency);
		return $(window).load((function(_this) {
			return function() {
				var doubleMoney, j, l, len, len1, money, ref, ref1;
				ref = $("span.money span.money");
				for (j = 0, len = ref.length; j < len; j++) {
					doubleMoney = ref[j];
					$(doubleMoney).parents("span.money").removeClass("money");
				}
				ref1 = $("span.money");
				for (l = 0, len1 = ref1.length; l < len1; l++) {
					money = ref1[l];
					$(money).attr("data-currency-" + Theme.currency, $(money).html());
				}
				if (Theme.currencySwitcher) {
					return _this.switchCurrency();
				}
			};
		})(this));
	};

	HeaderView.prototype._validate = function() {
		this.headerSettings = window.headerJSON;
		this.window = $(window);
		this.body = $('body');
		this.mainHeader = $('.main-header');
		this.minimalHeader = $('.header-minimal');
		this.mainHeaderWrap = $('.main-header-wrap');
		this.fullNav = $('nav.full', this.$el);
		this.compactNav = $('nav.compact', this.$el);
		this.slideshow = $('.slideshow', this.$el);
		this.actionLinks = $('.main-header .action-links');
		this.tools = $('.tools');
		this.branding = $('.store-title, .logo');
		this.searchWrap = $('.search-wrap.full');
		this.mobileSearchWrap = $('.search-outer-wrap');
		this.searchInput = $('.search-input');
		this.miniCart = $('.mini-cart');
		this.bodyContent = $('.page-body-content');
		//     this._initializeCurrency();
		if (this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
			this.body.addClass('main-header-slim');
		} else {
			this.body.removeClass('main-header-slim');
		}
		if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
			this.body.addClass('header-centered');
		} else {
			this.body.removeClass('header-centered');
		}
		if (!this.body.hasClass('template-index' && this.slideshow.length && this.slideshow.attr('data-full-width') === 'true')) {
			if (this.compactNav.length) {
				this.compactNav.addClass('bordered');
			} else {
				this.compactNav.removeClass('bordered');
			}
			if (this.fullNav.length) {
				this.fullNav.addClass('bordered');
			} else {
				this.fullNav.removeClass('bordered');
			}
		}
		if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
			this.tools = $('.tools-left');
		}
		if (this.mainHeaderWrap.attr('data-header-alignment') !== 'true') {
			this.branding.imagesLoaded((function(_this) {
				return function() {
					return _this.positionHeaderTools();
				};
			})(this));
		}
		this.positionBodyOffset();
		$('body').click((function(_this) {
			return function(e) {
				if (_this.miniCart.hasClass('active')) {
					//           _this.miniCart.hide().removeClass('active');
					_this.miniCart.fadeOut().removeClass('active');
					return _this.miniCart.parent().removeClass('active');
				}
			};
		})(this));
		this.window.on('scroll', window.themeUtils.debounce(this.toggleStickyMobileNav, 15));
		this.window.resize((function(_this) {
			return function() {
				_this.resize();
				if (_this.mainHeaderWrap.attr('data-header-alignment') !== 'true') {
					_this.positionHeaderTools();
				}
				if (_this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
					_this.positionBodyOffset();
					return _this.toggleStickyMobileNav();
				}
			};
		})(this));
		return this.NavigationView = new NavigationView({
			el: 'nav.full'
		});
	};

	HeaderView.prototype.sectionBinding = function() {
		this.$el.on('shopify:section:load', (function(_this) {
			return function(event) {
				if (!$(event.target).hasClass('section-header')) {
					return;
				}
				_this.delegateEvents();
				return _this._validate();
			};
		})(this));
		return this.$el.on('shopify:section:unload', (function(_this) {
			return function(event) {
				var ref, ref1;
				if (!$(event.target).hasClass('section-header')) {
					return;
				}
				_this.undelegateEvents();
				if ((ref = _this.NavigationView) != null) {
					ref.prepareRemove();
				}
				return (ref1 = _this.NavigationView) != null ? ref1.remove() : void 0;
			};
		})(this));
	};

	HeaderView.prototype.stopProp = function(e) {
		return e.stopPropagation();
	};

	HeaderView.prototype.resize = function() {
		if (this.window.width() < 720) {
			return this.searchWrap.hide();
		}
	};

	HeaderView.prototype.positionBodyOffset = function() {
		if (this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
			if (this.window.width() < 720) {
				return;
			}
			return this.bodyContent.delay(3000).css({
				marginTop: this.mainHeader.outerHeight()
			});
		} else {
			return this.bodyContent.css({
				marginTop: ""
			});
		}
	};

	HeaderView.prototype.toggleStickyMobileNav = function() {
		if (!(WINDOW.width() < 720)) {
			return;
		}
		if (this.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
			return;
		}
		if (this.window.scrollTop() > this.minimalHeader.outerHeight()) {
			this.mainHeaderWrap.addClass('header-mobile-stick');
			return this.bodyContent.css({
				marginTop: $('.main-header .compact').outerHeight()
			});
		} else {
			this.mainHeaderWrap.removeClass('header-mobile-stick');
			return this.bodyContent.css({
				marginTop: 0
			});
		}
	};

	HeaderView.prototype.positionHeaderTools = function() {
		var offset;
		if ($('.header-minimal').length) {
			offset = (this.mainHeader.outerHeight() - this.searchWrap.height()) / 2;
			return this.searchWrap.css({
				visibility: 'visible',
				'min-width': this.tools.outerWidth()
			});
		} else if ($('.header-social-links').length) {
			offset = 20;
			this.tools.css({
				marginTop: offset + 4,
				visibility: 'visible'
			});
			return this.searchWrap.css({
				marginTop: offset + 1,
				visibility: 'visible',
				'min-width': this.tools.outerWidth()
			});
		} else {
			offset = (this.branding.outerHeight() - this.tools.height()) / 2;
			this.tools.css({
				marginTop: offset + 4,
				visibility: 'visible'
			});
			return this.searchWrap.css({
				marginTop: offset + 1,
				visibility: 'visible',
				'min-width': this.tools.outerWidth()
			});
		}
	};

	HeaderView.prototype.toggleSearch = function() {
		if (this.searchWrap.hasClass('active')) {

			// Shinee. Search result field fix
			if ($('.search-wrap:hover').length != 0) {
				return false;
			}

			this.searchWrap.hide().removeClass('active');
			this.searchInput.val('');
			this.tools.css('visibility', 'visible');
		} else {
			this.searchWrap.show().addClass('active');
			this.searchInput.focus();
			this.tools.css('visibility', 'hidden');
			this.miniCart.hide().removeClass('active');
			this.miniCart.parent().removeClass('active');
		}
		return false;
	};

	HeaderView.prototype.toggleMobileSearch = function() {
		var offset;
		if (this.mobileSearchWrap.hasClass('active')) {

			// Shinee. Search result field fix
			if ($('.search-wrap:hover').length != 0) {
				return false;
			}

			this.mobileSearchWrap.hide().removeClass('active');
			return this.searchInput.val('');
		} else {
			this.mobileSearchWrap.show().addClass('active');
			offset = this.mobileSearchWrap.find('.search-wrap').outerHeight() / -2;
			this.mobileSearchWrap.find('.search-wrap').css({
				marginTop: offset
			});
			this.searchInput.focus();
			return $('.mobile-dropdown').trigger('close-mobile-nav');
		}
	};

	// Enk. Modified version. Checks if var e is null
	HeaderView.prototype.toggleMiniCart = function(e) {

		var button;
		button = this.miniCart.parent();

		//     if (this.miniCart.hasClass('active')) {
		//       this.miniCart.hide().removeClass('active');
		//       button.removeClass('active');
		//       this.miniCart.find('.options').hide();
		//     } else {
		//       this.miniCart.show().addClass('active');
		//       button.addClass('active');
		//       this.miniCart.find('.options').show();
		//     }

		var revealSpeed = 300;
		var hideSpeed = 300;

		if (this.miniCart.hasClass('active')) {
			this.miniCart.fadeOut(hideSpeed).removeClass('active');
			button.removeClass('active');
			this.miniCart.find('.options').fadeOut(hideSpeed);
		} else {
			this.miniCart.fadeIn(revealSpeed).addClass('active');
			button.addClass('active');
			this.miniCart.find('.options').fadeIn(revealSpeed);
		}

		return e.stopPropagation();
	};

	/* Original Function
	HeaderView.prototype.toggleMiniCart = function(e) {
	var button;
	button = this.miniCart.parent();
	if (this.miniCart.hasClass('active')) {
	this.miniCart.hide().removeClass('active');
	button.removeClass('active');
} else {
this.miniCart.show().addClass('active');
button.addClass('active');
}
return e.stopPropagation();
};
*/

HeaderView.prototype.switchCurrency = function(e) {
	var $switcher, j, len, money, newCurrency, ref;
	$switcher = $("[name=currencies]");
	newCurrency = $switcher.val();
	if (e !== void 0) {
		$switcher = $(e.currentTarget);
		if ($switcher !== void 0 && ($switcher != null ? $switcher.attr('name') : void 0) === 'currencies') {
			newCurrency = $switcher.val();
		}
	}
	if (newCurrency === null || newCurrency === '') {
		newCurrency = Theme.currency;
	}
	ref = $("span.money");
	for (j = 0, len = ref.length; j < len; j++) {
		money = ref[j];
		$(money).html($(money).attr("data-currency-" + Theme.currency));
		$(money).attr("data-currency", Theme.currency);
	}
	Currency.convertAll(Theme.currency, newCurrency);
	Currency.currentCurrency = newCurrency;
	Currency.cookie.write(newCurrency);
	return this.$(".selected-currency").text(Currency.currentCurrency);
};

return HeaderView;

})(Backbone.View);

NavigationView = (function(superClass) {
	extend(NavigationView, superClass);

	function NavigationView() {
		return NavigationView.__super__.constructor.apply(this, arguments);
	}

	NavigationView.prototype.events = {
		'mouseenter .dropdown': 'establishTierDirection',
		'mouseleave .dropdown': 'replaceTrailingDivider',
		'mouseenter .has-mega-nav': 'toggleMegaNav',
		'format-full-navigation': 'formatFullNavigation'
	};

	NavigationView.prototype.initialize = function() {
		this.initializedClass = 'navigation-initialized';
		return this._validate();
	};

	NavigationView.prototype._validate = function() {
		var j, len, navItem, ref;
		this.navigation = $('.main-header nav.full');
		this.megaNavButton = this.navigation.find('.has-mega-nav');
		this.mainMenuNavItems = this.navigation.find('> ul > .nav-item');
		this.multiLine = false;
		this.$megaNav = $('.mega-nav');
		this.checkIfFontsLoaded();
		this.requiredRoom = 0;
		ref = this.mainMenuNavItems;
		for (j = 0, len = ref.length; j < len; j++) {
			navItem = ref[j];
			navItem = $(navItem);
			this.requiredRoom += navItem.outerWidth();
		}
		this.MobileNavigationView = new MobileNavigationView({
			el: 'nav.compact'
		});
		this.MegaNavigationView = new MegaNavigationView({
			el: this.$megaNav
		});
		return WINDOW.resize((function(_this) {
			return function() {
				return _this.resize();
			};
		})(this));
	};

	NavigationView.prototype.prepareRemove = function() {
		this.MobileNavigationView.remove();
		return this.MegaNavigationView.remove();
	};

	NavigationView.prototype.checkIfFontsLoaded = function() {
		var checker, hasRun;
		hasRun = 0;
		return checker = setInterval((function(_this) {
			return function() {
				hasRun += 1;
				if ($('html').hasClass('wf-active') || hasRun === 10) {
					_this.formatFullNavigation();
					return clearInterval(checker);
				}
			};
		})(this), 500);
	};

	NavigationView.prototype.replaceTrailingDivider = function(e) {
		var previousNavItem;
		previousNavItem = ($(e.currentTarget)).prev();
		return previousNavItem.removeClass('hide-divider');
	};

	NavigationView.prototype.resize = function() {
		return this.formatFullNavigation();
	};

	NavigationView.prototype.formatFullNavigation = function() {
		var availableRoom;
		availableRoom = this.navigation.width();
		if (this.requiredRoom >= availableRoom) {
			this.navigation.addClass('compress');
			if (this.navigation.height() > 100) {
				this.multiLine = true;
				return this.navigation.addClass('multi-line');
			} else {
				this.navigation.removeClass('multi-line');
				return this.multiLine = false;
			}
		} else {
			this.navigation.removeClass('compress');
			this.navigation.removeClass('multi-line');
			return this.multiLine = false;
		}
	};

	NavigationView.prototype.establishTierDirection = function(e) {
		var availableRoom, childWidth, children, dropdown, positionLeft, previousNavItem, requiredRoom, secondaryChildren, tertiaryChildren;
		this.mainHeaderWrap = $('.main-header-wrap');
		if (this.mainHeaderWrap.attr('data-header-format') === 'minimal') {
			return;
		}
		previousNavItem = ($(e.currentTarget)).prev();
		previousNavItem.addClass('hide-divider');
		this.$megaNav.trigger('dismissMegaNav');
		dropdown = $(e.currentTarget);
		children = dropdown.find('.child');
		secondaryChildren = children.filter('.secondary');
		tertiaryChildren = children.filter('.tertiary');
		childWidth = dropdown.find('.dropdown-wrap').outerWidth();
		positionLeft = dropdown.position().left;
		requiredRoom = tertiaryChildren.length > 0 ? 3 * childWidth : 2 * childWidth;
		availableRoom = this.navigation.width() - positionLeft - dropdown.outerWidth();

		if (requiredRoom > (availableRoom + 200)) {
			return children.removeClass('right').addClass('left');
		} else {
			return children.removeClass('left').addClass('right');
		}
	};

	NavigationView.prototype.toggleMegaNav = function(e) {
		var previousNavItem;
		if ($(e.currentTarget).hasClass('active')) {
			return;
		}
		previousNavItem = this.megaNavButton.prev();
		if (previousNavItem.hasClass('hide-divider')) {
			previousNavItem.removeClass('hide-divider');
		} else {
			previousNavItem.addClass('hide-divider');
		}
		this.$megaNav.trigger('toggleMegaNav');
		return false;
	};

	return NavigationView;

})(Backbone.View);

MobileNavigationView = (function(superClass) {
	extend(MobileNavigationView, superClass);

	function MobileNavigationView() {
		return MobileNavigationView.__super__.constructor.apply(this, arguments);
	}

	MobileNavigationView.prototype.el = $('.mobile-dropdown');

	MobileNavigationView.prototype.events = {
		'click .dropdown > a': 'toggleExpand',
		'close-mobile-nav': 'closeMobileNav'
	};

	MobileNavigationView.prototype.initialize = function() {
		this.mobileDropdownButton = $('.compact .nav-item.dropdown');
		this.mobileDropdown = $('.mobile-dropdown');
		$('.nav-item.dropdown').on('click', (function(_this) {
			return function() {
				return _this.toggleMobileNav();
			};
		})(this));
		this.windowWidth = $(window).width();
		return WINDOW.resize((function(_this) {
			return function() {
				_this.resize();
				return _this.windowWidth = $(window).width();
			};
		})(this));
	};

	MobileNavigationView.prototype.resize = function() {
		var isWidthIncrease;
		isWidthIncrease = this.windowWidth !== $(window).width() ? true : false;
		if (WINDOW.width() > 720 && this.mobileDropdownButton.hasClass('active') && isWidthIncrease) {
			return this.closeMobileNav();
		}
	};

	MobileNavigationView.prototype.openMobileNav = function() {
		this.mobileDropdownButton.addClass('active');
		return this.mobileDropdown.show();
	};

	MobileNavigationView.prototype.closeMobileNav = function() {
		this.mobileDropdownButton.removeClass('active');
		return this.mobileDropdown.hide();
	};

	MobileNavigationView.prototype.toggleMobileNav = function() {
		if (this.mobileDropdownButton.hasClass('active')) {
			return this.closeMobileNav();
		} else {
			return this.openMobileNav();
		}
	};

	MobileNavigationView.prototype.toggleExpand = function(e) {
		var button, childList, listItem;
		button = ($(e.currentTarget)).parent();
		listItem = button.closest('li.list-item');
		childList = button.find('> .list');
		listItem.toggleClass('expanded');
		childList.toggle();
		return false;
	};

	return MobileNavigationView;

})(Backbone.View);

MegaNavigationView = (function(superClass) {
	extend(MegaNavigationView, superClass);

	function MegaNavigationView() {
		return MegaNavigationView.__super__.constructor.apply(this, arguments);
	}

	MegaNavigationView.prototype.initialize = function() {
		this.initializedClass = 'mega-navigation-initialized';
		return this._validate();
	};

	MegaNavigationView.prototype._validate = function() {
		var listCount;
		this.navContainer = $('nav.full');
		this.nav = this.$el;
		this.megaNavWrap = this.nav.find('.mega-nav-wrap');
		this.navTrigger = $('.has-mega-nav');
		this.mainList = this.$el.find('.main-list');
		this.expandedList = this.$el.find('.expanded-list');
		this.categoriesList = this.$el.find('.category-list');
		this.backButton = this.$el.find('.back');
		listCount = this.mainList.find('.list').length;
		if (listCount === 1) {
			listCount = 'one-col';
		}
		if (listCount === 2) {
			listCount = 'two-col';
		}
		if (listCount === 3) {
			listCount = 'three-col';
		}
		this.mainList.find('.list').addClass(listCount);
		this.nav.css({
			height: this.megaNavWrap.height()
		});
		WINDOW.resize((function(_this) {
			return function() {
				return _this.resize();
			};
		})(this));
		return $('.has-mega-nav, .mega-nav').mouseleave((function(_this) {
			return function(e) {
				return _this.closeMegaNav(e);
			};
		})(this));
	};

	MegaNavigationView.prototype.events = {
		'toggleMegaNav': 'toggle',
		'dismissMegaNav': 'dismiss',
		'click .show-more': 'goDeepWithin',
		'click .has-category': 'goDeepWithin',
		'click .back': 'reset'
	};

	MegaNavigationView.prototype.resize = function() {
		this.nav.css({
			height: this.megaNavWrap.height()
		});
		if (WINDOW.width() < 720) {
			return this.dismiss();
		} else if (this.navTrigger.hasClass('active')) {
			return this.invoke();
		}
	};

	MegaNavigationView.prototype.toggle = function() {
		if (this.navTrigger.hasClass('active')) {
			this.dismiss();
		} else {
			this.invoke();
		}
		return false;
	};

	MegaNavigationView.prototype.invoke = function() {
		var offset;
		offset = Math.floor(this.navContainer.position().top + this.navTrigger.position().top + this.navTrigger.outerHeight());
		this.navTrigger.addClass('active');
		return this.nav.css('top', offset);
	};

	MegaNavigationView.prototype.dismiss = function() {
		this.navTrigger.removeClass('active');
		this.navTrigger.prev().removeClass('hide-divider');
		return this.nav.css('top', '-9999px');
	};

	MegaNavigationView.prototype.closeMegaNav = function(e) {
		if ($(e.currentTarget).hasClass('has-mega-nav')) {
			if (!($(e.relatedTarget).hasClass('.mega-nav') || $(e.relatedTarget).closest('.mega-nav').length)) {
				return this.dismiss();
			}
		} else if ($(e.currentTarget).hasClass('mega-nav')) {
			if (!($(e.currentTarget).hasClass('has-mega-nav') || $(e.relatedTarget).parent().hasClass('has-mega-nav'))) {
				return this.dismiss();
			}
		}
	};

	MegaNavigationView.prototype.goDeepWithin = function(e) {
		var category, link, list, newHeight, origin, target, targetList;
		link = $(e.currentTarget);
		origin = link.closest('ul.mega-nav-list');
		if (link.hasClass('show-more')) {
			list = link.closest('ul.list-wrap').data('list');
			target = this.expandedList;
			targetList = target.find("li[data-list='" + list + "']");
			this.categoriesList.hide();
			this.expandedList.show().find('.list').removeClass('active');
			target.find('.back').data('target', 'main-list');
		} else if (link.hasClass('has-category')) {
			category = ($(e.currentTarget)).data('category');
			target = this.categoriesList;
			targetList = target.find("li[data-category='" + category + "']");
			if (origin.hasClass('main-list')) {
				this.expandedList.hide();
				this.categoriesList.show().find('.list').removeClass('active');
				target.find('.back').data('target', 'main-list');
			} else {
				this.categoriesList.show().find('.list').removeClass('active');
				target.find('.back').data('target', 'expanded-list');
			}
		}
		targetList.addClass('active');
		if (target.hasClass('expanded-list')) {
			target.find('.back').data('origin', 'expanded-list');
		} else {
			target.find('.back').data('origin', 'category-list');
		}
		newHeight = target.height();
		if (newHeight > origin.height()) {
			this.nav.animate({
				height: target.height()
			});
		}
		this.megaNavWrap.animate({
			top: '-=' + origin.height()
		}, (function(_this) {
			return function() {
				return target.find('.back').fadeIn(150);
			};
		})(this));
		return false;
	};

	MegaNavigationView.prototype.reset = function(e) {
		var backButton, origin, target;
		backButton = $(e.currentTarget);
		target = $("." + (backButton.data('target')));
		origin = $("." + (backButton.data('origin')));
		backButton.fadeOut(150);
		this.nav.animate({
			height: target.height()
		});
		this.megaNavWrap.animate({
			top: '+=' + target.height()
		});
		if (backButton.data('origin') === 'category-list') {
			backButton.data('target', 'main-list');
			return backButton.data('origin', 'expanded-list');
		}
	};

	return MegaNavigationView;

})(Backbone.View);

IndexView = (function(superClass) {
	extend(IndexView, superClass);

	function IndexView() {
		this.sizePictureBlocks = bind(this.sizePictureBlocks, this);
		return IndexView.__super__.constructor.apply(this, arguments);
	}

	IndexView.prototype.initialize = function() {
		setTimeout(((function(_this) {
			return function() {
				return _this.verticallyAlign();
			};
		})(this)), 500);
		WINDOW.resize((function(_this) {
			return function() {
				return _this.verticallyAlign();
			};
		})(this));
		this.pictureBlocks = $('.picture-block');
		if (this.pictureBlocks.length) {
			($(window)).on("load resize", window.themeUtils.debounce(this.sizePictureBlocks, 100));
			return this.sizePictureBlocks();
		}
	};

	IndexView.prototype.sizePictureBlocks = function() {
		if (this.pictureBlocks.length) {
			return this.pictureBlocks.each(function() {
				var contentHeight, imageHeight;
				if (($(window)).width() > 700) {
					contentHeight = $(this).find('.picture-block-content').outerHeight();
					imageHeight = $(this).find('.picture-block-image > *:first-child').outerHeight();
					if (contentHeight > imageHeight) {
						return $(this).height(contentHeight + 100);
					} else {
						return $(this).height(imageHeight);
					}
				} else {
					return $(this).css('height', '');
				}
			});
		}
	};

	IndexView.prototype.verticallyAlign = function() {
		var collection, j, label, labels, len, ref, results;
		ref = $('.collection');
		results = [];
		for (j = 0, len = ref.length; j < len; j++) {
			collection = ref[j];
			labels = ($(collection)).find('h3, span');
			results.push((function() {
				var l, len1, results1;
				results1 = [];
				for (l = 0, len1 = labels.length; l < len1; l++) {
					label = labels[l];
					results1.push(($(label)).css({
						marginTop: ($(label)).height() / -2
					}).removeClass('preload'));
				}
				return results1;
			})());
		}
		return results;
	};

	return IndexView;

})(Backbone.View);

CollectionListView = (function(superClass) {
	extend(CollectionListView, superClass);

	function CollectionListView() {
		return CollectionListView.__super__.constructor.apply(this, arguments);
	}

	CollectionListView.prototype.initialize = function() {
		this.initializedClass = 'collection-list-initialized';
		return this._validate();
	};

	CollectionListView.prototype._validate = function() {
		setTimeout(((function(_this) {
			return function() {
				return _this.verticallyAlign();
			};
		})(this)), 500);
		return WINDOW.resize((function(_this) {
			return function() {
				return _this.verticallyAlign();
			};
		})(this));
	};

	CollectionListView.prototype.verticallyAlign = function() {
		var collection, j, label, labels, len, ref, results;
		ref = $('.collection');
		results = [];
		for (j = 0, len = ref.length; j < len; j++) {
			collection = ref[j];
			labels = ($(collection)).find('h3, span');
			results.push((function() {
				var l, len1, results1;
				results1 = [];
				for (l = 0, len1 = labels.length; l < len1; l++) {
					label = labels[l];
					results1.push(($(label)).css({
						marginTop: ($(label)).height() / -2
					}).removeClass('preload'));
				}
				return results1;
			})());
		}
		return results;
	};

	return CollectionListView;

})(Backbone.View);

RTEView = (function(superClass) {
	extend(RTEView, superClass);

	function RTEView() {
		return RTEView.__super__.constructor.apply(this, arguments);
	}

	RTEView.prototype.events = {
		'click .tabs li': 'switchTabs'
	};

	RTEView.prototype.initialize = function() {
		this.rte = this.$el;
		this.setupTabs();
		this.setupImages();
		this.setupVideos();
		this.mobilifyTables();
		return WINDOW.resize((function(_this) {
			return function() {
				_this.setupVideos();
				return _this.mobilifyTables();
			};
		})(this));
	};

	RTEView.prototype.setupImages = function() {
		var images;
		images = this.rte.find('p > img');
		return images.imagesLoaded(function() {
			var image, j, len, results;
			results = [];
			for (j = 0, len = images.length; j < len; j++) {
				image = images[j];
				image = $(image);
				results.push(image.wrap('<div class="image-wrap">'));
			}
			return results;
		});
	};

	RTEView.prototype.setupVideos = function() {
		var aspectRatio, contentWidth, j, len, results, video, videos;
		videos = this.rte.not(".special").find('iframe, embed, object');
		contentWidth = this.rte.width();
		results = [];
		for (j = 0, len = videos.length; j < len; j++) {
			video = videos[j];
			video = $(video);
			aspectRatio = video.height() / video.width();
			results.push(video.css({
				width: contentWidth,
				height: contentWidth * aspectRatio
			}));
		}
		return results;
	};

	RTEView.prototype.switchTabs = function(e) {
		var aspectRatio, content, contentWidth, j, len, position, tab, tabContainer, tabContentContainer, video, videos;
		tab = $(e.currentTarget);
		tabContainer = tab.parent();
		tabContentContainer = tabContainer.next();
		position = tab.index();
		content = tabContentContainer.find('> li').eq(position);
		tabContainer.find('> li').removeClass('active');
		tabContentContainer.find('> li').removeClass('active');
		tab.addClass('active');
		content.addClass('active');
		videos = content.find('iframe, embed, object');
		contentWidth = content.width();
		for (j = 0, len = videos.length; j < len; j++) {
			video = videos[j];
			video = $(video);
			aspectRatio = video.height() / video.width();
			video.css({
				width: contentWidth,
				height: contentWidth * aspectRatio,
				visibility: 'visible'
			});
		}
		return false;
	};

	RTEView.prototype.setupTabs = function() {
		var tabs, tabsContent;
		tabs = this.rte.find('.tabs');
		tabsContent = this.rte.find('.tabs-content');
		if (this.rte.find(':first-child').hasClass('tabs')) {
			this.rte.parent().addClass('no-border');
		}
		tabs.find('li:first').addClass('active');
		return tabsContent.find('li:first').addClass('active');
	};

	RTEView.prototype.mobilifyTables = function() {
		return this.$('table').mobileTable();
	};

	return RTEView;

})(Backbone.View);

VideoView = (function(superClass) {
	extend(VideoView, superClass);

	function VideoView() {
		return VideoView.__super__.constructor.apply(this, arguments);
	}

	VideoView.prototype.initialize = function() {
		this.initializedClass = 'video-initialized';
		return this._validate();
	};

	VideoView.prototype._validate = function() {
		this.videoWrapper = this.$(".home-video-embed-wrapper", this.$el);
		this.video = this.$(".home-video-embed", this.$el);
		this.videoID = this.$(".home-video", this.$el).data("video-id");
		this.videoType = this.$(".home-video", this.$el).data("video-type");
		this.detachedVideo = null;
		if (this.videoType === "vimeo") {
			return $.getJSON("https://www.vimeo.com/api/v2/video/" + this.videoID + ".json?callback=?", {
				format: "json"
			}, function(data) {
				$(".vimeo-image", this.$el).attr("src", data[0].thumbnail_large);
			});
		}
	};

	VideoView.prototype.events = {
		"click .home-video-play-button": "openVideo",
		"keyup": "closeVideo"
	};

	VideoView.prototype.openVideo = function() {
		this.videoWrapper.addClass("opening");
		if (this.detachedVideo) {
			this.video.width("");
			this.detachedVideo.appendTo(this.video);
		} else {
			this.video.fitVids({
				customSelector: "iframe"
			});
		}
		this.verticallyCenterVideo();
		$(window).on("resize.video", (function(_this) {
			return function() {
				return _this.verticallyCenterVideo();
			};
		})(this));
		this.videoWrapper.on("click.video", (function(_this) {
			return function() {
				return _this.closeVideo();
			};
		})(this));
		return setTimeout((function(_this) {
			return function() {
				return _this.videoWrapper.addClass("open");
			};
		})(this), 20);
	};

	VideoView.prototype.centerVideoText = function() {
		var contentHeight, contentWidth, videoContent;
		videoContent = this.$(".home-video-content");
		contentWidth = videoContent.outerWidth();
		contentHeight = videoContent.outerHeight();
		return videoContent.css({
			marginTop: -(contentHeight / 2),
			marginLeft: -(contentWidth / 2)
		});
	};

	VideoView.prototype.verticallyCenterVideo = function() {
		var availableHeight, video, videoHeight, videoRatio, windowHeight;
		this.video.css({
			marginTop: 0,
			width: "100%"
		});
		video = this.video.find(".fluid-width-video-wrapper");
		videoHeight = video.outerHeight();
		videoRatio = video.width() / videoHeight;
		windowHeight = window.innerHeight || $(window).height();
		availableHeight = windowHeight - 60;
		if (videoHeight > availableHeight) {
			return this.video.removeClass("centered").css({
				marginTop: 0,
				width: availableHeight * videoRatio
			});
		} else {
			return this.video.addClass("centered").css({
				marginTop: -(videoHeight / 2),
				width: "100%"
			});
		}
	};

	VideoView.prototype.closeVideo = function(e) {
		var detach;
		if (!this.$(".home-video").length) {
			return;
		}
		if (e && this.videoWrapper.hasClass("open")) {
			if (e.which !== 27) {
				return;
			}
		}
		$(window).off("resize.video");
		this.videoWrapper.off("click.video");
		this.videoWrapper.removeClass("open");
		detach = (function(_this) {
			return function() {
				_this.detachedVideo = _this.video.find(".fluid-width-video-wrapper").detach();
				return _this.videoWrapper.removeClass("opening").off(_this.transitionend);
			};
		})(this);
		if (Modernizr.csstransitions) {
			this.videoWrapper.on(this.transitionend, (function(_this) {
				return function() {
					return detach();
				};
			})(this));
			return setTimeout((function(_this) {
				return function() {
					if (_this.videoWrapper.hasClass("opening")) {
						return detach();
					}
				};
			})(this), 300);
		} else {
			return detach();
		}
	};

	return VideoView;

})(Backbone.View);

RTEView = (function(superClass) {
	extend(RTEView, superClass);

	function RTEView() {
		return RTEView.__super__.constructor.apply(this, arguments);
	}

	RTEView.prototype.events = {
		'click .tabs li': 'switchTabs'
	};

	RTEView.prototype.initialize = function() {
		this.rte = this.$el;
		this.setupTabs();
		this.setupImages();
		this.setupVideos();
		this.mobilifyTables();
		return WINDOW.resize((function(_this) {
			return function() {
				_this.setupVideos();
				return _this.mobilifyTables();
			};
		})(this));
	};

	RTEView.prototype.setupImages = function() {
		var images;
		images = this.rte.find('p > img');
		return images.imagesLoaded(function() {
			var image, j, len, results;
			results = [];
			for (j = 0, len = images.length; j < len; j++) {
				image = images[j];
				image = $(image);
				results.push(image.wrap('<div class="image-wrap">'));
			}
			return results;
		});
	};

	RTEView.prototype.setupVideos = function() {
		var aspectRatio, contentWidth, j, len, results, video, videos;
		videos = this.rte.not(".special").find('iframe, embed, object');
		contentWidth = this.rte.width();
		results = [];
		for (j = 0, len = videos.length; j < len; j++) {
			video = videos[j];
			video = $(video);
			aspectRatio = video.height() / video.width();
			results.push(video.css({
				width: contentWidth,
				height: contentWidth * aspectRatio
			}));
		}
		return results;
	};

	RTEView.prototype.switchTabs = function(e) {
		var aspectRatio, content, contentWidth, j, len, position, tab, tabContainer, tabContentContainer, video, videos;
		tab = $(e.currentTarget);
		tabContainer = tab.parent();
		tabContentContainer = tabContainer.next();
		position = tab.index();
		content = tabContentContainer.find('> li').eq(position);
		tabContainer.find('> li').removeClass('active');
		tabContentContainer.find('> li').removeClass('active');
		tab.addClass('active');
		content.addClass('active');
		videos = content.find('iframe, embed, object');
		contentWidth = content.width();
		for (j = 0, len = videos.length; j < len; j++) {
			video = videos[j];
			video = $(video);
			aspectRatio = video.height() / video.width();
			video.css({
				width: contentWidth,
				height: contentWidth * aspectRatio,
				visibility: 'visible'
			});
		}
		return false;
	};

	RTEView.prototype.setupTabs = function() {
		var tabs, tabsContent;
		tabs = this.rte.find('.tabs');
		tabsContent = this.rte.find('.tabs-content');
		if (this.rte.find(':first-child').hasClass('tabs')) {
			this.rte.parent().addClass('no-border');
		}
		tabs.find('li:first').addClass('active');
		return tabsContent.find('li:first').addClass('active');
	};

	RTEView.prototype.mobilifyTables = function() {
		return this.$('table').mobileTable();
	};

	return RTEView;

})(Backbone.View);

ProductView = (function(superClass) {
	extend(ProductView, superClass);

	function ProductView() {
		this.onScroll = bind(this.onScroll, this);
		return ProductView.__super__.constructor.apply(this, arguments);
	}

	ProductView.prototype.initialize = function() {
		this.sectionBinding();
		this.initializedClass = 'product-initialized';
		return this._validate();
	};

	ProductView.prototype._validate = function() {
		var $productJSON, $productSettings, isInitialized;
		this.window = $(window);
		this.productArea = $('#product-area', this.$el);
		this.fullscreenViewer = $('.fullscreen-product-viewer');
		this.fullscreenModal = this.fullscreenViewer.find('.modal');
		this.thumbsCount = this.productArea.find('.thumb').length;
		this.productId = this.productArea.data('product-id');
		this.productZoom = $('.product-zoom');
		this.product = Theme.products[this.productId];
		this.variants = this.product.variants;
		isInitialized = this.$el.hasClass(this.initializedClass);
		this.productImages = this.productArea.find(".product-images");
		this.productMainImage = $('.product-main-image', this.$el);
		this.zoomArea = this.$(".product-zoom");
		this.productDetailsWrapper = this.productArea.find(".product-details-wrapper");
		this.productDetails = this.productArea.find(".product-details");
		this.$productForm = $(".product-form");
		this.formID = parseInt(this.$productForm.attr('data-product-form'), 10);
		this.productSelect = "#product-select-" + this.formID;
		this.$priceArea = $('.product-details .price', this.productArea);
		this.$addToCartButton = $(".submit-wrapper input", this.productArea);
		this.$productThumbnails = $('.product-images .thumb img', this.productArea);
		$productJSON = $("[data-product-json-" + this.formID + "]", this.productArea);
		$productSettings = $("[data-product-settings-" + this.formID + "]", this.productArea);
		this.productJSON = JSON.parse($productJSON.text());
		this.productSettings = JSON.parse($productSettings.text());
		this.$variantDropdowns = $("[data-option-select=" + this.formID + "]", this.productArea);
		this.options = this.productJSON.options;
		this.variants = this.productJSON.variants;
		this.selectedThumbIndex = 0;
		this.processing = false;
		if (this.productZoom.length) {
			this.productMainImage.imagesLoaded((function(_this) {
				return function() {
					return _this.prepareZoom();
				};
			})(this));
		}
		this.setupVariants();
		this.twitterSharing();
		this.googlePlusSharing();
		this.fullscreenViewer.find('.showcase .container').spin('small');
		this.transitionend = (function(transition) {
			var transEndEventNames;
			transEndEventNames = {
				"-webkit-transition": "webkitTransitionEnd",
				"-moz-transition": "transitionend",
				"-o-transition": "oTransitionEnd",
				transition: "transitionend"
			};
			return transEndEventNames[transition];
		})(Modernizr.prefixed("transition"));
		WINDOW.resize((function(_this) {
			return function() {
				return _this.resize();
			};
		})(this));
		Shopify.onError = (function(_this) {
			return function(XMLHttpRequest) {
				return _this.handleErrors(XMLHttpRequest);
			};
		})(this);
		if (this.productImages.attr('data-thumb-orientation') === 'list') {
			this.window.on("load resize", window.themeUtils.debounce(this.setupProductDetails, 100));
			return this.window.on("scroll", window.themeUtils.debounce(this.onScroll, 10));
		}
	};

	ProductView.prototype.sectionBinding = function() {
		this.$el.on('shopify:section:load', (function(_this) {
			return function(event) {
				if (!$(event.target).hasClass('section-product')) {
					return;
				}
				_this.delegateEvents();
				return _this._validate();
			};
		})(this));
		return this.$el.on('shopify:section:unload', (function(_this) {
			return function(event) {
				if (!$(event.target).hasClass('section-product')) {
					return;
				}
				return _this.undelegateEvents();
			};
		})(this));
	};

	ProductView.prototype.setupVariants = function() {
		var dropdownSettings, j, label, labels, len, variantHelperDefaults, width;
		variantHelperDefaults = {
			$addToCartButton: this.$addToCartButton,
			$priceFields: this.$priceArea,
			$productForm: this.$productForm,
			$productThumbnails: this.$productThumbnails,
			formID: this.formID,
			productSettings: this.productSettings,
			productJSON: this.productJSON
		};

		if (this.$variantDropdowns.length) {
			dropdownSettings = {
				$selector: this.$variantDropdowns,
				type: 'select'
			};
			dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
			this.variantHelpers = new VariantHelper(dropdownSettings);
		}
		labels = this.productArea.find('.inline-field-wrapper > label');
		if (labels.length > 1) {
			width = 0;
			for (j = 0, len = labels.length; j < len; j++) {
				label = labels[j];
				if (($(label)).width() > width) {
					width = ($(label)).width();
				}
			}
			return labels.width(width);
		}
	};

	ProductView.prototype.onScroll = function() {
		if (document.documentElement.offsetWidth > 770 && document.documentElement.clientHeight > this.detailsHeight) {
			return this.positionProductInfo(this.stickyNavHeight, this.detailsWrapperOffset, this.detailsHeight);
		} else {
			return this.productDetails.css("position", "static");
		}
	};

	ProductView.prototype.events = {
		"click #product-area .thumb": "determineSelectedThumb2",
		"click .fullscreen-product-viewer .thumb": "determineSelectedThumb2",
		"click .toggle-fullview": "openFullview",
		"click .fullscreen-product-viewer": "closeFullview",
		"click .fullscreen-product-viewer .modal": "stopProp",
		"click #product-area .submit": "addProductToCart",
		"click .modal-wrap .close": "closeFullview",
		"change #product-area .single-option-selector": "resetErrors",
		"prepare-zoom": "prepareZoom",

		// Shinee. Disabling zoom
		"click .product-main-image.zoom-enabled": "toggleZoom",
		"mouseout .product-zoom": "toggleZoom",
		"mousemove .product-zoom": "zoomImage",

		"click .slider-for .slick-slide" : "determineSelectedThumb2",
		"click .slider-nav .slick-slide" : "determineSelectedThumb2",
	};

	ProductView.prototype.resize = function() {
		this.formatTheModal();
		return this.resizeShowcase();
	};

	ProductView.prototype.stopProp = function(e) {
		return e.stopPropagation();
	};

	ProductView.productImages = $('.product-images');

	if (ProductView.productImages.attr('data-thumb-orientation') === 'list') {

		({
			setupProductDetails: function() {
				ProductView.mainHeaderWrap = $('.main-header-wrap');
				ProductView.productDetails.width(ProductView.productDetailsWrapper.width());
				if (ProductView.mainHeaderWrap.attr('data-header-format') !== 'minimal') {
					ProductView.stickyNavHeight = 0;
					ProductView.detailsWrapperOffset = ProductView.productDetailsWrapper.offset().top - ProductView.stickyNavHeight;
					ProductView.detailsHeight = ProductView.productDetails.outerHeight(true) + ProductView.stickyNavHeight;
				} else {
					ProductView.stickyNavHeight = $(".header-minimal").outerHeight(true);
					ProductView.detailsWrapperOffset = ProductView.productDetailsWrapper.offset().top;
					ProductView.detailsHeight = ProductView.productDetails.outerHeight(true);
				}
				return ProductView.onScroll();
			}
		});
	}

	ProductView.prototype.positionProductInfo = function(stickyNavHeight, detailsWrapperOffset, detailsHeight) {

		var detailsBottom, detailsTop, diff, imagesBottom, makeAbsolute, makeFixed, makeStatic, productTop, scrollTop;
		scrollTop = this.window.scrollTop() + stickyNavHeight;
		detailsTop = this.productDetails.offset().top;
		detailsBottom = detailsTop + detailsHeight;
		imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);
		productTop = $('#product-area').offset().top;
		diff = scrollTop - productTop;
		if (this.productDetails.outerHeight() >= this.productImages.outerHeight(true)) {
			return;
		}
		makeStatic = (function(_this) {
			return function() {
				return _this.productDetails.css({
					"position": "static",
					"bottom": "",
					"top": ""
				});
			};
		})(this);
		makeAbsolute = (function(_this) {
			return function() {
				return _this.productDetails.css({
					"position": "absolute",
					"bottom": 0 + _this.productArea.css('padding-bottom'),
					"top": "auto"
				});
			};
		})(this);
		makeFixed = (function(_this) {
			return function() {
				return _this.productDetails.css({
					"position": "fixed",
					"top": stickyNavHeight,
					"bottom": ""
				});
			};
		})(this);
		detailsBottom = this.productDetails.offset().top + detailsHeight;
		imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);
		if (detailsWrapperOffset - scrollTop >= 0) {
			makeStatic();
			return;
		}
		if ((this.productImages.offset().top < scrollTop) && ((detailsTop - scrollTop) > 0)) {
			makeFixed();
			return;
		}
		if (!((detailsBottom + 1) >= imagesBottom && imagesBottom < (scrollTop + this.window.height()))) {
			return makeFixed();
		} else {
			return makeAbsolute();
		}
	};

	ProductView.prototype.handleErrors = function(error) {
		var max, message, target, variant, variantID;
		error = $.parseJSON(error.responseText);
		if (error.message === "Cart Error") {
			variantID = parseInt(this.$(".product-select").val(), 10);
			if (this.product.variants.length === 1) {
				max = this.product.variants[0].inventory_quantity;
			} else {
				target = (function() {
					var j, len, ref, results;
					ref = this.product.variants;
					results = [];
					for (j = 0, len = ref.length; j < len; j++) {
						variant = ref[j];
						if (variant.id === variantID) {
							results.push(variant);
						}
					}
					return results;
				}).call(this);
				max = target[0].inventory_quantity;
			}
			message = Theme.errorStock.replace("--stock--", max);
		} else {
			message = Theme.errorGeneral.replace("--stock--", max);
		}
		this.$(".product-form").append("<div class='error-message'>" + message + "</div>");
		return this.$(".product-form .submit").val(error.message);
	};

	ProductView.prototype.resetErrors = function() {
		this.$(".error-message").remove();
		return this.processing = false;
	};

	ProductView.prototype.addProductToCart = function(e) {

		console.log('addProductToCart');

		var quantity, submitButton, variant;
		if (this.productDetails.attr('data-product-quick-add') === 'true') {
			e.preventDefault();

			submitButton = getSubmitButton();

			if (this.processing === false) {
				submitButton.data("original-text", submitButton.val()).val(get_please_wait()).addClass("disabled");
				this.processing = true;
				variant = this.$(".product-select").val();
				quantity = this.$(".product-quantity").val();

				console.log($('#po-prompt').val());
				return Shopify.addItemFromForm('product-form', (function(_this) {
					return function(product) {
						Shopify.getCart(function(cart) {
							return _this.updateMiniCart(cart);
						});

						//             submitButton.val(Theme.addedToCart);

						return setTimeout(function() {

							submitButton.val(get_add_to_cart()).removeClass("disabled").prop('disabled',false);

							return _this.processing = false;
						}, 2000);
					};
				})(this));
			} else {
				return false;
			}
		}
		else{
			// Enkomion. Disable redirection to cart when clicking "add to cart" and add text "added" instead
			// https://trello.com/c/hXDrmt1B/136-disable-redirection-to-cart-when-clicking-add-to-cart-and-add-text-added-instead
			e.preventDefault();
			//       submitButton = this.$(e.target);

			submitButton = getSubmitButton();

			var it = this;

			console.log('Part 2');

			if (it.processing === false) {

				if(submitButton.hasClass('disabled')){
					return false;
				}

				if(!$.enkValidateDropdowns()){
					return false;
				}

				//         if(submitButton.val() != get_pre_order() && submitButton.val() != get_add_to_cart() ){
				if(submitButton.val() != get_pre_order() &&
				(submitButton.val() != 'In den Warenkorb' && submitButton.val() != 'Add to Cart' && submitButton.val() != 'Ajouter (au panier)' &&
				submitButton.val() != 'Pré-commande'))
				{
					return false;
				}

				$('.added-product-notice').hide();

				submitButton.data("original-text", submitButton.val()).val(get_please_wait()).addClass("disabled");

				it.processing = true;

				var existing = false;
				var variant = this.$(".product-select").val();
				var quantity = this.$(".product-quantity").val();
				var new_prompt = $('#prompt2').html();

				Shopify.getCart(function(cart) {

					for(var i = 0; i < cart.items.length; i++){
						var item = cart.items[i];
						if(item.id == parseFloat(variant)){
							existing = true;
							var new_qty = item.quantity + parseFloat(quantity);

							if(new_prompt.length == 0){
								CartJS.updateItem(i + 1, new_qty);
							}
							else{
								CartJS.updateItem(i + 1, new_qty , {
									"PreOrder": new_prompt
								},{
									"success": function(data, textStatus, jqXHR) {
									}})
								}
							}
						};

						if($('#preorder-me-msg').is(':visible'))
							$('#preorder-me-msg').html('');


						if(existing){

							var SV = new QuickShopView;
							SV.updateMiniCart(cart);

							setTimeout(function() {

								submitButton.val(submitButton.data("original-text")).removeClass('disabled').prop('disabled',false);

								$('.added-product-notice').show();
								$('.mini-cart-wrap').trigger('click');
								return it.processing = false;

							}, 2000);
						}
						else{
							return Shopify.addItemFromForm('product-form', (function(_this) {

								return function(product) {
									Shopify.getCart(function(cart) {
										var SV = new QuickShopView;
										$('.mini-cart-wrap').trigger('click');
										return SV.updateMiniCart(cart);
									});

									return setTimeout(function() {

										submitButton.val(submitButton.data("original-text")).removeClass('disabled').prop('disabled',false);

										$('.added-product-notice').show();

										return it.processing = false;

									}, 2000);
								};
							})(it));
						}


					});

				} else {
					return false;
				}
			}

		};

		ProductView.prototype.updateMiniCart = function(cart) {

			console.log('updateMiniCart');

			var i, item, itemProperties, itemText, j, len, miniCartItemsWrap, productPrice, propertiesArray, propertyKeysArray, ref, variant;
			miniCartItemsWrap = $(".mini-cart-items-wrap");
			miniCartItemsWrap.empty();
			if (cart.item_count !== 1) {
				itemText = Theme.cartItemsOther;
			} else {
				itemText = Theme.cartItemsOne;
				$(".mini-cart .options").show();
				miniCartItemsWrap.find(".no-items").hide();
			}

			$(".mini-cart-wrap > label").html("<span class='item-count'>" + cart.item_count + "</span> " + itemText);

			$("#mobile-malaika-header .nav-item.cart .count").html("<span>" + cart.item_count + "</span> ");

			ref = cart.items;

			console.log('Log 1');
			console.log('here 21');

			for (j = 0, len = ref.length; j < len; j++) {
				item = ref[j];

				var isGrouped = false;
				var groupedURL;

				console.log('Log 2');
				console.log(item);
				productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
				variant = item.variant_title ? "<p class='variant'>" + item.variant_title + "</p>" : "";
				itemProperties = "";
				if (item.properties) {
					propertyKeysArray = Object.keys(item.properties);
					propertiesArray = _.values(item.properties);
					i = 0;
					while (i < propertyKeysArray.length) {

						//           if (propertiesArray[i].length) {
						//             itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
						//           }

						if(propertyKeysArray[i] == "_grouped_url" || propertyKeysArray[i] == "_grouped"){
							isGrouped = true;
							groupedURL = propertiesArray[i];
						}
						else{
							itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
						}
						i++;
					}
				}

				var itemURL = item.url;

				if(isGrouped == true){
					itemURL = groupedURL;
				}

				//       miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" data-product_id=\"" + item.product_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + item.url + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + item.url + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
				miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" data-product_id=\"" + item.product_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + itemURL + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + itemURL + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
			}

			$('.mini-cart-wrap').trigger('click');

			if (Theme.currencySwitcher) {
				return $(document.body).trigger("switch-currency");
			}
		};

		ProductView.prototype.resizeShowcase = function() {
			var container, imgHeight;
			container = this.productArea.find('.container');
			imgHeight = container.find('img').height();
			if (this.productImages.attr('data-thumb-orientation') !== 'list') {
				return container.height(imgHeight);
			}
		};

		ProductView.prototype.openFullview = function(e) {
			BODY.css({
				'overflow': 'hidden'
			});
			this.fullscreenViewer.show();
			this.formatTheModal();
			if (!$('html').hasClass('lt-ie9')) {
				this.fullscreenViewer.fadeTo(300, 1, (function(_this) {
					return function() {
						_this.parent = _this.fullscreenModal;
						if (_this.thumbsCount > 0) {
							return _this.updateProductShowcase();
						}
					};
				})(this));
			} else {
				this.parent = this.fullscreenModal;
				if (this.thumbsCount > 0) {
					this.updateProductShowcase();
				}
			}
			$(document).bind('keyup', (function(_this) {
				return function(e) {
					if (e.keyCode === 27) {
						return _this.closeFullview();
					}
				};
			})(this));
			return false;
		};

		ProductView.prototype.closeFullview = function(e) {
			if ((e == null) || e.target === e.currentTarget) {
				if (!$('html').hasClass('lt-ie9')) {
					this.fullscreenViewer.fadeTo(300, 0, (function(_this) {
						return function() {
							_this.parent = _this.productArea;
							if (_this.thumbsCount > 0) {
								_this.updateProductShowcase();
							}
							_this.fullscreenViewer.hide();
							return BODY.css({
								'overflow': 'auto'
							});
						};
					})(this));
				} else {
					this.parent = this.productArea;
					if (this.thumbsCount > 0) {
						this.updateProductShowcase();
					}
					this.fullscreenViewer.hide();
					BODY.css({
						'overflow': 'auto'
					});
				}
				return $(document).unbind('keyup');
			}
		};

		ProductView.prototype.formatTheModal = function() {
			var container, imgHeight;
			container = this.fullscreenModal.find('.container');
			imgHeight = container.find('img').height();
			container.height(imgHeight);
			this.scroller = this.fullscreenViewer.find('.pager').antiscroll({
				autoHide: false
			}).data('antiscroll');
			this.fullscreenViewer.find('.pager').height(imgHeight).one(this.transitionend, (function(_this) {
				return function(e) {
					$('.antiscroll-inner').css('width','auto');
					return _this.scroller.refresh();
				};
			})(this));
			return container.imagesLoaded((function(_this) {
				return function() {
					return _this.verticallyAlignModal();
				};
			})(this));
		};

		ProductView.prototype.verticallyAlignModal = function(imageHeight) {
			var modalHeight, offset, windowHeight;
			windowHeight = WINDOW.height();
			if (imageHeight) {
				modalHeight = imageHeight + 118;
			} else {
				modalHeight = this.fullscreenModal.outerHeight();
			}
			if (windowHeight <= modalHeight) {
				return this.fullscreenModal.css({
					'margin-top': 0
				});
			} else {
				offset = (windowHeight - modalHeight) / 2;
				this.fullscreenModal.css({
					'margin-top': offset
				});
				return window.setTimeout(function() {
					return $('.fullscreen-product-viewer .modal').addClass('transitions-are-go');
				}, 50);
			}
		};

		ProductView.prototype.determineSelectedThumb = function(e) {

			this.selectedThumbIndex = ($(e.currentTarget)).index();

			if (this.fullscreenViewer.is(":visible")) {
				this.parent = this.$('.modal-wrap');
			} else {
				this.parent = this.productArea;
			}

			return this.updateProductShowcase();
		};

		ProductView.prototype.determineSelectedThumb2 = function(e) {

			this.selectedThumbIndex = ($(e.currentTarget)).index();
			//     this.selectedThumbIndex -= 6;

			if (this.fullscreenViewer.is(":visible")) {
				this.parent = this.$('.modal-wrap');
			} else {
				this.parent = this.productArea;
			}

			return this.updateProductShowcase();
		};

		ProductView.prototype.updateProductShowcase = function() {
			var activeThumb, animationSpeed, img, selectedImg, selectedThumb, showcaseContainer, showcaseImage, showcaseWrap, src;
			showcaseContainer = this.parent.find('.showcase .container');
			showcaseWrap = showcaseContainer.find('.wrap');
			showcaseImage = showcaseContainer.find('img');
			//     showcaseContainer.height(showcaseImage.height());
			activeThumb = this.parent.find('.thumb.active');
			selectedThumb = this.parent.find('.thumb').eq(this.selectedThumbIndex);
			selectedImg = selectedThumb.find('img');
			src = selectedImg.data('high-res-url');

			if (this.selectedThumbIndex !== activeThumb.index()) {
				img = new Image();
				img.src = src;
				img = $(img);
				animationSpeed = 200;

				if(!$(showcaseWrap).hasClass('weit')){

					if(showcaseWrap.height() < img.height()){
						$newHeight = showcaseWrap.height();
						animationSpeed = 0;
					}
				}

				return showcaseWrap.fadeTo(animationSpeed, 0, (function(_this) {
					return function() {
						showcaseImage.remove();
						return img.imagesLoaded(function() {

							showcaseWrap.append(img).trigger("prepare-zoom");

							showcaseContainer.animate({
								//               height: img.height()
							}, animationSpeed, 'linear', function() {
								activeThumb.removeClass('active');
								selectedThumb.addClass('active');
								return showcaseWrap.fadeTo(animationSpeed, 1);
							});

							if (_this.fullscreenViewer.is(":visible")) {
								_this.verticallyAlignModal(img.height());
								return _this.fullscreenViewer.find('.pager').height(img.height()).one(_this.transitionend, function(e) {

									_this.fullscreenViewer.find('.showcase > .container').height('auto');

									return _this.scroller.refresh();
								});
							}
						});
					};
				})(this));
			}
		};

		ProductView.prototype.prepareZoom = function() {
			var newZoomImage, photoAreaHeight, photoAreaWidth;
			photoAreaWidth = this.productMainImage.width();
			photoAreaHeight = this.productMainImage.height();
			newZoomImage = new Image();
			$(newZoomImage).on("load", (function(_this) {
				return function() {
					var ratio, ratios;
					_this.zoomImageWidth = newZoomImage.width;
					_this.zoomImageHeight = newZoomImage.height;
					ratios = new Array();
					ratios[0] = _this.zoomImageWidth / photoAreaWidth;
					ratios[1] = _this.zoomImageHeight / photoAreaHeight;
					ratio = Math.max.apply(Math, ratios);
					if (ratio < 1.4) {
						_this.productMainImage.removeClass("zoom-enabled");
					} else {
						_this.productMainImage.addClass("zoom-enabled");
						return _this.zoomArea.css({
							backgroundImage: "url(" + newZoomImage.src + ")"
						});
					}
				};
			})(this));
			return newZoomImage.src = this.$(".product-images img").attr("src");
		};

		ProductView.prototype.toggleZoom = function(e) {
			if (this.productMainImage.hasClass("zoom-enabled")) {

				// Shinee disabling zoom on desktop
				if (window.matchMedia("(max-width: 720px)").matches) {
				}
				else{
					return false;
				}

				if (e.type === "mouseout") {
					this.zoomArea.removeClass("active");
					return;
				}
				this.zoomArea.toggleClass("active");
				return this.zoomImage(e);
			}
		};

		ProductView.prototype.zoomImage = function(e) {

			var bigImageOffset, bigImageX, bigImageY, mousePositionX, mousePositionY, newBackgroundPosition, ratioX, ratioY, zoomHeight, zoomWidth;
			zoomWidth = this.zoomArea.width();
			zoomHeight = this.zoomArea.height();
			bigImageOffset = this.productMainImage.offset();
			bigImageX = Math.round(bigImageOffset.left);
			bigImageY = Math.round(bigImageOffset.top);
			mousePositionX = e.pageX - bigImageX;
			mousePositionY = e.pageY - bigImageY;
			if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
				if (this.zoomArea.hasClass("active")) {
					ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
					ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;
					if (ratioX > 0) {
						ratioX = 0;
					}
					if (ratioY > 0) {
						ratioY = 0;
					}
					if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
						ratioX = -(this.zoomImageWidth - zoomWidth);
					}
					if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
						ratioY = -(this.zoomImageHeight - zoomHeight);
					}
					newBackgroundPosition = ratioX + "px " + ratioY + "px";
					return this.zoomArea.css({
						backgroundPosition: newBackgroundPosition
					});
				}
			}
		};

		ProductView.prototype.twitterSharing = function() {
			return !(function(d, s, id) {
				var js, p, twitterjs;
				js = void 0;
				twitterjs = d.getElementsByTagName(s)[0];
				p = /^http:/.test(d.location) ? 'http' : 'https';
				if (!d.getElementById(id)) {
					js = d.createElement(s);
					js.id = id;
					js.src = p + '://platform.twitter.com/widgets.js';
					twitterjs.parentNode.insertBefore(js, twitterjs);
				} else {
					twttr.widgets.load();
				}
			})(document, 'script', 'twitter-wjs');
		};

		ProductView.prototype.googlePlusSharing = function() {
			return !(function(d, s, id) {
				var googlejs, js;
				js = void 0;
				googlejs = d.getElementsByTagName(s)[0];
				if (!d.getElementById(id)) {
					js = d.createElement(s);
					js.type = 'text/javascript';
					js.async = true;
					js.src = 'https://apis.google.com/js/plusone.js';
					googlejs.parentNode.insertBefore(js, googlejs);
				}
			})(document, 'script', 'google-wjs');
		};

		ProductView.prototype.update = function($el) {
			this.$el = $el;
			return this._validate();
		};

		return ProductView;

	})(Backbone.View);

	SharingWidgetView = (function(superClass) {
		extend(SharingWidgetView, superClass);

		function SharingWidgetView() {
			return SharingWidgetView.__super__.constructor.apply(this, arguments);
		}

		SharingWidgetView.prototype.initialize = function() {
			this.sectionBinding();
			return this.validate();
		};

		SharingWidgetView.prototype.validate = function() {
			this.twitterSharing();
			return this.googlePlusSharing();
		};

		SharingWidgetView.prototype.twitterSharing = function() {
			return !(function(d, s, id) {
				var js, p, twitterjs;
				js = void 0;
				twitterjs = d.getElementsByTagName(s)[0];
				p = /^http:/.test(d.location) ? 'http' : 'https';
				if (!d.getElementById(id)) {
					js = d.createElement(s);
					js.id = id;
					js.src = p + '://platform.twitter.com/widgets.js';
					twitterjs.parentNode.insertBefore(js, twitterjs);
				} else {
					twttr.widgets.load();
				}
			})(document, 'script', 'twitter-wjs');
		};

		SharingWidgetView.prototype.googlePlusSharing = function() {
			return !(function(d, s, id) {
				var googlejs, js;
				js = void 0;
				googlejs = d.getElementsByTagName(s)[0];
				if (!d.getElementById(id)) {
					js = d.createElement(s);
					js.type = 'text/javascript';
					js.async = true;
					js.src = 'https://apis.google.com/js/plusone.js';
					googlejs.parentNode.insertBefore(js, googlejs);
				}
			})(document, 'script', 'google-wjs');
		};

		SharingWidgetView.prototype.sectionBinding = function() {
			this.$el.on('shopify:section:load', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-article')) {
						return;
					}
					_this.delegateEvents();
					return _this.validate();
				};
			})(this));
			return this.$el.on('shopify:section:unload', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-article')) {
						return;
					}
					return _this.undelegateEvents();
				};
			})(this));
		};

		return SharingWidgetView;

	})(Backbone.View);

	CartView = (function(superClass) {
		extend(CartView, superClass);

		function CartView() {
			return CartView.__super__.constructor.apply(this, arguments);
		}

		CartView.prototype.events = {
			'change .quantity .field': 'updateQuantity',
			'change .instructions textarea': 'saveNote',
			'click .get-rates': 'calculateShipping',
			'keydown #address_zip': 'calculateShipping'
		};

		CartView.prototype.initialize = function() {
			this.sectionBinding();
			return this.render();
		};

		CartView.prototype.render = function() {
			var error;
			this.cartForm = this.$("#cart-form");
			this.$shippingStrings = this.$('[data-shipping-calculator-strings]');
			this.shippingContext = {};
			if (this.$shippingStrings.length) {
				try {
					this.shippingContext = JSON.parse(this.$shippingStrings.text());
				} catch (error1) {
					error = error1;
					console.log('No shipping localisations found, unable to continue.');
				}
				if (this.shippingContext == null) {
					return;
				}
				if (this.$('[data-cart-item]').length) {
					this.shippingCalculator();
				}
			}
			return Shopify.onError = (function(_this) {
				return function(XMLHttpRequest) {
					return _this.handleErrors(XMLHttpRequest);
				};
			})(this);
		};

		CartView.prototype.sectionBinding = function() {
			this.$el.on('shopify:section:load', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-cart')) {
						return;
					}
					_this.delegateEvents();
					return _this.render();
				};
			})(this));
			return this.$el.on('shopify:section:unload', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-cart')) {
						return;
					}
					return _this.undelegateEvents();
				};
			})(this));
		};

		CartView.prototype.updateQuantity = function(e) {
			var id, input, quantity, url;
			input = $(e.currentTarget);
			quantity = input.val();
			id = input.data('id');
			url = "/cart/change/" + id + "?quantity=" + quantity;

			//     return window.location = url;
		};

		CartView.prototype.saveNote = function() {
			var newNote;
			newNote = $('.instructions textarea').val();
			return Shopify.updateCartNote(newNote, function(cart) {});
		};

		CartView.prototype.shippingCalculator = function() {
			return Shopify.Cart.ShippingCalculator.show({
				submitButton: this.shippingContext.submitButton,
				submitButtonDisabled: this.shippingContext.submitButtonDisabled,
				customerIsLoggedIn: this.shippingContext.customerIsLoggedIn,
				moneyFormat: this.shippingContext.moneyFormat
			});
		};

		CartView.prototype.calculateShipping = function(e) {
			var shippingAddress;
			if (e && e.type === 'keydown') {
				if (e.keyCode === 13) {
					e.preventDefault();
					$('.wrapper-response').empty();
				} else {
					return;
				}
			}
			shippingAddress = {};
			shippingAddress.zip = $('.address-zip').val() || '';
			shippingAddress.country = $('.address-country').val() || '';
			shippingAddress.province = $('.address-province').val() || '';
			return Shopify.getCartShippingRatesForDestination(shippingAddress, (function(_this) {
				return function() {
					var address, firstRate, j, len, multipleShippingRates, oneShippingRate, price, rate, rateValues, ratesFeedback, results;
					address = shippingAddress.zip + ", " + shippingAddress.province + ", " + shippingAddress.country;
					if (!shippingAddress.province.length) {
						address = shippingAddress.zip + ", " + shippingAddress.country;
					}
					if (!shippingAddress.zip.length) {
						address = shippingAddress.province + ", " + shippingAddress.country;
					}
					if (!(shippingAddress.province.length && shippingAddress.zip.length)) {
						address = shippingAddress.country;
					}
					$('.wrapper-response').empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
					ratesFeedback = $('.shipping-calculator-response');
					if (rates.length > 1) {
						firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
						multipleShippingRates = Theme.shippingCalcMultiRates.replace('--address--', address).replace('--number_of_rates--', rates.length).replace('--rate--', "<span class='money'>" + firstRate + "</span>");
						ratesFeedback.html(multipleShippingRates);
					} else if (rates.length === 1) {
						oneShippingRate = Theme.shippingCalcOneRate.replace('--address--', address);
						ratesFeedback.html(oneShippingRate);
					} else {
						ratesFeedback.html(Theme.shippingCalcNoRates);
					}
					results = [];
					for (j = 0, len = rates.length; j < len; j++) {
						rate = rates[j];
						price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
						rateValues = Theme.shippingCalcRateValues.replace('--rate_title--', rate.name).replace('--rate--', "<span class='money'>" + price + "</span>");
						results.push($('.shipping-rates').append("<li>" + rateValues + "</li>"));
					}
					return results;
				};
			})(this));
		};

		CartView.prototype.handleErrors = function(errors) {
			var errorMessage;
			console.log(errors);
			errorMessage = $.parseJSON(errors.responseText);
			errorMessage = Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
			return $('.wrapper-response').html("<p class='message'>" + errorMessage + "</p>");
		};

		return CartView;

	})(Backbone.View);

	ListCollectionsView = (function(superClass) {
		extend(ListCollectionsView, superClass);

		function ListCollectionsView() {
			return ListCollectionsView.__super__.constructor.apply(this, arguments);
		}

		ListCollectionsView.prototype.initialize = function() {
			setTimeout(((function(_this) {
				return function() {
					return _this.verticallyAlign();
				};
			})(this)), 500);
			return WINDOW.resize((function(_this) {
				return function() {
					return _this.verticallyAlign();
				};
			})(this));
		};

		ListCollectionsView.prototype.verticallyAlign = function() {
			var collection, j, label, labels, len, ref, results;
			ref = $('.collection');
			results = [];
			for (j = 0, len = ref.length; j < len; j++) {
				collection = ref[j];
				labels = ($(collection)).find('h2');
				results.push((function() {
					var l, len1, results1;
					results1 = [];
					for (l = 0, len1 = labels.length; l < len1; l++) {
						label = labels[l];
						results1.push(($(label)).css({
							marginTop: ($(label)).height() / -2
						}).removeClass('preload'));
					}
					return results1;
				})());
			}
			return results;
		};

		return ListCollectionsView;

	})(Backbone.View);

	CollectionView = (function(superClass) {
		extend(CollectionView, superClass);

		function CollectionView() {
			return CollectionView.__super__.constructor.apply(this, arguments);
		}

		CollectionView.prototype.el = $('.template-collection');

		CollectionView.prototype.events = {
			'change #sort-by': 'sortDropDown'
		};

		CollectionView.prototype.initialize = function() {
			this.titleContainer = $('.page-title');
			this.title = this.titleContainer.find('.label');
			this.tagsWrap = $('.tags-wrap');
			this.tags = this.tagsWrap.find('.tags');
			this.tagsWrap.removeClass('preload');
			this.tagFilters();
			return this.setSortDropdown();
		};

		CollectionView.prototype.setSortDropdown = function() {
			var urlParam;
			urlParam = new RegExp('[\?&]' + 'sort_by' + '=([^&#]*)').exec(window.location.href);
			if (urlParam && urlParam[1]) {
				return $('#sort-by').val(urlParam[1]);
			}
		};

		CollectionView.prototype.sortDropDown = function(e) {
			var aCouples, aKeyValue, i;
			Shopify.queryParams = {};
			if (location.search.length) {
				aKeyValue = void 0;
				i = 0;
				aCouples = location.search.substr(1).split('&');
				while (i < aCouples.length) {
					aKeyValue = aCouples[i].split('=');
					if (aKeyValue.length > 1) {
						Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
					}
					i++;
				}
			}
			Shopify.queryParams.sort_by = $(e.currentTarget).val();
			return location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
		};

		CollectionView.prototype.tagFilters = function() {
			var collFilters;
			collFilters = $('.coll-filter');
			return collFilters.change(function() {
				var dataUrl, newTags, query;
				newTags = [];
				dataUrl = ($(this)).data('window-href');
				collFilters.each(function() {
					if (($(this)).val()) {
						return newTags.push(($(this)).val());
					}
				});
				if (newTags.length) {
					query = newTags.join('+');
					return window.location.href = dataUrl + '/' + query;
				} else {
					return window.location.href = dataUrl;
				}
			});
		};

		return CollectionView;

	})(Backbone.View);

	QuickShopView = (function(superClass) {
		extend(QuickShopView, superClass);

		function QuickShopView() {
			return QuickShopView.__super__.constructor.apply(this, arguments);
		}

		QuickShopView.prototype.el = $('.quick-shop');

		QuickShopView.prototype.events = {
			'click': 'close',
			'click .close-modal': 'close',
			'click .quick-shop-modal .thumb': 'updateQuickShopShowcase',
			'click .quick-shop-modal .submit:not(.disabled)': 'addToCart',
		};

		QuickShopView.prototype.initialize = function() {
			this.quickShop = $('.quick-shop');
			this.quickShopModal = this.quickShop.find('.quick-shop-modal');
			this.errorWrap = $('.error-wrap');
			$('.product-inner [data-quickshop-id]').click((function(_this) {
				return function(e) {
					return _this.open(e);
				};
			})(this));
			this.verticallyAlignTriggers();
			return WINDOW.resize((function(_this) {
				return function() {
					_this.formatTheModal();
					_this.setupVideos();
					return _this.verticallyAlignTriggers();
				};
			})(this));
		};

		QuickShopView.prototype.verticallyAlignTriggers = function() {
			var j, label, len, ref, results;
			ref = $('.product-inner .label');
			results = [];
			for (j = 0, len = ref.length; j < len; j++) {
				label = ref[j];
				results.push(($(label)).css({
					marginTop: ($(label)).height() / -2
				}));
			}
			return results;
		};

		QuickShopView.prototype.formatTheModal = function() {

			var container, imgHeight, offset;
			container = this.quickShopModal.find('.container');
			imgHeight = container.find('img').height();
			container.height(imgHeight);
			if (WINDOW.height() <= $('.quick-shop-modal').outerHeight()) {
				return this.quickShopModal.css({
					'margin-top': 0
				});
			} else {
				offset = (WINDOW.height() - $('.quick-shop-modal').outerHeight()) / 2;
				return this.quickShopModal.css({
					'margin-top': offset
				});
			}
		};

		QuickShopView.prototype.setupVideos = function() {
			var aspectRatio, contentWidth, j, len, results, video, videos;
			videos = this.quickShopModal.find('.rte iframe:visible, .rte embed:visible, .rte object:visible');
			contentWidth = this.quickShopModal.find('.rte').width();
			results = [];
			for (j = 0, len = videos.length; j < len; j++) {
				video = videos[j];
				video = $(video);
				aspectRatio = video.height() / video.width();
				results.push(video.css({
					width: contentWidth,
					height: contentWidth * aspectRatio,
					visibility: 'visible'
				}));
			}
			return results;
		};

		QuickShopView.prototype.open = function(e) {
			var quickShopContent;
			e.preventDefault();
			this.itemId = ($(e.currentTarget)).data('quickshop-id');
			this.item = Theme.products[this.itemId];
			quickShopContent = $("#quick-shop-" + this.itemId);
			BODY.css({
				'overflow': 'hidden'
			});
			this.quickShop.show();
			this.quickShopModal.append(quickShopContent);
			this.setupVariants(quickShopContent);
			this.formatTheModal();
			this.setupVideos();
			if (!$('html').hasClass('lt-ie9')) {
				this.quickShop.fadeTo(200, 1);
			}
			this.quickShop.find('.showcase .container').spin('small');
			return $(document).bind('keyup', (function(_this) {
				return function(e) {
					if (e.keyCode === 27) {
						return _this.close();
					}
				};
			})(this));
		};

		QuickShopView.prototype.setupVariants = function(quickShopContent) {
			var $productJSON, $productSettings, dropdownSettings, j, label, labels, len, variantHelperDefaults, width;
			this.$quickshopForm = $(".quick-shop-form", quickShopContent);
			this.quickshopformID = parseInt(this.$quickshopForm.attr('data-quickshop-form'), 10);
			this.productSelect = "#product-select-" + this.quickshopformID;
			//     this.$priceArea = $('.product-details-wrapper .price', quickShopContent);
			this.$priceArea = $('.product-details-wrapper .price', quickShopContent, '.mobile-product-title .price');
			this.$addToCartButton = $(".selector-wrapper .submit", quickShopContent);
			this.$productThumbnails = $('.showcase .thumb img', quickShopContent);
			$productJSON = $("[data-quickshop-json-" + this.quickshopformID + "]", quickShopContent);
			$productSettings = $("[data-quickshop-settings-" + this.quickshopformID + "]", quickShopContent);
			this.productJSON = JSON.parse($productJSON.text());
			this.productSettings = JSON.parse($productSettings.text());
			this.$variantDropdowns = $("[data-option-select=" + this.quickshopformID + "]", quickShopContent);
			this.options = this.productJSON.options;
			this.variants = this.productJSON.variants;
			variantHelperDefaults = {
				$addToCartButton: this.$addToCartButton,
				$priceFields: this.$priceArea,
				$productForm: this.$quickshopForm,
				$productThumbnails: this.$productThumbnails,
				formID: this.quickshopformID,
				productSettings: this.productSettings,
				productJSON: this.productJSON
			};
			if (this.$variantDropdowns.length) {
				dropdownSettings = {
					$selector: this.$variantDropdowns,
					type: 'select'
				};
				dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);
				this.variantHelpers = new VariantHelper(dropdownSettings);
			}
			labels = quickShopContent.find('.inline-field-wrapper > label');
			if (labels.length > 1) {
				width = 0;
				for (j = 0, len = labels.length; j < len; j++) {
					label = labels[j];
					if (($(label)).width() > width) {
						width = ($(label)).width();
					}
				}
				return labels.width(width);
			}
		};

		QuickShopView.prototype.close = function(e) {
			var id, quantity, quickShopContent, submit;
			if ((e == null) || e.target === e.currentTarget) {
				submit = this.quickShopModal.find('.submit');
				quantity = this.quickShopModal.find('.product-quantity');
				quickShopContent = this.quickShopModal.find('.quick-shop-content');
				id = quickShopContent.attr('id').split('-')[2];
				$('.product-' + id).append(quickShopContent);
				if ($('html').hasClass('lt-ie9')) {
					this.quickShop.hide();
					this.quickShopModal.html('');
					BODY.css({
						'overflow': 'auto'
					});
					quantity.val('1');
				} else {
					this.quickShop.fadeTo(200, 0, (function(_this) {
						return function() {
							_this.quickShop.hide();
							_this.quickShopModal.html('');
							BODY.css({
								'overflow': 'auto'
							});
							return quantity.val('1');
						};
					})(this));
				}
				this.errorWrap.html('');
				return $(document).unbind('keyup');
			}
		};

		QuickShopView.prototype.updateQuickShopShowcase = function(e) {
			var activeThumb, img, selectedImg, selectedThumb, showcaseContainer, showcaseImage, showcaseWrap, src;
			showcaseContainer = this.quickShop.find('.showcase .container');
			showcaseWrap = showcaseContainer.find('.wrap');
			showcaseImage = showcaseContainer.find('img');
			showcaseContainer.height(showcaseImage.height());
			activeThumb = this.quickShop.find('.pager .thumb.active');
			selectedThumb = $(e.currentTarget);
			selectedImg = selectedThumb.find('img');
			src = selectedImg.data('high-res-url');
			img = new Image();
			img.src = src;
			img = $(img);
			img.removeAttr('height width');
			return showcaseWrap.fadeTo(200, 0, (function(_this) {
				return function() {
					showcaseImage.remove();
					return img.imagesLoaded(function() {
						showcaseWrap.append(img);
						return showcaseContainer.animate({
							height: img.height()
						}, function() {
							activeThumb.removeClass('active');
							selectedThumb.addClass('active');
							return showcaseWrap.fadeTo(200, 1);
						});
					});
				};
			})(this));
		};

		QuickShopView.prototype.updateMiniCart = function(cart, properties) {

			console.log('QuickShopView.prototype.updateMiniCart');

			var i, item, itemProperties, itemText, j, len, miniCartItemsWrap, productPrice, propertiesArray, propertyKeysArray, ref, variant;
			miniCartItemsWrap = $(".mini-cart-items-wrap");
			miniCartItemsWrap.empty();
			if (cart.item_count !== 1) {
				itemText = Theme.cartItemsOther;
			} else {
				itemText = Theme.cartItemsOne;
				$(".mini-cart .options").show();
				miniCartItemsWrap.find(".no-items").hide();
			}

			$(".mini-cart-wrap > label").html("<span class='item-count'>" + cart.item_count + "</span> " + itemText);

			ref = cart.items;
			for (j = 0, len = ref.length; j < len; j++) {
				item = ref[j];

				productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
				variant = item.variant_title ? "<p class='variant'>" + item.variant_title + "</p>" : "";
				itemProperties = "";
				if (item.properties) {
					propertyKeysArray = Object.keys(item.properties);
					propertiesArray = _.values(item.properties);
					i = 0;
					while (i < propertyKeysArray.length) {
						if (propertiesArray[i].length) {

							itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
						}
						i++;
					}
				}

				miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" data-product_id=\"" + item.product_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + item.url + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + item.url + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
			}
			if (Theme.currencySwitcher) {
				return $(document.body).trigger("switch-currency");
			}
		};

		QuickShopView.prototype.addToCart = function(e) {

			console.log('QuickShopView.prototype.addToCart');

			var button, imageAlt, j, l, len, len1, postToCartUrl, productFormID, properties, ref, selector, thumb, variantSelectors, variantTitle;
			if ($(".quick-shop-content").attr('data-product-quick-add') === 'true') {
				e.preventDefault();

				variantTitle = '';
				variantSelectors = this.quickShop.find('.single-option-selector');
				for (j = 0, len = variantSelectors.length; j < len; j++) {
					selector = variantSelectors[j];
					selector = $(selector);
					variantTitle += selector.val() + " / ";
				}
				variantTitle = variantTitle.substring(0, variantTitle.length - 3);
				properties = {};
				properties.variant = {};
				properties.product = {};
				properties.quantity = {};
				properties.matching_image = {};
				properties.quantity.added = this.quickShop.find('.product-quantity').val();
				properties.variant.id = this.quickShop.find('.product-select').val();
				properties.variant.title = this.quickShop.find('.product-select').data('variant-title') || variantTitle;
				properties.product.title = this.quickShop.find('.title').text();
				properties.product.url = this.quickShop.find('.title a').attr('href');
				ref = this.quickShop.find('.thumb');
				for (l = 0, len1 = ref.length; l < len1; l++) {
					thumb = ref[l];
					imageAlt = $(thumb).find('img').attr('alt');
					if (variantTitle.indexOf(imageAlt) > -1) {
						properties.matching_image = $(thumb).find('img').attr('src');
					}
				}
				postToCartUrl = "/cart/add.js?quantity=" + properties.quantity.added + "&id=" + properties.variant.id;
				productFormID = this.quickShop.find('.quick-shop-form').attr('id');
				button = this.quickShop.find('.submit');
				button.data('original-text', button.val());
				button.val(get_please_wait()).addClass('disabled');

				return Shopify.addItemFromForm(productFormID, (function(_this) {
					return function(product) {
						var resetButton;
						button.val(get_add_to_cart());
						resetButton = function() {

							return button.val(get_add_to_cart()).removeClass('disabled').prop('disabled',false);
						};
						setTimeout(resetButton, 2000);
						_this.errorWrap.html('');
						return Shopify.getCart(function(cart) {
							return _this.updateMiniCart(cart, properties);
						});
					};
				})(this));
			}
		};

		QuickShopView.prototype.handleErrors = function(error) {
			var button, errorMsg;
			button = this.quickShop.find('.submit');
			button.val(button.data('original-text')).removeClass('disabled').prop('disabled',false);
			error = $.parseJSON(error.responseText);
			errorMsg = "<p>" + error.description + "</p>";
			return this.errorWrap.html(errorMsg);
		};

		return QuickShopView;

	})(Backbone.View);

	AccountView = (function(superClass) {
		extend(AccountView, superClass);

		function AccountView() {
			return AccountView.__super__.constructor.apply(this, arguments);
		}

		AccountView.prototype.events = function() {
			return {
				'click .guest-login a': 'submitGuestCheckout'
			};
		};

		AccountView.prototype.submitGuestCheckout = function() {
			$('#customer_login_guest').submit();
			return false;
		};

		return AccountView;

	})(Backbone.View);

	SlideshowView = (function(superClass) {
		extend(SlideshowView, superClass);

		function SlideshowView() {
			return SlideshowView.__super__.constructor.apply(this, arguments);
		}

		SlideshowView.prototype.initialize = function() {
			this.initializedClass = 'slideshow-initialized';
			return this._validate();
		};

		SlideshowView.prototype._validate = function() {
			var _slide, fn, i, isInitialized, j, len, ref;
			this.slides = this.$('.slide', this.$el);
			this.slideshow = $('.slideshow', this.$el);
			this.jumpLinksWrap = $('.jump-to-slide', this.$el);
			this.fadeSpeed = 400;
			this.autoPlay = parseInt($('.slideshow', this.$el).attr('data-autoplay'), 10);
			isInitialized = this.$el.hasClass(this.initializedClass);
			this.slides.first().addClass('first');
			this.slides.last().addClass('last');
			this.jumpLinksWrap.html('');
			ref = this.slides;
			fn = (function(_this) {
				return function() {
					var slide;
					slide = _slide;
					if (_this.slides.length > 0) {
						_this.jumpLinksWrap.append($('<li>'));
					}
					if (i === 0) {
						slide = $(slide);
						return slide.imagesLoaded(function() {
							return slide.fadeTo('200', 1, function() {
								var height;
								height = slide.height();
								slide.css('z-index', 2000).addClass('active');
								return slide.parent().css('height', height);
							});
						});
					}
				};
			})(this);
			for (i = j = 0, len = ref.length; j < len; i = ++j) {
				_slide = ref[i];
				fn();
			}
			this.jumpLinks = this.jumpLinksWrap.find('li');
			this.jumpLinksWrap.find('li:first').addClass('active');
			if (this.slideshow.attr('data-full-width') === 'true') {
				this.slideshow.parents('.shopify-section').next('.shopify-section').addClass('slideshow-sibling-section');
			}
			if (this.slides.length === 1) {
				this.$('.next, .prev, .jump-to-slide').remove();
			}
			if (this.autoPlay > 1) {
				this.autoPlaySlides();
			}
			return WINDOW.resize((function(_this) {
				return function() {
					return $('.slideshow', _this.$el).css({
						height: _this.slides.filter('.active').height()
					});
				};
			})(this));
		};

		SlideshowView.prototype.events = {
			'click .next': 'nextSlide',
			'click .prev': 'previousSlide',
			'click .jump-to-slide li:not(.active)': 'jumpToSlide'
		};

		SlideshowView.prototype.selectedHeight = function(event) {
			return $(event.target).imagesLoaded((function(_this) {
				return function() {
					return setTimeout((function() {
						$('.slide', _this.$el).removeClass('active');
						$(event.target).addClass('active');
						return $('.slideshow', _this.$el).css({
							height: $(event.target).height()
						});
					}), 1000);
				};
			})(this));
		};

		SlideshowView.prototype.autoPlaySlides = function() {
			var interval;
			if (!!$('.slideshow', this.$el).hasClass('autoplay-enabled')) {
				return;
			}
			if (this.slides.length > 1) {
				$('.slideshow', this.$el).addClass('autoplay-enabled');
				return interval = setInterval(((function(_this) {
					return function() {
						if (!$('.slideshow', _this.$el).hasClass('paused')) {
							_this.nextSlide();
						}
					};
				})(this)), this.autoPlay);
			}
		};

		SlideshowView.prototype.slideStatus = function() {
			return $('.slideshow', this.$el).toggleClass('paused');
		};

		SlideshowView.prototype.lockSlide = function(event) {
			this.slidesLocked = true;
			$(event.target).closest('.slideshow', this.$el).addClass('paused');
			this.jumpToSlide(event);
			return this.selectedHeight(event);
		};

		SlideshowView.prototype.unlockSlide = function() {
			this.slidesLocked = false;
			return $(event.target).closest('.slideshow', this.$el).removeClass('paused');
		};

		SlideshowView.prototype.nextSlide = function() {
			var isLast, upcomingSlide;
			isLast = this.$('.slide.active').hasClass('last');
			upcomingSlide = isLast ? this.slides.first() : this.$('.slide.active').next();
			return this.switchToSlide(upcomingSlide);
		};

		SlideshowView.prototype.previousSlide = function() {
			var isFirst, upcomingSlide;
			isFirst = this.$('.slide.active').hasClass('first');
			upcomingSlide = isFirst ? this.slides.last() : this.$('.slide.active').prev();
			return this.switchToSlide(upcomingSlide);
		};

		SlideshowView.prototype.jumpToSlide = function(event) {
			var jumpPosition, upcomingSlide;
			jumpPosition = ($(event.target)).index();
			upcomingSlide = this.slides.eq(jumpPosition);
			return this.switchToSlide(upcomingSlide);
		};

		SlideshowView.prototype.switchToSlide = function(upcomingSlide) {
			var currentJumpLink, currentSlide, j, jumpLinks, jumpLinksWrap, len, ref, upcomingJumpLink, upcomingSlidePosition;
			currentSlide = this.$('.slide.active');
			upcomingSlidePosition = upcomingSlide.index();
			ref = this.jumpLinksWrap;
			for (j = 0, len = ref.length; j < len; j++) {
				jumpLinksWrap = ref[j];
				jumpLinksWrap = $(jumpLinksWrap);
				jumpLinks = jumpLinksWrap.find('li');
				upcomingJumpLink = jumpLinks.eq(upcomingSlidePosition);
				currentJumpLink = jumpLinks.filter('.active');
				currentJumpLink.removeClass('active');
				upcomingJumpLink.addClass('active');
			}
			$('.slideshow', this.$el).css({
				'height': upcomingSlide.height()
			});

			//     Shinee vimeo player
			var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
			var hasPlayer, playerSelector, jqueryPlayer;

			if(isMobile)
			playerSelector = '.malaika-video-slide.mobile-only';
			else
			playerSelector = '.malaika-video-slide.desktop-only';

			// Pausing current slide
			hasPlayer = ($(currentSlide).find(playerSelector).length > 0);
			if(hasPlayer){
				jqueryPlayer = new Vimeo.Player($(currentSlide).find(playerSelector));
				jqueryPlayer.pause();
			}

			// Playing next slide
			hasPlayer = ($(upcomingSlide).find(playerSelector).length > 0);
			if(hasPlayer){
				jqueryPlayer = new Vimeo.Player($(upcomingSlide).find(playerSelector));
				jqueryPlayer.play();
			}

			currentSlide.fadeTo(this.fadeSpeed, 0, function() {
				return currentSlide.removeClass('active');
			});
			return upcomingSlide.fadeTo(this.fadeSpeed, 1, function() {
				return upcomingSlide.addClass('active');
			});
		};

		SlideshowView.prototype.update = function($el) {
			this.$el = $el;
			return this._validate();
		};

		return SlideshowView;

	})(Backbone.View);

	InstagramView = (function(superClass) {
		extend(InstagramView, superClass);

		function InstagramView() {
			return InstagramView.__super__.constructor.apply(this, arguments);
		}

		InstagramView.prototype.initialize = function() {
			this.initializedClass = 'instagram-initialized';
			return this._validate();
		};

		InstagramView.prototype._validate = function() {
			var accessToken, isInitialized;
			this.photoContainer = $('[data-instagram-photos]', this.$el);
			accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
			isInitialized = this.$el.hasClass(this.initializedClass);
			return this._getPhotos(accessToken, isInitialized);
		};

		InstagramView.prototype._getPhotos = function(accessToken, isInitialized) {
			var url;
			if (!accessToken.length) {
				return this._hasError(false);
			}
			if (isInitialized) {
				return;
			}
			url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + accessToken + "&count=6&callback=";
			return $.ajax({
				type: "GET",
				dataType: "jsonp",
				url: url,
				success: (function(_this) {
					return function(response) {

						var j, len, photo, ref;
						if (response.meta.code === 200) {
							ref = response.data;
							for (j = 0, len = ref.length; j < len; j++) {
								photo = ref[j];
								_this.photoContainer.append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>");
							}
							_this.photoContainer.imagesLoaded(function() {
								_this.photoContainer.addClass('visible').height('auto');
								return _this.$('.loading').hide();
							});
							return _this.$el.toggleClass(_this.initializedClass, true);
						} else {
							return _this._hasError(response);
						}
					};
				})(this),
				error: (function(_this) {
					return function(response) {
						return _this._hasError(response);
					};
				})(this)
			});
		};

		InstagramView.prototype._hasError = function(response) {
			this.$el.toggleClass(this.initializedClass, false);
			this.photoContainer.html();
			if (response) {
				return console.log("Instagram error: " + response.meta.error_message);
			}
		};

		InstagramView.prototype.update = function($el) {
			this.$el = $el;
			return this._validate();
		};

		return InstagramView;

	})(Backbone.View);

	TwitterView = (function(superClass) {
		extend(TwitterView, superClass);

		function TwitterView() {
			return TwitterView.__super__.constructor.apply(this, arguments);
		}

		TwitterView.prototype.initialize = function() {
			this.initializedClass = 'twitter-initialized';
			return this._validate();
		};

		TwitterView.prototype._validate = function() {
			var isInitialized, retweets, username;
			this.tweetContainer = $('[data-twitter-tweets]', this.$el);
			username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
			retweets = $('[data-show-retweets]', this.$el).data('show-retweets');
			isInitialized = this.$el.hasClass(this.initializedClass);
			if (!isInitialized) {
				return this._fetchTweets(username, retweets);
			}
		};

		TwitterView.prototype._fetchTweets = function(username, retweets) {
			var config;
			config = {
				'profile': {
					'screenName': username
				},
				'maxTweets': 1,
				'enableLinks': true,
				'showUser': true,
				'showTime': true,
				'showRetweet': retweets,
				'customCallback': (function(_this) {
					return function(tweets) {
						return _this.renderTweets(tweets);
					};
				})(this),
				'showInteraction': false
			};
			return twitterFetcher.fetch(config);
		};

		TwitterView.prototype.renderTweets = function(tweets) {
			var j, len, results, tweet;
			if (tweets.length) {
				results = [];
				for (j = 0, len = tweets.length; j < len; j++) {
					tweet = tweets[j];
					tweet = $(tweet);
					this.tweetContainer.append("<div class='tweet-wrap'>" + tweet[1].innerHTML + ("<span class='timestamp'>" + tweet[2].innerHTML + " <span class='divider'>/</span> " + tweet[0].innerHTML + "</span></div>"));
					results.push(this.$el.toggleClass(this.initializedClass, true));
				}
				return results;
			} else {
				this.tweetContainer.html('');
				return console.log("No tweets to display. Most probable cause is an incorrectly entered username.");
			}
		};

		TwitterView.prototype.update = function($el) {
			this.$el = $el;
			return this._validate();
		};

		return TwitterView;

	})(Backbone.View);

	PasswordView = (function(superClass) {
		extend(PasswordView, superClass);

		function PasswordView() {
			return PasswordView.__super__.constructor.apply(this, arguments);
		}

		PasswordView.prototype.el = $('.password-page-modal-wrapper');

		PasswordView.prototype.events = {
			'click': 'close',
			'click .close-modal': 'close',
			'click .admin-login-modal': 'open'
		};

		PasswordView.prototype.initialize = function() {
			this.sectionBinding();
			this.initializedClass = 'password-initialized';
			return this._validate();
		};

		PasswordView.prototype._validate = function() {
			this.adminLogin = $('.password-page-modal-wrapper');
			this.adminModal = this.adminLogin.find('.password-page-modal');
			this.openByDefault = this.adminLogin.find('[data-open-modal]').length;
			if (this.openByDefault) {
				this.open();
			}
			return WINDOW.resize((function(_this) {
				return function() {
					return _this.formatTheModal();
				};
			})(this));
		};

		PasswordView.prototype.sectionBinding = function() {
			this.$el.on('shopify:section:load', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-password')) {
						return;
					}
					_this.delegateEvents();
					return _this._validate();
				};
			})(this));
			return this.$el.on('shopify:section:unload', (function(_this) {
				return function(event) {
					if (!$(event.target).hasClass('section-password')) {
						return;
					}
					return _this.undelegateEvents();
				};
			})(this));
		};

		PasswordView.prototype.formatTheModal = function() {

			var offset;
			if (WINDOW.height() <= this.adminModal.outerHeight()) {
				return this.adminModal.css({
					'margin-top': 0
				});
			} else {
				offset = (WINDOW.height() - this.adminModal.outerHeight()) / 2;
				return this.adminModal.css({
					'margin-top': offset
				});
			}
		};

		PasswordView.prototype.open = function(e) {
			BODY.css({
				'overflow': 'hidden'
			});
			this.adminLogin.show();
			this.formatTheModal();
			if (!$('html').hasClass('lt-ie9')) {
				this.adminLogin.fadeTo(200, 1);
			}
			return $(document).bind('keyup', (function(_this) {
				return function(e) {
					if (e.keyCode === 27) {
						return _this.close();
					}
				};
			})(this));
		};

		PasswordView.prototype.close = function(e) {
			if ((e == null) || e.target === e.currentTarget) {
				if ($('html').hasClass('lt-ie9')) {
					this.adminLogin.hide();
					BODY.css({
						'overflow': 'auto'
					});
				} else {
					this.adminLogin.fadeTo(200, 0, (function(_this) {
						return function() {
							return _this.adminLogin.hide();
						};
					})(this));
				}
				return $(document).unbind('keyup');
			}
		};

		return PasswordView;

	})(Backbone.View);

	GiftCardView = (function(superClass) {
		extend(GiftCardView, superClass);

		function GiftCardView() {
			return GiftCardView.__super__.constructor.apply(this, arguments);
		}

		GiftCardView.prototype.initialize = function() {
			return this.addQrCode();
		};

		GiftCardView.prototype.addQrCode = function() {
			var qrWrapper;
			qrWrapper = $('[data-qr-code]');
			return new QRCode(qrWrapper[0], {
				text: qrWrapper.data('qr-code'),
				width: 120,
				height: 120
			});
		};

		return GiftCardView;

	})(Backbone.View);





	/**
	* PreOrderme pome
	*/
	// preOrderMe_
	window.po = function(options){

		var vars = {
			variant: null
		}

		var root = this;

		this.construct = function(options){
			$.extend(vars, options);
		};

		this.construct(options);

		var widget = $('#preorder-me-widget')

		this.data = function(){

			return {
				shop: JSON.parse(widget.attr('data-shop')),
				mf: JSON.parse(widget.attr('data-mf')),
				seed: JSON.parse(widget.attr('data-seed'))
			};
		}

		var mf = function(){
			return root.data().mf;
		}

		var variantID = function(){
			if(vars.variant == null){
				if(!hasMultiDropdowns() && typeof(getUrlVars()["variant"]) == 'undefined'){
					return $('.product-select').val();
				}
				else if(typeof(getUrlVars()["variant"]) != 'undefined' && $('.product-select').val()){
					return $('.product-select').val();
				}
				else return false;
			}
			else{
				return vars.variant.id;
			}
			//     return vars.variant == null ? false : vars.variant.id;
		}

		this.variantID = function(){
			return variantID();
		}

		var _inventory = function(){
			return variantID() ? (mf()[variantID()].inventory_quantity) : null;
		}
		// returns TRUE if PreOrder is enabled for the selected variant
		// returns FALSE if PreOrder is NOT enabled for the selected variant
		// returns NULL if there is no selected variant
		this.enabled = function(){
			return variantID() ? (mf()[variantID()].enabled == true) : null;
		};

		this.prompt = function(){
			return variantID() ? (mf()[variantID()].prompt) : null;
		};

		this.inStock = function(){
			return _inventory() > 0 ? true : false;
		}

		this.inventory = function(){
			return _inventory();
		}

	}

	// preOrderMe_
	var preOrderMe = function(options){

		var vars = {
			variant: null
		}

		var root = this;

		this.construct = function(options){
			$.extend(vars, options);
		};

		this.construct(options);

		var widget = $('#preorder-me-widget')

		this.data = function(){

			return {
				shop: (JSON.parse(widget.attr('data-shop'))),
				mf: (JSON.parse(widget.attr('data-mf'))),
				seed: (JSON.parse(widget.attr('data-seed')))
			};
		}

		var mf = function(){
			return root.data().mf;
		}

		this.mf = function(){
			return mf();
		}

		var variantID = function(){
			if(vars.variant == null){
				if(!hasMultiDropdowns() && typeof(getUrlVars()["variant"]) == 'undefined'){
					return $('.product-select').val();
				}
				else if(typeof(getUrlVars()["variant"]) != 'undefined' && $('.product-select').val()){
					return $('.product-select').val();
				}
				else return false;
			}
			else{
				return vars.variant.id;
			}
			//     return vars.variant == null ? false : vars.variant.id;
		}

		this.variantID = function(){
			return variantID();
		}

		var _inventory = function(){
			// Updated
			var result;
			var seed = root.data().seed;

			for(var i = 0; i < seed.length; i++){
				if(seed[i].id == variantID())
				result = seed[i].inventory_quantity;
			}

			return result;
		}
		// returns TRUE if PreOrder is enabled for the selected variant
		// returns FALSE if PreOrder is NOT enabled for the selected variant
		// returns NULL if there is no selected variant
		this.enabled = function(){
			if (variantID()){
				if(mf()[variantID()] !== undefined){
					if(mf()[variantID()].enabled == true)
					return true;
					else return false;
				}
				else return null;
			}
			else
			return null
			// return variantID() ? (mf()[variantID()].enabled == true) : null;
		};

		this.prompt = function(){
			if (variantID()){
				if(mf()[variantID()] !== undefined){

					if(mf()[variantID()].prompt)
					return mf()[variantID()].prompt;
					else return false;
				}
				else return null;
			}
			else
			return null
			// return variantID() ? (mf()[variantID()].prompt) : null;
		};

		this.inStock = function(){
			return _inventory() > 0 ? true : false;
		}

		this.inventory = function(){
			return _inventory();
		}

	}


	/* makes header sticky when scrolling past the logo */
	var navBar        = $("#malaika-header");
	var mobileNavBar  = $("#mobile-malaika-header");
	var scroll        = $(window).scrollTop();

	$(document).on("scroll", navBar, function(e) {
		var scroll = $(window).scrollTop();
		if (scroll > 181) { navBar.addClass("malaika-fixed-nav-bar"); }
		else              { navBar.removeClass("malaika-fixed-nav-bar"); }
	});

	$(document).on("scroll", mobileNavBar, function(e) {
		var scroll = $(window).scrollTop();
		if (scroll > 181) { mobileNavBar.addClass("malaika-fixed-nav-bar"); } else              { mobileNavBar.removeClass("malaika-fixed-nav-bar"); }
	});


	// Shinee 4. Product and Cart page quantity input field spinner
	$(document).on('ready', function(){
		$('body').addClass('enk-ready');
	});

	$( window ).load(function() {
		$('body').addClass('enk-loaded');
	});

	var debug = false;

	window.logger = function(msg){
		if(debug == true)
		if(msg){
			console.log(msg);
		}
	}

	// Product Page Tabs. Size chart | Care Guides etc.

	$(function ($) {
		if($('body').hasClass('template-product')){
			enk_init_product_tabs();
		}

		function enk_init_product_tabs(){
			$('.enk-product-tab-header').click(function(){
				var $body = $(this).parent().parent().find('.enk-product-tabs-body-item');
				var $icon = $(this).find('.icon-rotate');
				$body.slideToggle();
				$icon.toggleClass("rotate");
			});
		}
		// end enk_init_product_tabs
	})

	$(function ($) {
		$('.enk-continue-shopping').click(function(e){
			e.preventDefault();
			//     window.history.back();
			window.location.history.go(-2);
		});
	});


	// Multiple gift wrapping is not necessary
	$(function ($) {
		if($('body').hasClass('template-cart')){

			return;

			$.each($('#cart-form .table-row'), function(){
				var $title = $(this).find('.product-item .title a').text();

				if($title == 'Gift wrapping'){
					$(this).find('.quantity .counter-minus').css('display','none');
					$(this).find('.quantity .counter-plus').css('display','none');
					$(this).find('.quantity .product-quantity').css('visibility','hidden');
				}
			});
		}
	});


	// Product page secondary images
	$( window ).resize(function() {
		setTimeout(function () {
			$('.showcase.product-images .container').css('height','');
		}, 400);

	});

	// Enkomion mobile detector
	var isMobile = function(){
		return $('.enk-mobile-detector').is(":visible");
	}
	var isTablet = function(){
		return $('.enk-tablet-detector').is(":visible");
	}

	// Product thumbs
	function enk_product_thumbs(){
		if(!$('body').hasClass('template-product'))
		return;

		// Main width
		var bigImageWidth = $('.product-main-image').innerWidth();

		// Making it square
		$('.product-main-image').height(bigImageWidth);

		// Thumbs holder
		var thumbsHolder = $('body.template-product .showcase.product-images .inner');

		// Thumbs array
		var thumbs = $(thumbsHolder).find('.thumb');

		// Per thumb width
		var thumbWidth = (bigImageWidth / 5) - 10;

		thumbsHolder.width(bigImageWidth);
		//   thumbsHolder.height(thumbWidth);


		// Iterator
		var $i = 0;
		var thumbsAlign = 'flex';

		// Thumbs Aligning
		var thumbsCount = thumbs.length;
		if(thumbsCount < 5){
			thumbsAlign = 'left';
			thumbsHolder.css('justify-content','flex-start');
		}

		// Looping through thumbs
		$.each(thumbs, function(){
			// Removing other thumbs
			//     if($i > 4){
			//       $(this).remove();
			//     }

			$(this).css('margin','0');
			$(this).css('padding','0');
			$(this).height(thumbWidth);
			$(this).css('width',thumbWidth);

			if(thumbsAlign == 'left'){
				$(this).css('margin-right','10px');
			}

			$i++;
		});
	}

	// Collections page square images
	function enk_square_collection_images(){
		if(!$('body').hasClass('template-list-collections'))
		return;

		var $holder = $('section.collections');

		var $width = $holder.find('.collection').first().width();

		var $items = $holder.find('.collection-wrap');

		$.each($items, function(){
			$(this).height($width);
			//     $(this).find('.collection').height('100%');
		});

		$.each($items, function(){
			//     $(this).height($width);
			$(this).find('.collection').height('100%');
		});
	}

	// Initial Trigger
	$(function ($) {
		enk_product_thumbs();
		enk_square_collection_images();
	});

	// Trigger on resize
	var resizeTimer;
	$(window).on('resize', function(e) {

		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {

			// Run code here, resizing has "stopped"
			enk_product_thumbs();

			enk_square_collection_images();
		}, 250);
	});

	// Cart Page - Moving Delivery Time text to under product title
	$( window ).load(function() {

		if(!$('body').hasClass('template-cart'))
		return;

		var rows = $('#cart-form tr.table-row');
		var deliveryTimeText = '',
		deliveryTimeTextObj;

		$.each(rows, function(){

			deliveryTimeText = $(this).find('span[class*="preorder-item"]');

			if( $(deliveryTimeText).length > 0 ){
				deliveryTimeTextObj = $(deliveryTimeText).detach();
				$(this).find('.product-item > .wrap').append(deliveryTimeTextObj.css('font-size','15px'));
			}
		});

	});
	// Ends

	// Cart Page - Moving Delivery Time text to under product title
	$( document ).ready(function() {

		if(!$('body').hasClass('template-cart'))
		return;

		var rows = $('#cart-form tr.table-row');
		var deliveryTimeText = '',
		deliveryTimeTextObj;

		$.each(rows, function(){

			deliveryTimeText = $(this).find('span[class*="preorder-item"]');

			if( $(deliveryTimeText).length > 0 ){
				deliveryTimeTextObj = $(deliveryTimeText).detach();
				$(this).find('.product-item > .wrap').append(deliveryTimeTextObj.css('font-size','15px'));
			}
		});

	});
	// Ends


	// Mini Cart
	$(function ($) {
		// Gift Note change
		$('#enk-mini-cart-gift-note').on('change',function(){
			CartJS.setAttributes({
				"gift-note": $('#enk-mini-cart-gift-note').val(),
			});
			$('#mini-cart-is-a-gift').append('<div class="enk-gift-note-updated">Updated*</div>');

			setTimeout(function(){
				$('.enk-gift-note-updated').hide('fast');
			}, 2000);
		});

		$('#mini-cart-is-a-gift').on('click', '#enk-update-mini-cart-note', function() {
			CartJS.setAttributes({
				"gift-note": $('#enk-mini-cart-gift-note').val(),
			});
		});
	});

	$(document).on('cart.requestComplete', function(event, cart) {
		var SV = new QuickShopView;
		SV.updateMiniCart(CartJS.cart);

		// Fix Tags
		var hiddenItems = $('.enk-hidden-item-data > div');

		$.each(hiddenItems, function(){
			if($(this).html() != ''){
				$('#item-'+$(this).attr('data-variant_id')+' .brand').html($(this).html());
			}
			else{
				$('#item-'+$(this).attr('data-variant_id')+' .brand').html('');
			}
		});
	});

	$(document).on('cart.ready', function(event, cart) {
		// Check or Uncheck the gift cart checkbox
		var hasGift = false;
		$.each(CartJS.cart.items, function(){
			if($(this)[0].handle.toLowerCase() == 'gift-wrapping'){
				hasGift = true;
			}
		});
		$('#enk-mini-cart-gift-wrapping').prop('checked',hasGift);
	});
	// Minicart ends


	// Slick Slider product image and thumbs slider
	$(document).ready(function(){

		var centerMode = true;

		if($('.showcase.product-images .pager .thumb').length < 5){
			centerMode = false;
		}

		if(centerMode){
			$('.slider-for').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				asNavFor: '.slider-nav',
				adaptiveHeight: false,
				speed: 300,
				//       prevArrow: '<button type="button" class="slick-prev">[</button>',
				//       nextArrow: '<button type="button" class="slick-next">]</button>',
				infinite: true,
				prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/back.svg?v=1600657634'>",
				nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/next.svg?v=1600657634'>",
				prevArrow: '<img class="a-left control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/2273/6209/files/back.svg?v=1645890155" data-wg-notranslate="manual">',
				nextArrow: '<img class="a-right control-c next slick-next" src="https://cdn.shopify.com/s/files/1/2273/6209/files/next.svg?v=1645890142" data-wg-notranslate="manual">',

				responsive: [
					{
						//           breakpoint: 576,
						breakpoint: 576,
						settings: {
							arrows: true,
							//             prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/back.svg?v=1600657634'>",
							//             nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/next.svg?v=1600657634'>",
							prevArrow: '<img class="a-left control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/2273/6209/files/back.svg?v=1645890155" data-wg-notranslate="manual">',
							nextArrow: '<img class="a-right control-c next slick-next" src="https://cdn.shopify.com/s/files/1/2273/6209/files/next.svg?v=1645890142" data-wg-notranslate="manual">',


						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]

			});
			$('.slider-nav').slick({
				asNavFor: '.slider-for',
				centerMode: centerMode,
				focusOnSelect: true,
				speed: 200,
				slidesToShow: 3,
				variableWidth: true,

				responsive: [
					{
						breakpoint: 1024,
						settings: {
							height: 69,
						}
					},
				],
			});
		}
		else{
			$('.slider-for').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				asNavFor: '.slider-nav',
				adaptiveHeight: false,
				speed: 300,
				//       prevArrow: '<button type="button" class="slick-prev">[</button>',
				//       nextArrow: '<button type="button" class="slick-next">]</button>',
				//       prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/back.svg?v=1600657634'>",
				//       nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0013/9431/1233/files/next.svg?v=1600657634'>",
				prevArrow: '<img class="a-left control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/2273/6209/files/back.svg?v=1645890155" data-wg-notranslate="manual">',
				nextArrow: '<img class="a-right control-c next slick-next" src="https://cdn.shopify.com/s/files/1/2273/6209/files/next.svg?v=1645890142" data-wg-notranslate="manual">',


				infinite: false,
			});
			$('.slider-nav').slick({
				asNavFor: '.slider-for',
				centerMode: false,
				focusOnSelect: true,
				speed: 200,
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							height: 69,
						}
					},
				]
			});
		}
	});

	$(window).on('resize', function() {
		setTimeout(function(){
			enk_resize_slick();
		}, 500);
	});


	$(document).ready(function(){

		var centerMode = true;
		var sliderLength = $('.showcase.product-images .pager .thumb').length;
		$('.slider-for').attr('centerMode',sliderLength >= 5);

		enk_resize_slick();

		$('.slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide){
			setSubmitButtons('_afterChange');
		});

		// Making it infinite manually
		$('.slider-for .slick-arrow').on('click', function(e){

			if($('.slider-for').attr('centerMode') == false){
				return;
			}

			var isNext = $(this).hasClass('slick-next');

			if($(this).attr('aria-disabled')){

				if(isNext){
					$('.slider-for').slick("slickGoTo",0);
				}
				else{
					var sliderLength = $('.showcase.product-images .pager .thumb').length;
					$('.slider-for').slick("slickGoTo",sliderLength -1);
				}
			}
		});

		// Toggle FullScreenView
		if($('body').hasClass('template-product')){

			if($('.showcase.product-images .pager .thumb').length > 1){

				$('.slider-for').on('click', '.slick-slide', function (e) {
					if(isMobile()){
						return false;
					}
					else{
						e.preventDefault();
						$('.toggle-fullview').click();
					}
				});
			}

		}
	});

	$(window).on("load", function(){
		enk_resize_slick();
	});

	function enk_resize_slick(){

		var slider = $('.slider-for');

		var centerMode = true;
		var sliderLength = $('.showcase.product-images .pager .thumb').length;
		var sliderWidth;

		if(sliderLength < 5){
			centerMode = false;
		}

		$('.slider-for').height(slider.width());

		$('.slider-for.slick-initialized .slick-slide').css('min-height',slider.width());

		if(isMobile()){

			if(centerMode){
				sliderWidth = slider.width() / 3 - 7;
			}
			else{
				sliderWidth = slider.width() / 4 - 14;
			}

			$('.slider-nav .slick-track .slick-slide').css('width', sliderWidth ).css('height', sliderWidth );

			if(!centerMode){
				$('.slider-nav .slick-track').css('margin-left', '-6px' );
			}
		}
		else{

			if(centerMode){
				sliderWidth = slider.width() / 5 - 9;
			}
			else{
				sliderWidth = slider.width() / 4 - 12;
			}

			if(!centerMode){
				$('.slider-nav .slick-track').css('margin-left', '-6px' );
			}

			$('.slider-nav .slick-track .slick-slide').css('width', sliderWidth ).css('height', sliderWidth );
		}

		//   if($('body').hasClass('enk-ready')){
		//    $('.slider-nav .slick-slide.slick-current.slick-active').click();
		//   }
	}

	function getUrlVars()
	{
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for(var i = 0; i < hashes.length; i++)
		{
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}

	// Fixing cart page gift wrapping checkbox
	$(function (){

		if(!$('body').hasClass('template-cart'))
		return false;

		$('.template-cart .remove a').click(function(e){
			var cartForm = $('#cart-form');

			//     if(cartForm.find('.table-row').length == 2){
			if($(this).parent().parent().find('.product-item .title').html() == 'Gift wrapping'){
				$('#gift-wrapping').click();
				e.preventDefault();
			}
			//     }
		});
	});

	// Changing variant dropdown on thumbnail change
	// Image to variant
	$(function(){

		// Otherwise
		$('.slider-for').on('beforeChange', function(event, slick, currentSlide, nextSlide){

			if(isInBedding())
			return;

			if($('body').hasClass('enk-variant-lock'))
			return;

			if(!$('body').hasClass('enk-ready'))
			return;

			var slide = $('.slider-for .slick-track img[data-slick-index="'+nextSlide+'"]');
			var variants = slide.attr('data-image-variants');

			var variant, variantArray;
			var dropDowns, dropDownOptions, dropDown;

			dropDowns = $('.product-options .inline-field-wrapper.js-required select.single-option-selector');

			var dropdownIndex;
			var foundVariant;

			if(variants != ''){

				var variantsArray = variants.split("||");

				var triggererDropdown;

				// Looping throught image's data-image-variants attr
				for(var i=0, l = variantsArray.length; i < l; i++){

					variant = variantsArray[i];

					if(variant.length == 0)
					continue;

					variantArray = variant.split("::");

					if(variantArray.length > 0){

						// looping through variants
						for(var j = 0, jl = variantArray.length; j < jl; j++){

							// Finding variant from dropdowns

							dropdownIndex = 0;

							$.each(dropDowns, function(){

								dropDown = $(this);

								dropDownOptions = $(this).find('option');

								foundVariant = false;

								$.each(dropDownOptions, function(){

									if(($(this).val().replace('/','|') == variantArray[j].replace('/','|')) && (dropdownIndex == j)){

										$(this).prop('selected','selected');

										dropDown.attr('selectedIndex', $(this).index());

										dropDown.parent().find('span[data-selected-option]').html($(this).val());

										triggererDropdown = dropDown;

										foundVariant = true;

										triggererDropdown.change();

										return false;
									}

									$(this).val($(this).val().replace('|','/'));

								});

								//               if(foundVariant){
								//                 return false;
								//               }

								dropdownIndex++;

							});
							// dropdowns loop ends
						}
					}

					//         triggererDropdown.change();
				}
			}
			else{
				// If image has no variants linked
				// Handling button
				// Checking if selected all options
				//       var $addToCartButton = $(".action-button.submit");
				//       $addToCartButton.addClass('disabled');
			}
		});
	});
	// Changing variant dropdown on thumbnail change ends

	var isInBedding = function(){
		return $('main.content').hasClass('content-area-bedding');
	}

	// On Page load, setting handle counters
	$(document).on('ready', function(){

		var buildHandleCounters = function(){

			return;

			if($('body').hasClass('template-cart')){
				return;
			}

			$.each($('.handle-counter'), function(){
				var $enkID = $(this).prop('id');
				var $enkQtyInput = $('#'+$enkID).find('.product-quantity');
				var $enkMax = $enkQtyInput.attr('data-max');

				var options = {
					minimum: 1,
					maximize: $enkMax,
					onChange: function(d){

						if($('body').hasClass('template-cart')){

							return;

							if($('body').hasClass('enk-loaded')){
								$($enkQtyInput).attr('value',d);
								$('#' + $enkID + ' input').change();

								$('.cart__submit-control').click();
							}
						}
						else if($('body').hasClass('template-product')){
							if($('body').hasClass('enk-ready')){
								if(!hasEmptyDropdown()){
									$($enkQtyInput).attr('value',d);
									$('#' + $enkID + ' input').change();
								}
								else{
									$($enkQtyInput).val(1);
									$('#' + $enkID + ' input').change();
								}
							}
						}
					},
				}
				$('#' + $enkID).handleCounter(options);
			});
		}

		if($('body').hasClass('template-cart')){
			//     buildHandleCounters();
			//     setSubmitButtons('_buildHandleCounters');
		}

		// Product page handle counters
		if($('body').hasClass('template-product')){

			setTimeout(function(){

				if(!hasMultiDropdowns()){
					setSubmitButtons('_buildHandleCounters');
				}
			}, 550);
		}


		// Adding PreOrder notification on the Cart page
		if($('body').hasClass('template-cart')){

			return;

			var products = $('.product-item');
			var pageTitle = $('.page-title');
			var notification = '<h5 class="preOrder-notification">Please Note: Some items in your cart are only available as pre-orders.</h5>';
			var notificationDE = '<h5 class="preOrder-notification">Achtung: Bei einigen Posten in Ihrem Warenkorb handelt es sich um Vorbestellungen.</h5>';

			var checkPreOrderItemsInCart = function(lang){

				if($('body').hasClass('hasPreOrderItems'))
				return false;

				$.each(products, function(){

					var preOrderItem = $(this).find('.preorder-item');

					if(preOrderItem.length > 0){

						if(lang == null || lang == 'en'){
							pageTitle.append(notification);
						}
						else{
							pageTitle.append(notificationDE);
						}

						pageTitle.find('.preOrder-notification').css('opacity',1);

						$('body').addClass('hasPreOrderItems');

						return false;
					}
					else{
						setTimeout(function(){
							lang = Weglot.getCurrentLang();
							checkPreOrderItemsInCart(lang);
						}, 300);
					}
				});
			}

			Weglot.on("switchersReady", function(){
				var lang = Weglot.getCurrentLang();
				checkPreOrderItemsInCart(lang);
			});

			Weglot.on('languageChanged', function(e){

				$('body').removeClass('hasPreOrderItems');
				$('.preOrder-notification').remove();
				checkPreOrderItemsInCart(e);
			});
		}
	});

	$(document).ready(function(){
		$('.product-options .inline-field-wrapper.js-required select.single-option-selector').change(function(){
			if($(this).val() != null){
				$(this).parent().removeClass('enk-dropdown-required');
			}
		});

		// Making buttons disabled when it has .disabled class
		//   $('.action-button.submit').click(function(e){
		//     e.preventDefault();
		//     if(!$(this).hasClass('disabled'));
		//        $(this).one('click');

		//     return false;
		//   });

		//

		// Fixing No variant and PreOrder products qty is 0
		if($('body').hasClass('template-product')){

		}

	});

	// Lazy Loading
	// http://jquery.eisbehr.de/lazy
	// $(document).ready(function(){
	//   $('.lazy').Lazy({
	//     effect: 'fadeIn',
	//     enableThrottle: true,
	//     throttle: 250,
	//   });
	// });

	// Checks and validates dropdown values
	$.enkValidateDropdowns = function() {

		if($('.single-option-selector').length == 0){
			return true;
		}

		var dropdown;
		var label;
		var hasEmptyDropdown = false;

		$.each($('.select-text span'), function(){

			dropdown = $(this).parent().parent().find('.single-option-selector');
			label = $(this).html();

			if(label == get_please_select()){
				dropdown.parent().addClass('enk-dropdown-required');
				hasEmptyDropdown = true;
			}
			else{
				dropdown.parent().removeClass('enk-dropdown-required');
			}
		});

		if(hasEmptyDropdown){
			return false;
		}
		else {
			return true;
		}
	};



	window.hasMultiDropdowns = function() {
		return $('.single-option-selector').length > 0;
	};

	window.hasEmptyDropdown = function() {

		var hasEmptyDropdown = false;

		if($('.single-option-selector').length == 0){
			return false;
		}

		$.each($('.select-text span'), function(){

			if($(this).html() == get_please_select()){
				hasEmptyDropdown = true;
			}
		});

		return hasEmptyDropdown;
	};


	window.getSubmitButton = function(){
		return $('.action-button.submit:visible');
	}

	window.setSubmitButtonLabel = function(label){
		var btn = getSubmitButton();

		if(btn.attr('id') == 'preorder-me-btn' || label == 'pre_order')
		return false;

		if(label == 'please_choose_options'){

			btn.val(get_please_choose_options());
			btn.addClass('disabled');
		}
		else if(label == 'please_wait'){

			btn.val(get_please_wait());
			btn.addClass('disabled');
		}
		else if(label == 'sold_out'){

			//btn.val(get_sold_out());
			var txt = get_sold_out();
			btn.removeAttr('disabled');
			btn.prop('disabled',false);
			$(btn).attr('value',txt);

			btn.addClass('disabled');
		}
		else if(label == 'add_to_cart'){

			btn.val(get_add_to_cart());
			btn.removeClass('disabled');
		}
		else{
			btn.val(label);
			btn.removeClass('disabled');
		}

		if(btn.hasClass('disabled')){

			if(label == 'sold_out'){

			}
			else{
				btn.val(get_please_choose_options());
			}

			btn.prop('disabled','disabled');
			$('#preorder-me-msg').hide();
		}
		else{
			btn.attr('disabled',false);
			btn.prop('disabled',false);
		}

		Weglot.on('languageChanged', function(e){
			setTimeout(function(){

				if(btn.hasClass('disabled')){
					if(label == 'sold_out'){
						btn.val(get_sold_out());
					}
					else{
						btn.val(get_please_choose_options());
					}

					btn.prop('disabled','disabled');
				}
				else{
					btn.attr('disabled',false);
					btn.prop('disabled',false);
				}
			}, 150);
		});

		return true;
	}

	window.setSubmitButtonType = function(btn){

		// console.log('setSubmitButtonType');
		// console.log(btn);

		if(btn != 'add_to_cart'){
			if($('#prompt2')){
				if(($('#prompt2').length > 1)){
					$('#prompt2').slice(1).remove();
				}
			}
		}

		$.each($('.action-button.submit'), function(){

			if($(this).attr('id') == 'preorder-me-btn'){
				// preorder button

				if(btn == 'add_to_cart'){
					$(this).css('display','none');
				}
				else{
					$(this).css('display','inline-block');
				}
			}
			else{
				// add to cart button
				if(btn == 'add_to_cart'){
					$(this).css('display','inline-block');
				}
				else{
					$(this).css('display','none');
				}
			}
		});
	}

	function getVarFromMF(mf, variant){
		for (var k in mf){
			if(k == variant){
				return mf[k];
				break;
			}
		}
	}

	// setSubmitButtons_
	window.setSubmitButtons = function(eventSrc, variant){

		if(!$('body').hasClass('template-product'))
		return;

		setTimeout(function(){

			// console.log('setSubmitButtons');

			if(typeof(window.PreOrderMeBtn) == 'undefined'){
				setTimeout(function(){
					Weglot.on("switchersReady", function(){
						setSubmitButtons(eventSrc, variant);
					});
				}, 100);

				getVarFromMF(typeof(window.PreOrderMeBtn, variant));
			}
			else{

				var preOrder = new preOrderMe({variant: variant});

				// var poVar = preOrder.mf()[variant.id];
				// console.log(poVar.enabled);
				// console.log(preOrder.enabled());
				// console.log(variant);



				if(variant == null){

					// console.log('a1');

					if($('body').hasClass('setSubmitButtons') && eventSrc != '_afterChange' && eventSrc != '_buildHandleCounters'){
						setSubmitButtonLabel('please_choose_options');
						setSubmitButtonType('add_to_cart');

						// console.log('a1-1');
					}
					else if(eventSrc == '_variantChange' && !$('body').hasClass('setSubmitButtons')){

						setSubmitButtonType('add_to_cart');
						setSubmitButtonLabel('please_choose_options');

						// console.log('a1-2');
					}
					else if(eventSrc == '_buildHandleCounters' && !hasMultiDropdowns()){

						var _tmpVariant = {id: preOrder.variantID(),
							inventory_quantity: 999
						};

						setQty(_tmpVariant, preOrder.enabled(), eventSrc);

						// console.log('a1-3');
					}
				}

				else if(variant != null && preOrder.mf()[variant.id] !== undefined){

					// console.log(preOrder.mf());
					// console.log(getVarFromMF(preOrder.mf(), variant.id));
					// console.log(variant);

					var varMF = getVarFromMF(preOrder.mf(), variant.id);
					var varMFEnabled = (varMF.enabled == true);

					// console.log(varMFEnabled);
					// console.log(preOrder.enabled());
					//
					// console.log('b1');

					// Add to cart
					if(
						((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
						((!preOrder.enabled() && preOrder.inStock()) || (preOrder.enabled() && preOrder.inStock()))
					){

						// console.log('b1-1');

						var curr_qty = parseInt($('.product-quantity').attr('data-num'));


						// console.log(curr_qty);
						// console.log(parseInt(preOrder.inventory()));

						if(curr_qty > parseInt(preOrder.inventory()) && preOrder.enabled() == true){

							// console.log('b1-1-1');
							setTimeout(function(){
								setSubmitButtonLabel(get_pre_order());
								setSubmitButtonType('preOrder');
							}, 200);
						}
						else{

							// console.log('b1-2');
							setTimeout(function(){
								setSubmitButtonType('add_to_cart');
								setSubmitButtonLabel('add_to_cart');
							}, 200);
						}

						//           setSubmitButtonLabel('add_to_cart');
						//           setSubmitButtonType('add_to_cart');
					}
					// preOrder
					else if(
						preOrder.enabled() &&
						((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
						!preOrder.inStock()
					){
						// PreOrder App handle here

						// console.log('b1-3');

						setSubmitButtonLabel(get_pre_order());
						setSubmitButtonType('preOrder');
					}
					else if(
						!preOrder.enabled() &&
						((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
						!preOrder.inStock()
					){

						// console.log('b1-4');
						setSubmitButtonLabel('sold_out');
						setSubmitButtonType('add_to_cart');
					}
					else{

						// console.log('b1-5');
						setSubmitButtonLabel('please_choose_options');
						setSubmitButtonType('add_to_cart');
					}

					// console.log('---');
					// console.log(hasMultiDropdowns());
					// console.log(eventSrc);
					// console.log(preOrder.enabled());
					// Quantity Selector
					if(hasMultiDropdowns()){
						if(eventSrc == '_updateOptions' || eventSrc == '_variantChange'){
							setQty(variant, preOrder.enabled(), eventSrc);
							// console.log('b2-1');
						}
						else{

							setQty(variant, preOrder.enabled(), eventSrc);
							// console.log('b2-2');
						}
					}
					else{

						// console.log('b2-3');
						setQty(variant, preOrder.enabled(), eventSrc);
					}
				}
				else{
					// PreOrder App has 50 limits, some variants are excluded from that and has no preOrder info

					// console.log('b3');
					// Add to cart
					if(
						((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
						((!preOrder.enabled() && preOrder.inStock()) || (preOrder.enabled() && preOrder.inStock())
					)
				){

					// console.log('b3-1');
					var curr_qty = parseInt($('.product-quantity').attr('data-num'));

					if(curr_qty > parseInt(preOrder.inventory())){
						setTimeout(function(){
							setSubmitButtonLabel(get_pre_order());
							setSubmitButtonType('preOrder');
						}, 200);

						// console.log('b4');
					}
					else{
						setTimeout(function(){
							setSubmitButtonType('add_to_cart');
							setSubmitButtonLabel('add_to_cart');
						}, 200);
						// console.log('b4');
					}

					//           setSubmitButtonLabel('add_to_cart');
					//           setSubmitButtonType('add_to_cart');
				}
				// preOrder
				else if(
					preOrder.enabled() &&
					((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
					!preOrder.inStock()
				){
					// PreOrder App handle here
					// console.log('b4');
				}
				else if(
					!preOrder.enabled() &&
					((hasMultiDropdowns() && !hasEmptyDropdown()) || !hasMultiDropdowns()) &&
					!preOrder.inStock()
				){

					// console.log('b4');
					// if bugged
					if(preOrder.mf()[variant.id] === undefined){
						setTimeout(function(){
							// setSubmitButtonLabel(get_pre_order());
							// setSubmitButtonType('preOrder');
							setSubmitButtonType('add_to_cart');
							setSubmitButtonLabel('add_to_cart');
						}, 200);
					}
					else{
						setSubmitButtonLabel('sold_out');
						setSubmitButtonType('add_to_cart');
					}
				}
				else{

					// console.log('b4');

					setSubmitButtonLabel('please_choose_options');
					setSubmitButtonType('add_to_cart');
				}

				// Quantity Selector
				if(hasMultiDropdowns()){
					if(eventSrc == '_updateOptions' || eventSrc == '_variantChange'){
						setQty(variant, preOrder.enabled(), eventSrc);

						// console.log('b5');
					}
					else{
					}
				}
				else{

					// console.log('b5');
					setQty(variant, preOrder.enabled(), eventSrc);
				}
			}
		}

		$('body').addClass('setSubmitButtons');

	}, 150);
}

window.setQty = function(variant, preOrderEnabled, eventSrc){

	if(eventSrc == 'self')
	return;

	var _promptCount = $('#prompt2').length;
	// console.log('setQty');

	// Quantity
	setTimeout(function(){

		var preOrder = false;
		var pre_order = get_pre_order();
		var btn = getSubmitButton();

		preOrder = (btn.val() == pre_order);

		var qtyMax = 1;

		if(variant != null){
			qtyMax = variant.inventory_quantity
		}

		if(preOrder || preOrderEnabled){
			qtyMax = 999;
		}

		if(hasMultiDropdowns()){
			$('.product-quantity').attr('data-max', qtyMax);
		}
		else{

			qtyMax = $('.product-quantity').attr('data-max');

			if(preOrder || preOrderEnabled){
				qtyMax = 999;
			}
		}

		$('.product-quantity').val(1);

		var options = {
			minimum: 1,
			maximize: qtyMax,
			onChange: function(d){
				//         if(eventSrc != 'self'){
				setSubmitButtons('self',variant);

				var prompt = $('#preorder-me-msg');
				var _prompt = $('#prompt2');

				var preOrder = new preOrderMe({variant: variant});
				var qty = parseInt(preOrder.inventory());
				var promptMsg = preOrder.prompt();

				if(qtyMax != 999){

					if(_prompt.length == 0){
						_prompt = prompt.clone();
						_prompt.attr('id','prompt2');
						_prompt.insertAfter(prompt);
					}

					if(d == qtyMax){

						_prompt.html('Only ' + qtyMax + ' in stock').show();

					}
					else{
						_prompt.html('').hide();
					}
				}
				else{
					setTimeout(function(){

						var _btn = getSubmitButton();

						var poTmp = '<input id="po-prompt" type="text" name="properties[PreOrder]">';
						var cont = $('.poTmp-container');
						var po = $('#po-prompt');

						if(_prompt.length == 0){
							prompt = $('#preorder-me-msg');  //

							_prompt = prompt.clone();
							_prompt.attr('id','prompt2');
							_prompt.insertAfter(prompt);

						}

						var btnLbl = _btn.data('label');
						if(!btnLbl){
							btnLbl = _btn.val();
						}

						if(btnLbl.toLowerCase() == 'preorder'){

							var preOrder = new preOrderMe({variant: variant});
							var qty = parseInt(preOrder.inventory());

							var promptMsg = preOrder.prompt();

							if(po.length == 0){
								cont.append(poTmp);
								po = $('#po-prompt');
							}

							$('#preorder-me-alert').addClass('hidden').html('').hide();

							var lang = Weglot.getCurrentLang();

							// if(typeof(prompt) == 'object'){
							// 	prompt = prompt.html();
							// }

							// PreOrder
							if(prompt != ''){

								if(preOrder.enabled()){

									var pt = promptMsg.toLowerCase();

									if(lang == 'en'){

										if(qty <= 0){
											// _prompt.html('Item out of stock. This is a pre-order and ' + pt.toLowerCase()).show();
											// po.val('Item out of stock. This is a pre-order and ' + pt.toLowerCase());
											_prompt.html('' + pt).show();
											po.val('' + pt);

											$('#preorder-me-msg').html('').hide();

											setTimeout(function(){
												$('#preorder-me-msg').html('').hide();
											}, 500);
										}
										else{
											_prompt.html('Only ' + qty + ' in stock. The remaining quantity are pre-order items and ' + pt.toLowerCase()).show();
											po.val('Only ' + qty + ' in stock. The remaining quantity are pre-order items and ' + pt.toLowerCase());
										}
										// _prompt.html('Only ' + qty + ' in stock. The remaining quantity are pre-order items and ' + pt.toLowerCase()).show();
										// po.val('Only ' + qty + ' in stock. The remaining quantity are pre-order items and ' + pt.toLowerCase());
									}
									else{
										var days = pt.replace(/\D/g,'');
										var pt2;

										if (pt.indexOf('weeks') != 0) {
											if(parseFloat(days) == 1){
												pt2 = 'Versandfertig in ' + days  + ' Woche.';
											}
											else{
												pt2 = 'Versandfertig in ' + days  + ' Wochen.';
											}
										}
										else{
											if(parseFloat(days) == 1){
												pt2 = 'Versandfertig in ' + days  + ' Tage.';
											}
											else{
												pt2 = 'Versandfertig in ' + days  + ' Tagen.';
											}
										}

										// _prompt.html('' + pt).show();
										// po.val('' + pt);
										$('#preorder-me-msg').html('').hide();
										// setTimeout(function(){
										// 	$('#preorder-me-msg').html('').hide();
										// }, 500);


										// _prompt.html(pt2).show();
										// po.val(pt2);
										// _prompt.html('Nur '  + qty + ' verfügbar. Die restliche Anzahl ist ' + pt2).show();
										// po.val('Nur '  + qty + ' verfügbar. Die restliche Anzahl ist ' + pt2);
										// _prompt.html('Die restliche Anzahl ist ' + pt2).show();
										// po.val('Die restliche Anzahl ist ' + pt2);
										_prompt.html(pt2).show();
										po.val(pt2);
									}
								}
								else{

									var pt = promptMsg.toLowerCase();

									_prompt.html(pt.toLowerCase()).hide();
									po.val(prompt);

									// if(lang == 'en'){

									// 	console.log('Log 1 4 1');

									// 	_prompt.html('Item out of stock. This is a pre-order and ' + pt.toLowerCase()).show();
									// 	po.val('Item out of stock. This is a pre-order and ' + pt.toLowerCase());
									// }

								}
							}
							else{

								if(lang == 'en'){

									_prompt.html('Only ' + qty + ' in stock.').show();
									po.val('Only ' + qty + ' in stock.');
								}
								else{
									var days = pt.replace(/\D/g,'');
									var pt2;
									if (pt.indexOf('weeks') != 0) {
										if(parseFloat(days) == 1){
											pt2 = 'versandfertig in ' + days  + ' Woche.';
										}
										else{
											pt2 = 'versandfertig in ' + days  + ' Wochen.';
										}
									}
									else{
										if(parseFloat(days) == 1){
											pt2 = 'versandfertig in ' + days  + ' Tage.';
										}
										else{
											pt2 = 'versandfertig in ' + days  + ' Tagen.';
										}
									}

									_prompt.html(pt2).show();
									po.val(pt2);
								}
							}

						}
						else{
							_prompt.html('').hide();
							po.remove();
						}
					}, 400);
				}
				//         }

				// Fix double prompt2
				setTimeout(function(){
					var ct = $('[id="prompt2"]');
					if(ct.size() > 1){
						$('[id="prompt2"]').not(':first').remove();
					}
				}, 200);

				// Removing prompt2 if preorder-me-msg is shown
				if($('#prompt2').is(':visible'))
					if($('#prompt2').html() != '') $('#preorder-me-msg').hide();
				// ends

			}
		}

		var _promptCount = $('#prompt2').length;

		if(_promptCount > 1){
			$('#prompt2').last().remove();
		}

		//   Building the element
		var counter = $('#handleCounter');
		var counterParent = counter.parent();
		var counterClone = $('#handleCounter').clone(false);
		counter.remove();
		counterClone.appendTo(counterParent);
		$('#handleCounter').handleCounter(options);


	}, 100);

	var foobar = setTimeout(function(){

		if($('.min-bar').is(':visible')){

		}
		else{
			$('.selector-wrapper.quantity').click(function(){
				var bar2 =setTimeout(function(){
					if($('.min-bar').is(':visible')){

					}
					else{
						$('.product-quantity').first().trigger("click");
						clearTimeout(bar2);
						console.log(eventSrc);
					}

					$('.product-quantity').off();

				}, 200);

				clearTimeout(foobar);
			});
		}

		setTimeout(function(){
			$('.selector-wrapper.quantity').unbind();
			$('.product-quantity').unbind();
		}, 150);


	}, 200);

}

window.get_please_choose_options = function(){
	return getText("Please Choose Options");
}
window.get_add_to_cart = function(){
	return getText("Add to Cart");
}
window.get_please_select = function(){
	return getText("Please Select");
}
window.get_please_wait = function(){
	return getText("Please wait");
}
window.get_pre_order = function(){
	return getText("PreOrder");
}
window.get_sold_out = function(){
	return getText("Sold out");
}

window.getText = function(text){

	var please_choose_options = "Please Choose Options";
	var add_to_cart = "Add to Cart";
	var please_select = "Please Select";
	var please_wait = "Please wait";
	var pre_order = "PreOrder";
	var sold_out = "Sold out";

	if(getCurrentLang() == 'en'){

		if(text == please_choose_options)
		return please_choose_options;
		else if(text == add_to_cart)
		return add_to_cart;
		else if(text == please_select)
		return please_select;
		else if(text == please_wait)
		return please_wait;
		else if(text == pre_order)
		return pre_order;
		else if(text == sold_out)
		return sold_out;
		else return text;
	}
	else if(getCurrentLang() == 'de'){

		if(text == please_choose_options)
		return 'Bitte auswählen';
		else if(text == add_to_cart)
		return 'In den Warenkorb';
		else if(text == please_select)
		return 'Bitte auswählen';
		else if(text == please_wait)
		return 'Bitte Warten';
		else if(text == pre_order)
		return 'Vorbestellen';
		else if(text == sold_out)
		return 'Ausverkauft';
		else return text;
	}
	else if(getCurrentLang() == 'fr'){

		if(text == please_choose_options)
		return 'Sélectionner';
		else if(text == add_to_cart)
		return 'Ajouter (au panier)';
		else if(text == please_select)
		return 'Sélectionner';
		else if(text == please_wait)
		return 'Patienter';
		else if(text == pre_order)
		return 'Pré-commander';
		else if(text == sold_out)
		return 'En rupture de stock';
		else return text;
	}
	else return text;
}

window.getCurrentLang = function(){
	return Weglot.getCurrentLang();
};

// Ends

/*
* Also Bought App.
* Runs on Single Product page.
* Adding Price and Tags to Also Bought app widget on Product page.
*/
$(document).ready(function(){

	// Works only on Product page.
	if(!$('body').hasClass('template-product')){
		return;
	}

	// Adding fields using Shopify JSON API
	function modifyAlsoBought(){

		$('.cbb-also-bought-container');
		//         $('.cbb-also-bought-container').addClass('content-area').removeAttr('style');

		$.each($('.cbb-also-bought-slider-list .cbb-also-bought-product'), function(){

			// Fetching product handle
			var href = $(this).find('.cbb-also-bought-product-name a');
			var url = href.attr('href');
			var handle = url.substr(url.lastIndexOf('/') + 1);
			var that = $(this);

			// Pulling Product Data using Shopify jQuery API
			jQuery.getJSON('/products/' + handle + '.js', function(product) {

				// Adding Price
				var price_min = product.price_min;
				var price_max = product.price_max;

				price_min = Shopify.formatMoney(price_min,Theme.moneyFormat);
				price_max = Shopify.formatMoney(price_max,Theme.moneyFormat);

				var templatePrice = '<p class="price"><span class="money" data-currency-eur="' + price_min + ' — ' + price_max + '" data-currency="EUR">' + price_min + ' — ' + price_max + '</span></p>';
				that.append(templatePrice);

				// Adding Brand
				var tags = product.tags;
				var tag = '';

				// Expected Tags
				var values = ['Hand Embroidered','Hand Finished','Hand Crafted','Hand Printed'];

				$.each(tags, function(index, value){
					for(var i = 0; i < values.length; i++){
						if(values[i] == value){
							tag = values[i];
							return;
						}
					}
				});

				if(tag != ''){
					var templateBrand = '<span class="brand">' + tag + '</span>';
					that.find('.cbb-also-bought-product-name').prepend(templateBrand);
				}
			});
		});
	}

	/*
	* Also Bought app loads functions async.
	* We don't know when it finishes loading, so wait for a while and try again until it fully loads.
	*/

	// Wait 10 secs maximum and break.
	var maxRun = 40;
	var i = 0;

	// This function re-runs itself until the Also Bought App finishes loading.
	function waitAndLoadAlsoBoughtApp(){

		if($('.page-body-content .cbb-also-bought-slider-list').length){
			modifyAlsoBought();
		}
		else{
			if(i <= maxRun){
				setTimeout(function(){
					i++;
					waitAndLoadAlsoBoughtApp();
				}, 250);
			}
		}
	}

	waitAndLoadAlsoBoughtApp();
});

// Also Bought app code ends

/*
* This is an important Variable for firing Resize event only one time.
*/
var waitForFinalEvent = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if(!ms){
			ms = 500;
		}
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}
		if (timers[uniqueId]) {
			clearTimeout (timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

/*
* Collection page Placeholder products
* On Desktop, if there are 2 placeholders, move one to the 5th. Leave the second at last
* On Tablet, only one.
* On Mobile, no placeholder
*/
function initPlaceHolders(){
	$(document).ready(function(){
		// Works only on Collection pages.
		if(!$('body').hasClass('template-collection')){
			return;
		}

		function placeHolders(){

			var screenSize = 'desktop';
			var colCount = 3;

			if(isTablet()){
				screenSize = 'tablet';
				colCount = 2;
			}
			else if(isMobile()){
				screenSize = 'mobile';
				colCount = 1;
			}

			var products = $('.product-list .product:not(".product-placeholder")');
			var placeHolders = $('.product-list .product-placeholder');

			if(screenSize == 'desktop' || screenSize == 'tablet'){

				var placeHolderCountToAdd = colCount - (products.length % colCount);

				if(placeHolderCountToAdd == 1){
					var placeHolder = placeHolders.first().detach();

					$.each(placeHolders, function(){
						$(this).hide();
					});

					$('.product-list').append(placeHolder.css('display','inline-block'));
				}
				else if(placeHolderCountToAdd == 2){
					var placeHolder = placeHolders.first().detach();
					var prevProduct = $('.product-list .product:nth-child(4)');
					placeHolder.insertAfter(prevProduct).css('display','inline-block');
				}
				else{
					$.each(placeHolders, function(){
						$(this).hide();
					});
				}
			}
			else{
				$.each(placeHolders, function(){
					$(this).hide();
				});
			}
		}

		placeHolders();

		$(window).resize(function () {
			waitForFinalEvent(function(){
				placeHolders();
			});
		});
	});
}
initPlaceHolders();

/*
* Making Collection page header images keep ratio on screen sizes
*/
$(document).ready(function(){
	// Works only on Collection pages.
	if(!$('body').hasClass('template-collection') && !$('body').hasClass('template-page')){
		return;
	}

	// Otherwise, here we go
	function keepCollectionPageHeaderRatio(){

		// Defining base ratio.
		var maxWidth = 1440;
		var maxHeight = 640;

		if($('.page-title.collection-title-header').attr('data-initial-height') != ''){
			maxHeight = $('.page-title.collection-title-header').attr('data-initial-height');
		}

		var windowWidth = $(window).width();
		var header = $('header.page-title.collection-title-header');
		// Decrease header height only smaller screens

		if(windowWidth < maxWidth){

			var widthRatio = parseFloat(windowWidth) / maxWidth;
			var calculatedHeaderHeight = parseFloat(maxHeight) * widthRatio;

			header.outerHeight(calculatedHeaderHeight);
		}
		else{
			header.outerHeight(maxHeight);
		}
	}

	// First Run
	keepCollectionPageHeaderRatio();

	$(window).resize(function () {
		waitForFinalEvent(function(){
			keepCollectionPageHeaderRatio();
		}, 200);
	});
});
// Collection page header aspect ratio function end

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setCookieInSeconds(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCountryCode(){

	var ipinfo = getCookie('malaika-ipinfo');

	if(!ipinfo){

		//     return $.get("https://ipinfo.io?token=47955fb2961668", function(response) {
		//     return $.get("https://ipinfo.io?token=5f8c5f2562bdbd", function(response) {
		return $.get("https://ipinfo.io?token=38aeecafdd9f6e", function(response) {
			var countryCode = response.country;
			$('body').attr('countryCode', countryCode);
			setCookie('malaika-ipinfo', countryCode, 1);
			return countryCode;
		}, "jsonp");
	}
	else{
		return ipinfo;
	}
}
getCountryCode();

/*
* Location Redirection Notification Popup.
* Using MagnificPopup library of SmashingMagazine here.
*/
$(document).ready(function(){

	$('.open-language-popup-cart-link').magnificPopup({
		type:'inline',
		modal: true,
		mainClass: 'mfp-fade',
		callbacks: {
			open: function(){
				$('.mfp-wrap').css("overflow-y", "scroll")
			},
			close: function() {
				if(getCookie('malaika-language-cart-accepted') != 'accepted'){
					window.location.href = '/checkout';
				}
			}
		},
	});

	$('.open-language-popup-home-link').magnificPopup({
		type:'inline',
		modal: true,
		mainClass: 'mfp-fade',
		callbacks: {
			open: function(){
				$('.mfp-wrap').css("overflow-y", "scroll")
			},
		},
	});

	// Accepted. Closing popup and creating "Accepted" cookie
	$('.accept-language-popup-cart').click(function(){
		setCookie('malaika-language-cart-accepted', 'accepted', 30);
		var magnificPopup = $.magnificPopup.instance;
		magnificPopup.close();

		window.location.href = '/checkout';
	});

	$('.accept-language-popup-home').click(function(){
		setCookie('malaika-language-home-accepted', 'accepted', 30);

		var magnificPopup = $.magnificPopup.instance;
		magnificPopup.close();
	});

	$('#language-popup-cart .decline-language-cart-popup, #language-popup-cart .mfp-close').click(function(e){
		window.location.href = 'https://malaika-store.com/pages/malaika-deutschland';
	});

	function checkLanguagePopupHomeCookie(){
		if(getCookie('malaika-language-home-accepted') != 'accepted'){
			$('.open-language-popup-home-link').trigger('click');
		}
	}


	function showDollarCountry(countryCode){
		// Showing currency country code in front of price

		var currentCur = $('select[name="currency"]').val();

		if($('body').hasClass('template-product')){
			if(currentCur == 'AUD' || currentCur == 'CAD' || currentCur == 'HKD'){

				var prContainer = $('.product-details').find('.price');
				var pr = '<span class="currCountry">' + currentCur + '</span>';
				prContainer.append(pr);
			}
			else{
				if($('.currCountry').length > 0){
					$('.currCountry').remove();
				}
			}
		}
		else if($('body').hasClass('template-collection')){
			if(currentCur == 'AUD' || currentCur == 'CAD' || currentCur == 'HKD'){

				var prContainer = $('.product-card-details').find('.price');
				var pr = '<span class="currCountry">' + currentCur + '</span>';
				prContainer.append(pr);
			}
			else{
				if($('.currCountry').length > 0){
					$('.currCountry').remove();
				}
			}
		}
	}

	function checkCountries(){

		var countryCode = getCountryCode();
		if(typeof(countryCode) != 'string'){
			setTimeout(function(){
				checkCountries();
			}, 500);
		}
		else{
			checkNoSellCountries(countryCode);
			checkBerlinProvince(countryCode);
			showDollarCountry(countryCode);
			checkUK(countryCode);
		}
	}
	checkCountries();

	$('.cart-tools .checkout .action-button[name="checkout"]').attr('id','checkoutBtn');
	var myClone = $('.cart-tools .checkout .action-button[name="checkout"]').clone().attr('id','checkoutBtnClone');
	$('#checkoutBtn').css('display','none');
	$('.cart-tools .checkout').prepend(myClone);

	$('.mini-cart .action-button.checkout').attr('id','checkoutBtnMini');
	var myCloneMini = $('#checkoutBtnMini').clone().attr('id','checkoutBtnCloneMini');

	$('#checkoutBtnMini').css('display','none');
	$('.mini-cart .options').prepend(myCloneMini);

	$('body').on('click','.checkout #checkoutBtnClone, #checkoutBtnCloneMini', function(e){
		//     e.preventDefault();
		// We need it no more
		//     checkLanguagePopupCartCookie(e);
	});
});

// Redirect some countries to other site
function checkNoSellCountries(countryCode){
	var arr = [
		//         'MN', 
		'EE',
		'EG'
	];

	if ( $.inArray(countryCode, arr) > -1 ) {

		if($('body').attr('id') != 'shashiko-bedding-collection'){
			window.location.replace("//egypt.malaikalinens.com");
		}
	}
}

// Popup for Berlin/Brandenburg users
function checkBerlinProvince(countryCode){

	if(countryCode == 'DE' || countryCode == 'MN'){
		//  Continues
	}
	else{
		return false;
	}

	if(countryCode == 'UK' || countryCode == 'GB'){
		return false;
	}

	function newsletterPopup(){

		$('.open-newsletter-popup').magnificPopup({
			type:'inline',
			mainClass: 'mfp-fade',
			closeOnBgClick: true,
			showCloseBtn: true,
			enableEscapeKey: true,
			closeOnContentClick: false,
			callbacks: {
				open: function(){
					$('.mfp-wrap').css("overflow-y", "scroll")
				},
				close: function() {
					if(getCookie2('malaika-newsletter-popup-showed') != true){
						setCookieInSeconds('malaika-newsletter-popup-showed','true', 60 * 60 * 24 * 7);//7 days
					}
				}
			},
		});

		if(typeof(getUrlVars()["customer_posted"]) != 'undefined'){
			$('.open-newsletter-popup').trigger('click');
			return false;
		}
		else if(typeof(getUrlVars()["form_type"]) != 'undefined'){
			if(typeof(getUrlVars()["contact%5Btags%5D"]) != 'undefined'){
				$('.open-newsletter-popup').trigger('click');
				$('#contact_form').hide();
				$('#contact-form-existing').show();
				return false;
			}
			else{
				$('#contact_form').show();
				$('#contact-form-existing').hide();
			}
		}

		if(!getCookie2('malaika-newsletter-popup-showed')){
			setCookieInSeconds('malaika-newsletter-popup-showed','true', 60 * 60 * 24 * 7);//7 days
			$('.open-newsletter-popup').trigger('click');
		}
	}

	setTimeout(newsletterPopup, 1000 * 60 * 3);
}

function getCookie2(name) {
	function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
	var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
	return match ? match[1] : null;
}

// Popup for Berlin/Brandenburg users
function checkUK(countryCode){
	if(countryCode == 'UK' || countryCode == 'MN' || countryCode == 'GB'){
		//  Continues
	}
	else{
		return false;
	}

	function ukPopup(){

		$('.open-uk-popup').magnificPopup({
			type:'inline',
			mainClass: 'mfp-fade',
			closeOnBgClick: true,
			showCloseBtn: true,
			enableEscapeKey: true,
			closeOnContentClick: false,
			callbacks: {
				open: function(){
					$('.mfp-wrap').css("overflow-y", "scroll")
				},
				close: function() {
					if(getCookie('malaika-uk-popup-showed') != 'true'){
						setCookie('malaika-uk-popup-showed', 'true', 1);
					}
				}
			},
		});

		// Show Popup if visitor is on the site for 2 minutes
		if(getCookie('malaika-uk-popup-showed') != 'true'){
			setCookieInSeconds('malaika-uk-popup-no-show','true', 10 * 1);// 10 secs
		}

		function recursiveCheckUkPopup(){

			if(getCookie('malaika-uk-popup-showed') != 'true'){
				if(getCookie('malaika-uk-popup-no-show') == 'true'){
					setTimeout(recursiveCheckUkPopup, 1000);
				}
				else{
					setCookieInSeconds('malaika-uk-popup-showed','true', 60 * 60 * 3 * 1);//sec * min * hours * days = 3 hours.
					$('.open-uk-popup').trigger('click');
				}
			}
		}

		recursiveCheckUkPopup();
	}
	// UK Popup end

	// ukPopup();
}

// Currency
$(document).ready(function(){

	$('.shopify-currency-form select').on('change', function() {

		$(this).parents('form').submit();

		return;

		var url = window.location.href;

		if(typeof(getUrlVars()["variant"]) == 'undefined'){
			url += '?';
		}
		else{
			url += '&';
		}

		url += 'currency=' + $(this).val();

		$.get(url, function(formData) {
			console.log('success');
		})
		.fail(function(data) {
			console.log('fail');
		});

	});
});

// Translate Cookie Bar
$(document).ready(function(){

	function cookieBarTranslate(){

		function _translate(countryCode){

			var cookieBar = $('.cc-window');

			var desk = cookieBar.find('.cc-message');
			var close = cookieBar.find('.cc-dismiss');
			var settings = cookieBar.find('.cc-settings');
			var allow = cookieBar.find('.cc-allow');

			var dialog = $('.cc-settings-dialog');

			if(countryCode != 'DE'){

				desk.html('This website uses cookies to ensure you get the best experience on our website. ' +
				'<a aria-label="learn more about cookies" role="button" tabindex="0" class="cc-link" ' +
				'href="https://malaikalinens.com/pages/privacy-policy" rel="noopener noreferrer nofollow" ' +
				'target="_blank">Privacy Policy</a>');
				close.html('Close');
				settings.html('Preferences');
				allow.html('Accept');

				dialog.html('<span class="cookie_settings_header">Choose Type of Cookies You Accept Using' +
				'</span><br><br><label><input type="checkbox" checked="checked" disabled="disabled" value="functional"> ' +
				'Strictly Required Cookies</label><br>' +
				'These cookies are required for the website to run and cannot be switched off. Such cookies are only set in response to actions made by you such as language, currency, login session, privacy preferences. You can set your browser to block these cookies but this might affect the way our site is working.<br><br><label><input type="checkbox" name="cookie_isl_analytics" value="analytics"> Analytics and Statistics</label><br> These cookies allow us to measure visitors traffic and see traffic sources by collecting information in data sets. They also help us understand which products and actions are more popular than others.<br><br><label><input type="checkbox" name="cookie_isl_marketing" value="marketing"> Marketing and Retargeting</label><br> These cookies are usually set by our marketing and advertising partners. They may be used by them to build a profile of your interest and later show you relevant ads. If you do not allow these cookies you will not experience targeted ads for your interests. ' +
				'<br><br><div class="cc-compliance cc-highlight"><a class="cc-btn cc-btn-close-settings">Close</a>&nbsp;&nbsp;<a class="cc-btn cc-btn-save-settings">Save Changes</a></div>');
			}

			cookieBar.attr('data-translated', 'true');
		}

		function checkCookieBar(countryCode){
			var cookieBar = $('.cc-window');
			if((cookieBar).length <= 0){
				setTimeout(function(){
					checkCookieBar(countryCode);
				}, 200);
			}
			else{
				_translate(countryCode);
			}
		}

		function checkCountries(){

			var countryCode = getCountryCode();
			if(typeof(countryCode) != 'string'){
				setTimeout(function(){
					checkCountries();
				}, 200);
			}
			else{
				checkCookieBar(countryCode);
			}
		}
		checkCountries();
	}

	cookieBarTranslate();
});

// Covid and Announcement bar replace on product page
$(document).ready(function(){

	// function switchBars(front,back){
	// 	front.addClass('announcement-bar-back').removeClass('announcement-bar-front');
	// 	back.removeClass('announcement-bar-back').addClass('announcement-bar-front');
	//
	// 	setTimeout(function(){
	// 		switchBars(back,front);
	// 	}, 7000);
	// }
	//
	// var front = $('.template-product .announcement-bar-front');
	// var back = $('.template-product .header-message');
	// var last = $('.template-product .announcement-bar-last');
	//
	// back.addClass('announcement-bar-back');
	//
	// switchBars(front,back);
});

$(document).ready(function(){

	if(!$('body').hasClass('template-product'))
		return;

	var itemCount = $('.announcement-bar-item').length;

	setTimeout(function(){
		switchBar(	$( ".announcement-bar-front" ));
	}, 7000);

	function switchBar(item){

		var idx = item.index();

		if(idx+1 == itemCount)
			idx = 0;
		else
				idx++;

		var next = $($('.announcement-bar-item')[idx]);

		item.removeClass('announcement-bar-front').addClass('announcement-bar-back');
		next.addClass('announcement-bar-front').removeClass('announcement-bar-back');

		setTimeout(function(){
			switchBar(next);
		}, 7000);
	}

});

// Covid and Announcement bar replace on product page
// $(window).load(function(){

//   if(!$('body').hasClass('template-cart')){
//     return false;
//   }

//   jQuery.getJSON('/cart.js', function(cart) {

//     var cart_items = cart.items;
//     var _form = $('#cart-form');
//     var _items = _form.find('.product-item');
//     //     var _items = _form.find('data-cart-item');

//     var hasFragileShipment = false;
//     var hasFragileAlready = false;
//     for(var i=0; i < _items.length; i++){

//       var _item = $(_items[i]);
//       var item_parent = _item.parent();

//       // Checking if it's a preOrder item
//       if(_item.find('.preorder-item').length > 0){

//         var ordering = _item.parent().find('.quantity input').attr('value');
//         var max = _item.parent().find('.quantity input').attr('data-max');

//         if(ordering > max){
//           CartJS.updateItem(i + 1, ordering, {
//             "PreOrder": _item.find('.preorder-item').html()
//           });
//         }
//         else{
//           CartJS.updateItem(i + 1, ordering, {
//           });
//         }
//       }

//       // Checking if it's a fragile item
//       if(item_parent.data('variant-id') == '33229787660365'){
//         hasFragileAlready = true;
//       }
//       if(item_parent.data('is-fragile') == true){
//         hasFragileShipment = true;
//       }
//     }


//   } );

// });

// Function runs on Cart page. To scan each item's preorder status and add/remove preorder prompt
var scanCart = function(btn){

	// Grouped preOrderMe_
	class c_preOrderMe {

		constructor(productID, variantID){
			this.widget = $('.preorder-info-' + productID);
			this.productID = productID;
			this.variantID = variantID;
		}

		seed(){
			return JSON.parse(this.widget.attr('data-seed'));
		}

		mf(){
			return JSON.parse(this.widget.attr('data-mf'));
		}

		seedVariant(){
			var seeds = this.seed(); var result = false;
			for (var i = 0; i < seeds.length; i++){
				if(seeds[i].id == this.variantID){
					result = seeds[i]; break;
				}
			}
			return result;
		}

		mfVariant(){
			return this.mf()[this.variantID];
		}

		getInventory(){
			return this.seedVariant().inventory_quantity;
		}

		getPrompt(){
			return this.mfVariant().prompt;
		}
	}

	class loadingStatus{

		constructor(btn){
		}

		// Set loading status on elements
		start(){
			$('.action-button').prop('disabled',true);
			$('.cart-update-inline').prop('disabled',true);

			$('#cart-form').css('opacity', 0.8);

			animateCartBtn(btn, 300);

			setTimeout(function(){
				animateCartBtn(btn, 300);
			}, 300 * 4);
		}

		// enable elements
		end(){
			$('.action-button').prop('disabled',false);
			$('.cart-update-inline').prop('disabled',false);
		}
	}

	var animateCartBtn = function(btn, interval){
		setTimeout(function(){
			$(btn).text('Loading');
			setTimeout(function(){
				$(btn).text('Loading.');
				setTimeout(function(){
					$(btn).text('Loading..');
					setTimeout(function(){
						$(btn).text('Loading...');
					}, interval);
				}, interval);
			}, interval);
		}, interval);
	}

	var load = new loadingStatus(btn);
	load.start();

	jQuery.getJSON('/cart.js', function(cart) {

		// console.log('jQuery.getJSON');

		var cart_items = cart.items;
		var _form = $('#cart-form');
		// var _items = _form.find('.product-item');

		var hasFragileShipment = false;
		var hasFragileAlready = false;

		// for(var i = 0; i < _items.length; i++){

			// var _item = $(_items[i]);
			var _item = btn.parent().parent().find('.product-item');

			var item_parent = _item.parent();

			var variantID = _item.parent().data('variant-id');
			var productID = _item.parent().data('product-id');

			var gp = new c_preOrderMe(productID,variantID);



			var seed = gp.seedVariant();
			var mf = gp.mfVariant();
			var inventory_policy = seed.inventory_policy;
			var inventory = gp.getInventory();
			var prompt = gp.getPrompt();

			// current qty
			var qty = item_parent.find('.product-quantity').val();

			var preOrderEnabled;

			if(inventory_policy == 'continue' && mf.enabled == true)
			preOrderEnabled = true;
			else preOrderEnabled = false;

			var promptPre = 'Only ' + inventory +' in stock. The remaining quantity are pre-order and ' + prompt;

			if( inventory < 0){
				// promptPre = 'Item out of stock. This is a pre-order and ' + prompt;
				promptPre = '' + prompt;
			}

			prompt = promptPre;

			var idx =  $(_item).parent().index();

			// console.log(btn);
			// console.log(_item);
			// console.log(variantID);
			// console.log(qty);
			// console.log(idx);

			// Check if ordering less than inventory
			// then add prompt
			if((qty > inventory && preOrderEnabled) || inventory < 0){
				// console.log('Add prompt');

				CartJS.updateItemById(variantID, qty,
					{
						"PreOrder": prompt
					},
					{
						"success": function(data, textStatus, jqXHR) {
							load.end();
							setTimeout(function(){
								$('.cart__submit-control').click();
							}, 1000);
						},
						"error": function(jqXHR, textStatus, errorThrown) {
							$('.cart__submit-control').click();
						}
					}
				);

			}
			else{
				// console.log('Remove prompt');

				// console.log(variantID);

				// CartJS.removeItemById(variantID);

				// setTimeout(function(){
				// 	CartJS.addItem(variantID, qty, {},
				// 		{
				// 			"success": function(data, textStatus, jqXHR) {
				// 				load.end();
				// 				setTimeout(function(){
				// 					$('.cart__submit-control').click();
				// 				}, 1000);
				// 			},
				// 			"error": function(jqXHR, textStatus, errorThrown) {
				// 				$('.cart__submit-control').click();
				// 			}
				// 		}
				// 	);
				// }, 500)
				// CartJS.updateItemById(variantID, 0);
				// CartJS.addItem(variantID, qty, {},
				// 	{
				// 		"success": function(data, textStatus, jqXHR) {
				// 			load.end();
				// 			setTimeout(function(){
				// 				$('.cart__submit-control').click();
				// 			}, 1000);
				// 		},
				// 		"error": function(jqXHR, textStatus, errorThrown) {
				// 			$('.cart__submit-control').click();
				// 		}
				// 	}
				// );

				CartJS.updateItemById(variantID, qty, {
					"PreOrder": "In stock"
				},
							{
								"success": function(data, textStatus, jqXHR) {
									load.end();
									setTimeout(function(){
										$('.cart__submit-control').click();
									}, 1000);
							}},

				);

				// CartJS.removeItemById(variantID,
				// 	{
				// 		"success": function(data, textStatus, jqXHR) {
				// 		}
				// 	}
				// );
				//
				// CartJS.addItem(variantID, qty, {},
				// 	{
				// 		"success": function(data, textStatus, jqXHR) {
				// 			load.end();
				// 			setTimeout(function(){
				// 				$('.cart__submit-control').click();
				// 			}, 1000);
				// 		},
				// 		"error": function(jqXHR, textStatus, errorThrown) {
				// 			$('.cart__submit-control').click();
				// 		}
				// 	}
				// );

				// CartJS.addItem(variantID, qty, {},
				// 	{
				// 		"success": function(data, textStatus, jqXHR) {
				// 			load.end();
				// 			setTimeout(function(){
				// 				$('.cart__submit-control').click();
				// 			}, 1000);
				// 		},
				// 		"error": function(jqXHR, textStatus, errorThrown) {
				// 			$('.cart__submit-control').click();
				// 		}
				// 	}
				// );
			}
		// }
		// for ends

		// setTimeout(function(){
		// 	$('.cart__submit-control').click();
		// }, 2000);
	});
	// end getJson
}
// scancart ends

$(document).ready(function(){
	if(!$('body').hasClass('template-cart')){
		return false;
	}
	$('form input').keydown(function (e) {
		if (e.keyCode == 13) {
			var inputs = $(this).parents("form").eq(0).find(":input");
			if (inputs[inputs.index(this) + 1] != null) {
				inputs[inputs.index(this) + 1].focus();
			}
			e.preventDefault();
			return false;
		}
	});

	// Removing incomplete preorder message
	$('.item-properties').each(function(){
		if($(this).html().trim() == '<strong>PreOrder: In stock</strong>'){
			$(this).html('');
		}
	});
});

// Covid and Announcement bar replace on product page
$(window).load(function(){
	// Event handling here.
	if(!$('body').hasClass('template-cart')){
		return false;
	}
});

$(document).on('cart.ready', function(event, cart) {
	// Event handling here.
	if(!$('body').hasClass('template-cart')){
		return false;
	}
});

// To run function after resize finished
var resized = (function () {
	var timers = {};
	return function (callback, ms, uniqueId) {
		if (!uniqueId) {
			uniqueId = "Don't call this twice without a uniqueId";
		}
		if (timers[uniqueId]) {
			clearTimeout (timers[uniqueId]);
		}
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();






// Grouped products
$(document).ready(function(){

	if(!$('body').hasClass('template-collection')){
		return false;
	}

	$('.action-button.submit').click(function(e){

		e.preventDefault();

		var btn = $(this);

		var form = btn.closest('.product-form');
		var variant = form.data('variant');
		var notice = form.find('.added-product-notice');
		var originalText = btn.data('original-text');
		btn.data("original-text", btn.val()).val(get_please_wait()).addClass("disabled");

		CartJS.addItem(variant, 1, {
			//           "size": "XL"
		}, {
			"success": function(data, textStatus, jqXHR) {
				btn.val(btn.data("original-text")).removeClass('disabled').prop('disabled',false);
				notice.show();
			},
			"error": function(jqXHR, textStatus, errorThrown) {
				console.log('Error: ' + errorThrown + '!');
				btn.val(btn.data("original-text")).removeClass('disabled').prop('disabled',false);
				notice.hide();
			}
		});
	});
});

$(document).ready(function(){

	if(!$('body').hasClass('template-index') && !$('body').hasClass('template-page')){
		return;
	}

	// Homepage Feedback badges
	var $slider = $('.product-list-slider');

	const settings = {
		slidesToShow: 4,
		slidesToScroll: 1,
		draggable: true,
		arrows: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	}
});

// Grouped products
function updateQueryString(key, value, url) {

	if (!url) url = window.location.href;

	let updated = ''
	var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
	hash;

	if (re.test(url)) {
		if (typeof value !== 'undefined' && value !== null) {
			updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
		}
		else {
			hash = url.split('#');
			url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
			if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1];
			}
			updated = url;
		}
	}
	else {
		if (typeof value !== 'undefined' && value !== null) {
			var separator = url.indexOf('?') !== -1 ? '&' : '?';
			hash = url.split('#');
			url = hash[0] + separator + key + '=' + value;
			if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1];
			}
			updated = url;
		}
		else {
			updated = url;
		}
	}

	window.history.replaceState({ path: updated }, '', updated);
}

$(document).ready(function(){

	$('.grouped-qty').change(function(){
		$(this).attr('value',$(this).val());

		qtyChange($(this));
	});

	function grouped_add_to_cart(e, btn){

		var original_text = btn.val();
		btn.val('Please wait');
		btn.prop('disabled','disabled');
		btn.toggleClass('disabled');

		var form = btn.closest('.grouped-form');
		var variant = form.find('.grouped-selected-variant').val();
		var qty_selector = form.find('.grouped-qty');
		qty_selector.change();
		var qty = qty_selector.attr('value');

		if(!qty) qty = 1;

		var prompt = form.find('.grouped-preorder-info').html();

		CartJS.addItem(variant, qty, {
			"PreOrder": prompt,
			"_grouped": 1,
			"_grouped_url": window.location.href
		}, {
			"success": function(data, textStatus, jqXHR) {
				$('.grouped-added-product-notice').fadeIn();
				setTimeout(function(){
					btn.val(original_text);
					btn.prop('disabled',false);
					btn.toggleClass('disabled');

					setTimeout(function(){
						$('.grouped-added-product-notice').fadeOut();
					},3000);
				},1500);

			},
			"error": function(jqXHR, textStatus, errorThrown) {
				console.log('Error: ' + errorThrown + '!');
			}
		});
	}

	$('.grouped-add-to-cart').click(function(e){
		e.preventDefault();
		grouped_add_to_cart(e, $(this));
	});

	$('.product-grouped-product-form .product-card-details .title a').click(function(e){
		e.preventDefault();
	});

	// Grouped preOrderMe_
	function getGroupedVariant(product,variant){

		var g_preOrderMe = function(product){
			var widget = $('.preorder-info-' + product)
			return JSON.parse(widget.attr('data-mf'));
		}

		if(typeof(window.PreOrderMeBtn) == 'undefined'){
			setTimeout(function(){
				getGroupedVariant(product,variant);
			}, 100);
		}
		else{

			var gp = new g_preOrderMe(product);

			for(var key in gp){
				if(key == variant){
					var form = $('.preorder-info-' + product).closest('form');
					form.find('.grouped-preorder-info').html(gp[key].prompt);
				}
			}
		}
	}

	$.each($('.grouped-form'), function(){
		var sel = $(this).find('.select-wrapper').last();
		sel.change();
	});
	$('.gp-masterselect').change(function(){
		var product = $(this).parent().parent().parent().data('product-id');
		var variant = $('#product-select-' + product).attr('value');

		// Preparing the Qty counter input
		var it = $('#qty-' + product);
		var form = it.closest('.grouped-form');
		var option = form.find('option[data-variant="' + variant + '"]');
		var preorder_enabled = option.data('continue-selling') == 1;
		var inv_qty = option.data('qty');

		// Changing image
		var img = option.data('img');
		if(typeof(img) != 'undefined'){
			var li = $('.product-' + product);

			if(!img.includes("no-image")){
				var img_first = li.find('.enk-collection-product-image-first');
				img_first.prop('src',img);
			}
		}

		// Recreating counter
		var counter = $('#handleCounter-' + product);
		var input = counter.find('.product-quantity');

		var parent = counter.parent();
		var clone = counter.clone();

		clone.off();
		input.off();
		counter.remove();
		parent.append(clone);

		counter = $('#handleCounter-' + product);
		input = counter.find('.product-quantity');
		var prodID = product;

		if(preorder_enabled){
			inv_qty = 999;
		}

		if(option.length == 0)
		return;

		var options = {
			minimum: 1,
			maximize: inv_qty,
			onChange: function(d){

				$(input).attr('value',d);
				$('#' + prodID + ' input').change();
				$('#qty-' + prodID).val(d).change();
			},
		}
		counter.handleCounter(options);

		getGroupedVariant(product, variant);
		qtyChange($('#qty-' + product));
	});

	//   Quantity event
	function qtyChange(it){

		var new_qty = it.val();

		var form = it.closest('.grouped-form');
		var variant = form.find('.grouped-selected-variant').val();

		var warning = form.find('.grouped-variant-warning');

		var option = form.find('option[value="' + variant + '"]');
		var inv_qty = option.data('qty');
		var preorder_enabled = option.data('continue-selling') == 1;

		var warning_msg = 'Only ' + inv_qty +' in stock. The remaining quantity are pre-order items and ';
		var preorder_info = form.find('.grouped-preorder-info');

		new_qty = parseFloat(new_qty);
		inv_qty = parseFloat(inv_qty);

		if(preorder_enabled){
			if(inv_qty > 0){
				//product is in stock
				if(new_qty > inv_qty){
					warning_msg = 'Only ' + inv_qty +' in stock. The remaining quantity are pre-order items and ';
					warning.html(warning_msg);
					var txt = preorder_info.html();
					preorder_info.html(txt.toLowerCase());
					preorder_info.show();
				}
				else{
					warning.html('');
					preorder_info.hide();
				}
			}
			else{
				// out of stock
				warning.html('');
				preorder_info.show();

			}
		}
		else{
			if(inv_qty > 0){
				preorder_info.hide();
				warning_msg = 'Only ' + inv_qty +' in stock.';
				warning.html(warning_msg);
			}
			else{
				warning_msg = '';
				warning.html(warning_msg);
				preorder_info.hide();
			}
		}
	}

	// Cart page
	$('.cart-update-inline').click(function(e){
		e.preventDefault();

		// var up = $(this);

		// Shopify.getCart(function(cart) {

		// var row = up.closest('tr.table-row');
		// var variant = row.data('variant-id');
		// var idx = row.index();
		// var input = up.parent().find('.product-quantity').first();
		// var new_qty = input.val();

		// var qty = parseInt(input.data('max'));
		// var enabled = (input.data('max') == 999);

		var btn = $(this);
		setTimeout(function(){
			scanCart(btn);
		}, 500);
		// });
	});

	// Collection page header slider
	var $slider = $('.grouped-header-slider');
	var settings = {
		//     draggable: true,
		arrows: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4000,
		infinite: true,
		//     slidesToShow: 1,
		//     slidesToScroll: 1,
		variableWidth: true,
		centerMode: true,
		//     lazyLoad: 'progressive',
		//     prevArrow: '<button class="slide-arrow prev-arrow"></button>',
		//     nextArrow: '<button class="slide-arrow next-arrow"></button>'
		//     prevArrow: '<img class="a-left control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/0013/9431/1233/files/back.svg?v=1600657634" data-wg-notranslate="manual">',
		//     nextArrow: '<img class="a-right control-c next slick-next" src="https://cdn.shopify.com/s/files/1/0013/9431/1233/files/next.svg?v=1600657634" data-wg-notranslate="manual">',
		prevArrow: '<img class="a-left control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/2273/6209/files/back.svg?v=1645890155" data-wg-notranslate="manual">',
		nextArrow: '<img class="a-right control-c next slick-next" src="https://cdn.shopify.com/s/files/1/2273/6209/files/next.svg?v=1645890142" data-wg-notranslate="manual">',

		responsive: [{
			breakpoint: 720,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				//         adaptiveHeight: true,
				centerMode: true,
				//     infinite: true,
			}
		}]
	};
	var sl = $slider;

	sl.on('lazyLoaded', function(event, slick, image, imageSource){
		// left
	}).slick(settings);

	setTimeout(function(){
		$('.grouped-header-slider-wrapper').css('opacity',1);
	}, 1000);

});

// On Page load, setting handle counters
$(document).on('ready', function(){

	var buildHandleCounters = function(){

		if(!$('body').hasClass('template-cart')){
			return;
		}

		$.each($('.handle-counter'), function(){
			var $enkID = $(this).prop('id');
			var $enkQtyInput = $('#'+$enkID).find('.product-quantity');
			var $enkMax = $enkQtyInput.attr('data-max');

			var options = {
				minimum: 1,
				maximize: $enkMax,
				onChange: function(d){

					if($('body').hasClass('template-cart')){

						return;

						if($('body').hasClass('enk-loaded')){
							$($enkQtyInput).attr('value',d);
							//               $('#' + $enkID + ' input').change();

							//               $('.cart__submit-control').click();
						}
					}
					else if($('body').hasClass('template-product')){
						if($('body').hasClass('enk-ready')){
							if(!hasEmptyDropdown()){
								$($enkQtyInput).attr('value',d);
								//                 $('#' + $enkID + ' input').change();
							}
							else{
								$($enkQtyInput).val(1);
								//                 $('#' + $enkID + ' input').change();
							}
						}
					}
				},
			}

			$('#' + $enkID).handleCounter(options);
		});
	}

	if($('body').hasClass('template-cart')){
		buildHandleCounters();
		//     setSubmitButtons('_buildHandleCounters');
	}

});

$(document).ready(function(){

	$.each($('.section-rich-table .text-content table'),function(){
		$(this).wrapAll("<div class='responsive-table-wrap'></div>");
	});
});











$(document).ready(function(){

	if(!$('body').hasClass('template-index') && !$('body').hasClass('template-page')){
		return;
	}

	//     Shinee vimeo player
	var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;

	function getVimeoId( url ) {
		var match = /vimeo.*\/(\d+)/i.exec( url );
		if ( match ) {
			return match[1];
		}
	}

	function buildVid(elmnt){

		var vid = $('#' + elmnt);

		if(vid.length > 0){
			// has VIdeo
			var url = vid.data('video-url');
			var vid_id = getVimeoId(url);

			var vid_width = vid.parent().parent().parent().parent().width();
			var vid_height = vid.parent().parent().parent().parent().height();

			var options = {
				id: vid_id,
				width: vid_width,
				height: vid_height,
				loop: true,
				controls: false,
				autoplay: false,
				volume: 0,
				muted: true,
				autopause: true,
				background: true,
				responsive: true
			};

			if(isMobile){
				options.height = vid_height  - 42;
				vid.height(vid_height - 42);
			}
			else{
				vid.height(vid_height);
			}

			vid.parent().parent().parent().parent().height(vid_height);
			var player = new Vimeo.Player(elmnt, options);
			//       player.play();
			//       player.setVolume(0);
		}
	}

	$.each($('.malaika-video-slide'),function(){

		var id = $(this).data('block-id');

		if(isMobile) buildVid('malaika-vimeo-' + id + '-mobile');
		else buildVid('malaika-vimeo-' + id);

		$(window).resize(function () {
			waitForFinalEvent(function(){
				if(isMobile) buildVid('malaika-vimeo-' + id + '-mobile');
				else buildVid('malaika-vimeo-' + id);
			});
		});

	});

	// Homepage Feedback badges
	var $slider = $('.product-list-slider');

	var settings = {
		slidesToShow: 4,
		slidesToScroll: 1,
		draggable: true,
		arrows: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	};

	var sl =  $slider.slick(settings);
	// Homepage Feedback badges ends
});
